"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoleRevokedEvent_OrderBy = exports.RoleGrantedEvent_OrderBy = exports.RoleAdminChangedEvent_OrderBy = exports.RewardAddressChangedEvent_OrderBy = exports.ResolverEntry_OrderBy = exports.Pool_OrderBy = exports.PoolMember_OrderBy = exports.PoolDistributor_OrderBy = exports.PoolCreatedEvent_OrderBy = exports.PoolConnectionUpdatedEvent_OrderBy = exports.PppConfigurationChangedEvent_OrderBy = exports.OrderDirection = exports.NewPicEvent_OrderBy = exports.MintedEvent_OrderBy = exports.MetadataUpdateEvent_OrderBy = exports.MemberUnitsUpdatedEvent_OrderBy = exports.JailEvent_OrderBy = exports.InstantDistributionUpdatedEvent_OrderBy = exports.Index_OrderBy = exports.IndexUpdatedEvent_OrderBy = exports.IndexUnsubscribedEvent_OrderBy = exports.IndexUnitsUpdatedEvent_OrderBy = exports.IndexSubscription_OrderBy = exports.IndexSubscribedEvent_OrderBy = exports.IndexDistributionClaimedEvent_OrderBy = exports.IndexCreatedEvent_OrderBy = exports.GovernanceReplacedEvent_OrderBy = exports.FlowUpdatedEvent_OrderBy = exports.FlowOperator_OrderBy = exports.FlowOperatorUpdatedEvent_OrderBy = exports.FlowDistributionUpdatedEvent_OrderBy = exports.ExitRateChangedEvent_OrderBy = exports.Event_OrderBy = exports.DistributionClaimedEvent_OrderBy = exports.CustomSuperTokenCreatedEvent_OrderBy = exports.ConfigChangedEvent_OrderBy = exports.CfAv1LiquidationPeriodChangedEvent_OrderBy = exports.BurnedEvent_OrderBy = exports.BufferAdjustedEvent_OrderBy = exports.BondIncreasedEvent_OrderBy = exports.ApprovalForAllEvent_OrderBy = exports.ApprovalEvent_OrderBy = exports.AppRegisteredEvent_OrderBy = exports.AgreementLiquidatedV2Event_OrderBy = exports.AgreementLiquidatedByEvent_OrderBy = exports.AgreementClassUpdatedEvent_OrderBy = exports.AgreementClassRegisteredEvent_OrderBy = exports.Account_OrderBy = exports.AccountTokenSnapshot_OrderBy = exports.AccountTokenSnapshotLog_OrderBy = void 0;
exports.GetSuperFluidEvents = exports.PaymentFragment = exports.EventFragment = exports.getSdk = exports.GetSuperFluidEventsDocument = exports.PaymentFragmentFragmentDoc = exports.EventFragmentFragmentDoc = exports._SubgraphErrorPolicy_ = exports.TrustedForwarderChangedEvent_OrderBy = exports.TransferEvent_OrderBy = exports.Token_OrderBy = exports.TokenUpgradedEvent_OrderBy = exports.TokenStatistic_OrderBy = exports.TokenStatisticLog_OrderBy = exports.TokenGovernanceConfig_OrderBy = exports.TokenDowngradedEvent_OrderBy = exports.SuperTokenMinimumDepositChangedEvent_OrderBy = exports.SuperTokenLogicUpdatedEvent_OrderBy = exports.SuperTokenLogicCreatedEvent_OrderBy = exports.SuperTokenFactoryUpdatedEvent_OrderBy = exports.SuperTokenCreatedEvent_OrderBy = exports.SubscriptionUnitsUpdatedEvent_OrderBy = exports.SubscriptionRevokedEvent_OrderBy = exports.SubscriptionDistributionClaimedEvent_OrderBy = exports.SubscriptionApprovedEvent_OrderBy = exports.Stream_OrderBy = exports.StreamRevision_OrderBy = exports.StreamPeriod_OrderBy = exports.SetEvent_OrderBy = exports.SentEvent_OrderBy = exports.SfMeta_OrderBy = void 0;
const graphql_tag_1 = require("graphql-tag");
var AccountTokenSnapshotLog_OrderBy;
(function (AccountTokenSnapshotLog_OrderBy) {
    AccountTokenSnapshotLog_OrderBy["Account"] = "account";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot"] = "accountTokenSnapshot";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__activeCFAIncomingStreamCount"] = "accountTokenSnapshot__activeCFAIncomingStreamCount";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__activeCFAOutgoingStreamCount"] = "accountTokenSnapshot__activeCFAOutgoingStreamCount";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__activeGDAIncomingStreamCount"] = "accountTokenSnapshot__activeGDAIncomingStreamCount";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__activeGDAOutgoingStreamCount"] = "accountTokenSnapshot__activeGDAOutgoingStreamCount";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__activeIncomingStreamCount"] = "accountTokenSnapshot__activeIncomingStreamCount";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__activeOutgoingStreamCount"] = "accountTokenSnapshot__activeOutgoingStreamCount";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__balanceUntilUpdatedAt"] = "accountTokenSnapshot__balanceUntilUpdatedAt";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__id"] = "accountTokenSnapshot__id";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__inactiveCFAIncomingStreamCount"] = "accountTokenSnapshot__inactiveCFAIncomingStreamCount";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__inactiveCFAOutgoingStreamCount"] = "accountTokenSnapshot__inactiveCFAOutgoingStreamCount";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__inactiveGDAIncomingStreamCount"] = "accountTokenSnapshot__inactiveGDAIncomingStreamCount";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__inactiveGDAOutgoingStreamCount"] = "accountTokenSnapshot__inactiveGDAOutgoingStreamCount";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__inactiveIncomingStreamCount"] = "accountTokenSnapshot__inactiveIncomingStreamCount";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__inactiveOutgoingStreamCount"] = "accountTokenSnapshot__inactiveOutgoingStreamCount";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__isLiquidationEstimateOptimistic"] = "accountTokenSnapshot__isLiquidationEstimateOptimistic";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__maybeCriticalAtTimestamp"] = "accountTokenSnapshot__maybeCriticalAtTimestamp";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalAmountStreamedInUntilUpdatedAt"] = "accountTokenSnapshot__totalAmountStreamedInUntilUpdatedAt";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalAmountStreamedOutUntilUpdatedAt"] = "accountTokenSnapshot__totalAmountStreamedOutUntilUpdatedAt";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalAmountStreamedUntilUpdatedAt"] = "accountTokenSnapshot__totalAmountStreamedUntilUpdatedAt";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalAmountTransferredUntilUpdatedAt"] = "accountTokenSnapshot__totalAmountTransferredUntilUpdatedAt";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalApprovedSubscriptions"] = "accountTokenSnapshot__totalApprovedSubscriptions";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalCFAAmountStreamedInUntilUpdatedAt"] = "accountTokenSnapshot__totalCFAAmountStreamedInUntilUpdatedAt";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalCFAAmountStreamedOutUntilUpdatedAt"] = "accountTokenSnapshot__totalCFAAmountStreamedOutUntilUpdatedAt";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalCFAAmountStreamedUntilUpdatedAt"] = "accountTokenSnapshot__totalCFAAmountStreamedUntilUpdatedAt";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalCFADeposit"] = "accountTokenSnapshot__totalCFADeposit";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalCFAInflowRate"] = "accountTokenSnapshot__totalCFAInflowRate";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalCFANetFlowRate"] = "accountTokenSnapshot__totalCFANetFlowRate";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalCFANumberOfActiveStreams"] = "accountTokenSnapshot__totalCFANumberOfActiveStreams";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalCFANumberOfClosedStreams"] = "accountTokenSnapshot__totalCFANumberOfClosedStreams";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalCFAOutflowRate"] = "accountTokenSnapshot__totalCFAOutflowRate";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalConnectedMemberships"] = "accountTokenSnapshot__totalConnectedMemberships";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalDeposit"] = "accountTokenSnapshot__totalDeposit";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalGDAAmountStreamedInUntilUpdatedAt"] = "accountTokenSnapshot__totalGDAAmountStreamedInUntilUpdatedAt";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalGDAAmountStreamedOutUntilUpdatedAt"] = "accountTokenSnapshot__totalGDAAmountStreamedOutUntilUpdatedAt";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalGDAAmountStreamedUntilUpdatedAt"] = "accountTokenSnapshot__totalGDAAmountStreamedUntilUpdatedAt";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalGDADeposit"] = "accountTokenSnapshot__totalGDADeposit";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalGDAInflowRate"] = "accountTokenSnapshot__totalGDAInflowRate";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalGDANetFlowRate"] = "accountTokenSnapshot__totalGDANetFlowRate";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalGDANumberOfActiveStreams"] = "accountTokenSnapshot__totalGDANumberOfActiveStreams";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalGDANumberOfClosedStreams"] = "accountTokenSnapshot__totalGDANumberOfClosedStreams";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalGDAOutflowRate"] = "accountTokenSnapshot__totalGDAOutflowRate";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalInflowRate"] = "accountTokenSnapshot__totalInflowRate";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalMembershipsWithUnits"] = "accountTokenSnapshot__totalMembershipsWithUnits";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalNetFlowRate"] = "accountTokenSnapshot__totalNetFlowRate";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalNumberOfActiveStreams"] = "accountTokenSnapshot__totalNumberOfActiveStreams";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalNumberOfClosedStreams"] = "accountTokenSnapshot__totalNumberOfClosedStreams";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalOutflowRate"] = "accountTokenSnapshot__totalOutflowRate";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__totalSubscriptionsWithUnits"] = "accountTokenSnapshot__totalSubscriptionsWithUnits";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__updatedAtBlockNumber"] = "accountTokenSnapshot__updatedAtBlockNumber";
    AccountTokenSnapshotLog_OrderBy["AccountTokenSnapshot__updatedAtTimestamp"] = "accountTokenSnapshot__updatedAtTimestamp";
    AccountTokenSnapshotLog_OrderBy["Account__createdAtBlockNumber"] = "account__createdAtBlockNumber";
    AccountTokenSnapshotLog_OrderBy["Account__createdAtTimestamp"] = "account__createdAtTimestamp";
    AccountTokenSnapshotLog_OrderBy["Account__id"] = "account__id";
    AccountTokenSnapshotLog_OrderBy["Account__isSuperApp"] = "account__isSuperApp";
    AccountTokenSnapshotLog_OrderBy["Account__updatedAtBlockNumber"] = "account__updatedAtBlockNumber";
    AccountTokenSnapshotLog_OrderBy["Account__updatedAtTimestamp"] = "account__updatedAtTimestamp";
    AccountTokenSnapshotLog_OrderBy["ActiveCFAIncomingStreamCount"] = "activeCFAIncomingStreamCount";
    AccountTokenSnapshotLog_OrderBy["ActiveCFAOutgoingStreamCount"] = "activeCFAOutgoingStreamCount";
    AccountTokenSnapshotLog_OrderBy["ActiveGDAIncomingStreamCount"] = "activeGDAIncomingStreamCount";
    AccountTokenSnapshotLog_OrderBy["ActiveGDAOutgoingStreamCount"] = "activeGDAOutgoingStreamCount";
    AccountTokenSnapshotLog_OrderBy["ActiveIncomingStreamCount"] = "activeIncomingStreamCount";
    AccountTokenSnapshotLog_OrderBy["ActiveOutgoingStreamCount"] = "activeOutgoingStreamCount";
    AccountTokenSnapshotLog_OrderBy["Balance"] = "balance";
    AccountTokenSnapshotLog_OrderBy["BlockNumber"] = "blockNumber";
    AccountTokenSnapshotLog_OrderBy["Id"] = "id";
    AccountTokenSnapshotLog_OrderBy["InactiveCFAIncomingStreamCount"] = "inactiveCFAIncomingStreamCount";
    AccountTokenSnapshotLog_OrderBy["InactiveCFAOutgoingStreamCount"] = "inactiveCFAOutgoingStreamCount";
    AccountTokenSnapshotLog_OrderBy["InactiveGDAIncomingStreamCount"] = "inactiveGDAIncomingStreamCount";
    AccountTokenSnapshotLog_OrderBy["InactiveGDAOutgoingStreamCount"] = "inactiveGDAOutgoingStreamCount";
    AccountTokenSnapshotLog_OrderBy["InactiveIncomingStreamCount"] = "inactiveIncomingStreamCount";
    AccountTokenSnapshotLog_OrderBy["InactiveOutgoingStreamCount"] = "inactiveOutgoingStreamCount";
    AccountTokenSnapshotLog_OrderBy["LogIndex"] = "logIndex";
    AccountTokenSnapshotLog_OrderBy["MaybeCriticalAtTimestamp"] = "maybeCriticalAtTimestamp";
    AccountTokenSnapshotLog_OrderBy["Order"] = "order";
    AccountTokenSnapshotLog_OrderBy["Timestamp"] = "timestamp";
    AccountTokenSnapshotLog_OrderBy["Token"] = "token";
    AccountTokenSnapshotLog_OrderBy["Token__createdAtBlockNumber"] = "token__createdAtBlockNumber";
    AccountTokenSnapshotLog_OrderBy["Token__createdAtTimestamp"] = "token__createdAtTimestamp";
    AccountTokenSnapshotLog_OrderBy["Token__decimals"] = "token__decimals";
    AccountTokenSnapshotLog_OrderBy["Token__id"] = "token__id";
    AccountTokenSnapshotLog_OrderBy["Token__isListed"] = "token__isListed";
    AccountTokenSnapshotLog_OrderBy["Token__isNativeAssetSuperToken"] = "token__isNativeAssetSuperToken";
    AccountTokenSnapshotLog_OrderBy["Token__isSuperToken"] = "token__isSuperToken";
    AccountTokenSnapshotLog_OrderBy["Token__name"] = "token__name";
    AccountTokenSnapshotLog_OrderBy["Token__symbol"] = "token__symbol";
    AccountTokenSnapshotLog_OrderBy["Token__underlyingAddress"] = "token__underlyingAddress";
    AccountTokenSnapshotLog_OrderBy["TotalAmountStreamed"] = "totalAmountStreamed";
    AccountTokenSnapshotLog_OrderBy["TotalAmountStreamedIn"] = "totalAmountStreamedIn";
    AccountTokenSnapshotLog_OrderBy["TotalAmountStreamedOut"] = "totalAmountStreamedOut";
    AccountTokenSnapshotLog_OrderBy["TotalAmountTransferred"] = "totalAmountTransferred";
    AccountTokenSnapshotLog_OrderBy["TotalApprovedSubscriptions"] = "totalApprovedSubscriptions";
    AccountTokenSnapshotLog_OrderBy["TotalCFAAmountStreamed"] = "totalCFAAmountStreamed";
    AccountTokenSnapshotLog_OrderBy["TotalCFAAmountStreamedIn"] = "totalCFAAmountStreamedIn";
    AccountTokenSnapshotLog_OrderBy["TotalCFAAmountStreamedOut"] = "totalCFAAmountStreamedOut";
    AccountTokenSnapshotLog_OrderBy["TotalCFADeposit"] = "totalCFADeposit";
    AccountTokenSnapshotLog_OrderBy["TotalCFAInflowRate"] = "totalCFAInflowRate";
    AccountTokenSnapshotLog_OrderBy["TotalCFANetFlowRate"] = "totalCFANetFlowRate";
    AccountTokenSnapshotLog_OrderBy["TotalCFANumberOfActiveStreams"] = "totalCFANumberOfActiveStreams";
    AccountTokenSnapshotLog_OrderBy["TotalCFANumberOfClosedStreams"] = "totalCFANumberOfClosedStreams";
    AccountTokenSnapshotLog_OrderBy["TotalCFAOutflowRate"] = "totalCFAOutflowRate";
    AccountTokenSnapshotLog_OrderBy["TotalConnectedMemberships"] = "totalConnectedMemberships";
    AccountTokenSnapshotLog_OrderBy["TotalDeposit"] = "totalDeposit";
    AccountTokenSnapshotLog_OrderBy["TotalGDAAmountStreamed"] = "totalGDAAmountStreamed";
    AccountTokenSnapshotLog_OrderBy["TotalGDAAmountStreamedIn"] = "totalGDAAmountStreamedIn";
    AccountTokenSnapshotLog_OrderBy["TotalGDAAmountStreamedOut"] = "totalGDAAmountStreamedOut";
    AccountTokenSnapshotLog_OrderBy["TotalGDADeposit"] = "totalGDADeposit";
    AccountTokenSnapshotLog_OrderBy["TotalGDAInflowRate"] = "totalGDAInflowRate";
    AccountTokenSnapshotLog_OrderBy["TotalGDANetFlowRate"] = "totalGDANetFlowRate";
    AccountTokenSnapshotLog_OrderBy["TotalGDANumberOfActiveStreams"] = "totalGDANumberOfActiveStreams";
    AccountTokenSnapshotLog_OrderBy["TotalGDANumberOfClosedStreams"] = "totalGDANumberOfClosedStreams";
    AccountTokenSnapshotLog_OrderBy["TotalGDAOutflowRate"] = "totalGDAOutflowRate";
    AccountTokenSnapshotLog_OrderBy["TotalInflowRate"] = "totalInflowRate";
    AccountTokenSnapshotLog_OrderBy["TotalMembershipsWithUnits"] = "totalMembershipsWithUnits";
    AccountTokenSnapshotLog_OrderBy["TotalNetFlowRate"] = "totalNetFlowRate";
    AccountTokenSnapshotLog_OrderBy["TotalNumberOfActiveStreams"] = "totalNumberOfActiveStreams";
    AccountTokenSnapshotLog_OrderBy["TotalNumberOfClosedStreams"] = "totalNumberOfClosedStreams";
    AccountTokenSnapshotLog_OrderBy["TotalOutflowRate"] = "totalOutflowRate";
    AccountTokenSnapshotLog_OrderBy["TotalSubscriptionsWithUnits"] = "totalSubscriptionsWithUnits";
    AccountTokenSnapshotLog_OrderBy["TransactionHash"] = "transactionHash";
    AccountTokenSnapshotLog_OrderBy["TriggeredByEventName"] = "triggeredByEventName";
})(AccountTokenSnapshotLog_OrderBy || (exports.AccountTokenSnapshotLog_OrderBy = AccountTokenSnapshotLog_OrderBy = {}));
var AccountTokenSnapshot_OrderBy;
(function (AccountTokenSnapshot_OrderBy) {
    AccountTokenSnapshot_OrderBy["Account"] = "account";
    AccountTokenSnapshot_OrderBy["AccountTokenSnapshotLogs"] = "accountTokenSnapshotLogs";
    AccountTokenSnapshot_OrderBy["Account__createdAtBlockNumber"] = "account__createdAtBlockNumber";
    AccountTokenSnapshot_OrderBy["Account__createdAtTimestamp"] = "account__createdAtTimestamp";
    AccountTokenSnapshot_OrderBy["Account__id"] = "account__id";
    AccountTokenSnapshot_OrderBy["Account__isSuperApp"] = "account__isSuperApp";
    AccountTokenSnapshot_OrderBy["Account__updatedAtBlockNumber"] = "account__updatedAtBlockNumber";
    AccountTokenSnapshot_OrderBy["Account__updatedAtTimestamp"] = "account__updatedAtTimestamp";
    AccountTokenSnapshot_OrderBy["ActiveCFAIncomingStreamCount"] = "activeCFAIncomingStreamCount";
    AccountTokenSnapshot_OrderBy["ActiveCFAOutgoingStreamCount"] = "activeCFAOutgoingStreamCount";
    AccountTokenSnapshot_OrderBy["ActiveGDAIncomingStreamCount"] = "activeGDAIncomingStreamCount";
    AccountTokenSnapshot_OrderBy["ActiveGDAOutgoingStreamCount"] = "activeGDAOutgoingStreamCount";
    AccountTokenSnapshot_OrderBy["ActiveIncomingStreamCount"] = "activeIncomingStreamCount";
    AccountTokenSnapshot_OrderBy["ActiveOutgoingStreamCount"] = "activeOutgoingStreamCount";
    AccountTokenSnapshot_OrderBy["BalanceUntilUpdatedAt"] = "balanceUntilUpdatedAt";
    AccountTokenSnapshot_OrderBy["FlowOperators"] = "flowOperators";
    AccountTokenSnapshot_OrderBy["Id"] = "id";
    AccountTokenSnapshot_OrderBy["InactiveCFAIncomingStreamCount"] = "inactiveCFAIncomingStreamCount";
    AccountTokenSnapshot_OrderBy["InactiveCFAOutgoingStreamCount"] = "inactiveCFAOutgoingStreamCount";
    AccountTokenSnapshot_OrderBy["InactiveGDAIncomingStreamCount"] = "inactiveGDAIncomingStreamCount";
    AccountTokenSnapshot_OrderBy["InactiveGDAOutgoingStreamCount"] = "inactiveGDAOutgoingStreamCount";
    AccountTokenSnapshot_OrderBy["InactiveIncomingStreamCount"] = "inactiveIncomingStreamCount";
    AccountTokenSnapshot_OrderBy["InactiveOutgoingStreamCount"] = "inactiveOutgoingStreamCount";
    AccountTokenSnapshot_OrderBy["IsLiquidationEstimateOptimistic"] = "isLiquidationEstimateOptimistic";
    AccountTokenSnapshot_OrderBy["MaybeCriticalAtTimestamp"] = "maybeCriticalAtTimestamp";
    AccountTokenSnapshot_OrderBy["Token"] = "token";
    AccountTokenSnapshot_OrderBy["Token__createdAtBlockNumber"] = "token__createdAtBlockNumber";
    AccountTokenSnapshot_OrderBy["Token__createdAtTimestamp"] = "token__createdAtTimestamp";
    AccountTokenSnapshot_OrderBy["Token__decimals"] = "token__decimals";
    AccountTokenSnapshot_OrderBy["Token__id"] = "token__id";
    AccountTokenSnapshot_OrderBy["Token__isListed"] = "token__isListed";
    AccountTokenSnapshot_OrderBy["Token__isNativeAssetSuperToken"] = "token__isNativeAssetSuperToken";
    AccountTokenSnapshot_OrderBy["Token__isSuperToken"] = "token__isSuperToken";
    AccountTokenSnapshot_OrderBy["Token__name"] = "token__name";
    AccountTokenSnapshot_OrderBy["Token__symbol"] = "token__symbol";
    AccountTokenSnapshot_OrderBy["Token__underlyingAddress"] = "token__underlyingAddress";
    AccountTokenSnapshot_OrderBy["TotalAmountStreamedInUntilUpdatedAt"] = "totalAmountStreamedInUntilUpdatedAt";
    AccountTokenSnapshot_OrderBy["TotalAmountStreamedOutUntilUpdatedAt"] = "totalAmountStreamedOutUntilUpdatedAt";
    AccountTokenSnapshot_OrderBy["TotalAmountStreamedUntilUpdatedAt"] = "totalAmountStreamedUntilUpdatedAt";
    AccountTokenSnapshot_OrderBy["TotalAmountTransferredUntilUpdatedAt"] = "totalAmountTransferredUntilUpdatedAt";
    AccountTokenSnapshot_OrderBy["TotalApprovedSubscriptions"] = "totalApprovedSubscriptions";
    AccountTokenSnapshot_OrderBy["TotalCFAAmountStreamedInUntilUpdatedAt"] = "totalCFAAmountStreamedInUntilUpdatedAt";
    AccountTokenSnapshot_OrderBy["TotalCFAAmountStreamedOutUntilUpdatedAt"] = "totalCFAAmountStreamedOutUntilUpdatedAt";
    AccountTokenSnapshot_OrderBy["TotalCFAAmountStreamedUntilUpdatedAt"] = "totalCFAAmountStreamedUntilUpdatedAt";
    AccountTokenSnapshot_OrderBy["TotalCFADeposit"] = "totalCFADeposit";
    AccountTokenSnapshot_OrderBy["TotalCFAInflowRate"] = "totalCFAInflowRate";
    AccountTokenSnapshot_OrderBy["TotalCFANetFlowRate"] = "totalCFANetFlowRate";
    AccountTokenSnapshot_OrderBy["TotalCFANumberOfActiveStreams"] = "totalCFANumberOfActiveStreams";
    AccountTokenSnapshot_OrderBy["TotalCFANumberOfClosedStreams"] = "totalCFANumberOfClosedStreams";
    AccountTokenSnapshot_OrderBy["TotalCFAOutflowRate"] = "totalCFAOutflowRate";
    AccountTokenSnapshot_OrderBy["TotalConnectedMemberships"] = "totalConnectedMemberships";
    AccountTokenSnapshot_OrderBy["TotalDeposit"] = "totalDeposit";
    AccountTokenSnapshot_OrderBy["TotalGDAAmountStreamedInUntilUpdatedAt"] = "totalGDAAmountStreamedInUntilUpdatedAt";
    AccountTokenSnapshot_OrderBy["TotalGDAAmountStreamedOutUntilUpdatedAt"] = "totalGDAAmountStreamedOutUntilUpdatedAt";
    AccountTokenSnapshot_OrderBy["TotalGDAAmountStreamedUntilUpdatedAt"] = "totalGDAAmountStreamedUntilUpdatedAt";
    AccountTokenSnapshot_OrderBy["TotalGDADeposit"] = "totalGDADeposit";
    AccountTokenSnapshot_OrderBy["TotalGDAInflowRate"] = "totalGDAInflowRate";
    AccountTokenSnapshot_OrderBy["TotalGDANetFlowRate"] = "totalGDANetFlowRate";
    AccountTokenSnapshot_OrderBy["TotalGDANumberOfActiveStreams"] = "totalGDANumberOfActiveStreams";
    AccountTokenSnapshot_OrderBy["TotalGDANumberOfClosedStreams"] = "totalGDANumberOfClosedStreams";
    AccountTokenSnapshot_OrderBy["TotalGDAOutflowRate"] = "totalGDAOutflowRate";
    AccountTokenSnapshot_OrderBy["TotalInflowRate"] = "totalInflowRate";
    AccountTokenSnapshot_OrderBy["TotalMembershipsWithUnits"] = "totalMembershipsWithUnits";
    AccountTokenSnapshot_OrderBy["TotalNetFlowRate"] = "totalNetFlowRate";
    AccountTokenSnapshot_OrderBy["TotalNumberOfActiveStreams"] = "totalNumberOfActiveStreams";
    AccountTokenSnapshot_OrderBy["TotalNumberOfClosedStreams"] = "totalNumberOfClosedStreams";
    AccountTokenSnapshot_OrderBy["TotalOutflowRate"] = "totalOutflowRate";
    AccountTokenSnapshot_OrderBy["TotalSubscriptionsWithUnits"] = "totalSubscriptionsWithUnits";
    AccountTokenSnapshot_OrderBy["UpdatedAtBlockNumber"] = "updatedAtBlockNumber";
    AccountTokenSnapshot_OrderBy["UpdatedAtTimestamp"] = "updatedAtTimestamp";
})(AccountTokenSnapshot_OrderBy || (exports.AccountTokenSnapshot_OrderBy = AccountTokenSnapshot_OrderBy = {}));
var Account_OrderBy;
(function (Account_OrderBy) {
    Account_OrderBy["AccountTokenSnapshots"] = "accountTokenSnapshots";
    Account_OrderBy["CreatedAtBlockNumber"] = "createdAtBlockNumber";
    Account_OrderBy["CreatedAtTimestamp"] = "createdAtTimestamp";
    Account_OrderBy["Id"] = "id";
    Account_OrderBy["Inflows"] = "inflows";
    Account_OrderBy["IsSuperApp"] = "isSuperApp";
    Account_OrderBy["Outflows"] = "outflows";
    Account_OrderBy["PoolMemberships"] = "poolMemberships";
    Account_OrderBy["Pools"] = "pools";
    Account_OrderBy["PublishedIndexes"] = "publishedIndexes";
    Account_OrderBy["ReceivedTransferEvents"] = "receivedTransferEvents";
    Account_OrderBy["SentTransferEvents"] = "sentTransferEvents";
    Account_OrderBy["Subscriptions"] = "subscriptions";
    Account_OrderBy["TokenDowngradedEvents"] = "tokenDowngradedEvents";
    Account_OrderBy["TokenUpgradedEvents"] = "tokenUpgradedEvents";
    Account_OrderBy["UpdatedAtBlockNumber"] = "updatedAtBlockNumber";
    Account_OrderBy["UpdatedAtTimestamp"] = "updatedAtTimestamp";
})(Account_OrderBy || (exports.Account_OrderBy = Account_OrderBy = {}));
var AgreementClassRegisteredEvent_OrderBy;
(function (AgreementClassRegisteredEvent_OrderBy) {
    AgreementClassRegisteredEvent_OrderBy["Addresses"] = "addresses";
    AgreementClassRegisteredEvent_OrderBy["AgreementType"] = "agreementType";
    AgreementClassRegisteredEvent_OrderBy["BlockNumber"] = "blockNumber";
    AgreementClassRegisteredEvent_OrderBy["Code"] = "code";
    AgreementClassRegisteredEvent_OrderBy["GasPrice"] = "gasPrice";
    AgreementClassRegisteredEvent_OrderBy["GasUsed"] = "gasUsed";
    AgreementClassRegisteredEvent_OrderBy["Id"] = "id";
    AgreementClassRegisteredEvent_OrderBy["LogIndex"] = "logIndex";
    AgreementClassRegisteredEvent_OrderBy["Name"] = "name";
    AgreementClassRegisteredEvent_OrderBy["Order"] = "order";
    AgreementClassRegisteredEvent_OrderBy["Timestamp"] = "timestamp";
    AgreementClassRegisteredEvent_OrderBy["TransactionHash"] = "transactionHash";
})(AgreementClassRegisteredEvent_OrderBy || (exports.AgreementClassRegisteredEvent_OrderBy = AgreementClassRegisteredEvent_OrderBy = {}));
var AgreementClassUpdatedEvent_OrderBy;
(function (AgreementClassUpdatedEvent_OrderBy) {
    AgreementClassUpdatedEvent_OrderBy["Addresses"] = "addresses";
    AgreementClassUpdatedEvent_OrderBy["AgreementType"] = "agreementType";
    AgreementClassUpdatedEvent_OrderBy["BlockNumber"] = "blockNumber";
    AgreementClassUpdatedEvent_OrderBy["Code"] = "code";
    AgreementClassUpdatedEvent_OrderBy["GasPrice"] = "gasPrice";
    AgreementClassUpdatedEvent_OrderBy["GasUsed"] = "gasUsed";
    AgreementClassUpdatedEvent_OrderBy["Id"] = "id";
    AgreementClassUpdatedEvent_OrderBy["LogIndex"] = "logIndex";
    AgreementClassUpdatedEvent_OrderBy["Name"] = "name";
    AgreementClassUpdatedEvent_OrderBy["Order"] = "order";
    AgreementClassUpdatedEvent_OrderBy["Timestamp"] = "timestamp";
    AgreementClassUpdatedEvent_OrderBy["TransactionHash"] = "transactionHash";
})(AgreementClassUpdatedEvent_OrderBy || (exports.AgreementClassUpdatedEvent_OrderBy = AgreementClassUpdatedEvent_OrderBy = {}));
var AgreementLiquidatedByEvent_OrderBy;
(function (AgreementLiquidatedByEvent_OrderBy) {
    AgreementLiquidatedByEvent_OrderBy["Addresses"] = "addresses";
    AgreementLiquidatedByEvent_OrderBy["AgreementClass"] = "agreementClass";
    AgreementLiquidatedByEvent_OrderBy["AgreementId"] = "agreementId";
    AgreementLiquidatedByEvent_OrderBy["BailoutAmount"] = "bailoutAmount";
    AgreementLiquidatedByEvent_OrderBy["BlockNumber"] = "blockNumber";
    AgreementLiquidatedByEvent_OrderBy["BondAccount"] = "bondAccount";
    AgreementLiquidatedByEvent_OrderBy["Deposit"] = "deposit";
    AgreementLiquidatedByEvent_OrderBy["FlowRateAtLiquidation"] = "flowRateAtLiquidation";
    AgreementLiquidatedByEvent_OrderBy["GasPrice"] = "gasPrice";
    AgreementLiquidatedByEvent_OrderBy["GasUsed"] = "gasUsed";
    AgreementLiquidatedByEvent_OrderBy["Id"] = "id";
    AgreementLiquidatedByEvent_OrderBy["LiquidatorAccount"] = "liquidatorAccount";
    AgreementLiquidatedByEvent_OrderBy["LogIndex"] = "logIndex";
    AgreementLiquidatedByEvent_OrderBy["Name"] = "name";
    AgreementLiquidatedByEvent_OrderBy["Order"] = "order";
    AgreementLiquidatedByEvent_OrderBy["PenaltyAccount"] = "penaltyAccount";
    AgreementLiquidatedByEvent_OrderBy["RewardAmount"] = "rewardAmount";
    AgreementLiquidatedByEvent_OrderBy["Timestamp"] = "timestamp";
    AgreementLiquidatedByEvent_OrderBy["Token"] = "token";
    AgreementLiquidatedByEvent_OrderBy["TransactionHash"] = "transactionHash";
})(AgreementLiquidatedByEvent_OrderBy || (exports.AgreementLiquidatedByEvent_OrderBy = AgreementLiquidatedByEvent_OrderBy = {}));
var AgreementLiquidatedV2Event_OrderBy;
(function (AgreementLiquidatedV2Event_OrderBy) {
    AgreementLiquidatedV2Event_OrderBy["Addresses"] = "addresses";
    AgreementLiquidatedV2Event_OrderBy["AgreementClass"] = "agreementClass";
    AgreementLiquidatedV2Event_OrderBy["AgreementId"] = "agreementId";
    AgreementLiquidatedV2Event_OrderBy["BlockNumber"] = "blockNumber";
    AgreementLiquidatedV2Event_OrderBy["Deposit"] = "deposit";
    AgreementLiquidatedV2Event_OrderBy["FlowRateAtLiquidation"] = "flowRateAtLiquidation";
    AgreementLiquidatedV2Event_OrderBy["GasPrice"] = "gasPrice";
    AgreementLiquidatedV2Event_OrderBy["GasUsed"] = "gasUsed";
    AgreementLiquidatedV2Event_OrderBy["Id"] = "id";
    AgreementLiquidatedV2Event_OrderBy["LiquidationType"] = "liquidationType";
    AgreementLiquidatedV2Event_OrderBy["LiquidatorAccount"] = "liquidatorAccount";
    AgreementLiquidatedV2Event_OrderBy["LogIndex"] = "logIndex";
    AgreementLiquidatedV2Event_OrderBy["Name"] = "name";
    AgreementLiquidatedV2Event_OrderBy["Order"] = "order";
    AgreementLiquidatedV2Event_OrderBy["RewardAccount"] = "rewardAccount";
    AgreementLiquidatedV2Event_OrderBy["RewardAmount"] = "rewardAmount";
    AgreementLiquidatedV2Event_OrderBy["RewardAmountReceiver"] = "rewardAmountReceiver";
    AgreementLiquidatedV2Event_OrderBy["TargetAccount"] = "targetAccount";
    AgreementLiquidatedV2Event_OrderBy["TargetAccountBalanceDelta"] = "targetAccountBalanceDelta";
    AgreementLiquidatedV2Event_OrderBy["Timestamp"] = "timestamp";
    AgreementLiquidatedV2Event_OrderBy["Token"] = "token";
    AgreementLiquidatedV2Event_OrderBy["TransactionHash"] = "transactionHash";
    AgreementLiquidatedV2Event_OrderBy["Version"] = "version";
})(AgreementLiquidatedV2Event_OrderBy || (exports.AgreementLiquidatedV2Event_OrderBy = AgreementLiquidatedV2Event_OrderBy = {}));
var AppRegisteredEvent_OrderBy;
(function (AppRegisteredEvent_OrderBy) {
    AppRegisteredEvent_OrderBy["Addresses"] = "addresses";
    AppRegisteredEvent_OrderBy["App"] = "app";
    AppRegisteredEvent_OrderBy["BlockNumber"] = "blockNumber";
    AppRegisteredEvent_OrderBy["GasPrice"] = "gasPrice";
    AppRegisteredEvent_OrderBy["GasUsed"] = "gasUsed";
    AppRegisteredEvent_OrderBy["Id"] = "id";
    AppRegisteredEvent_OrderBy["LogIndex"] = "logIndex";
    AppRegisteredEvent_OrderBy["Name"] = "name";
    AppRegisteredEvent_OrderBy["Order"] = "order";
    AppRegisteredEvent_OrderBy["Timestamp"] = "timestamp";
    AppRegisteredEvent_OrderBy["TransactionHash"] = "transactionHash";
})(AppRegisteredEvent_OrderBy || (exports.AppRegisteredEvent_OrderBy = AppRegisteredEvent_OrderBy = {}));
var ApprovalEvent_OrderBy;
(function (ApprovalEvent_OrderBy) {
    ApprovalEvent_OrderBy["Addresses"] = "addresses";
    ApprovalEvent_OrderBy["BlockNumber"] = "blockNumber";
    ApprovalEvent_OrderBy["GasPrice"] = "gasPrice";
    ApprovalEvent_OrderBy["GasUsed"] = "gasUsed";
    ApprovalEvent_OrderBy["Id"] = "id";
    ApprovalEvent_OrderBy["LogIndex"] = "logIndex";
    ApprovalEvent_OrderBy["Name"] = "name";
    ApprovalEvent_OrderBy["Order"] = "order";
    ApprovalEvent_OrderBy["Owner"] = "owner";
    ApprovalEvent_OrderBy["Owner__createdAtBlockNumber"] = "owner__createdAtBlockNumber";
    ApprovalEvent_OrderBy["Owner__createdAtTimestamp"] = "owner__createdAtTimestamp";
    ApprovalEvent_OrderBy["Owner__id"] = "owner__id";
    ApprovalEvent_OrderBy["Owner__isSuperApp"] = "owner__isSuperApp";
    ApprovalEvent_OrderBy["Owner__updatedAtBlockNumber"] = "owner__updatedAtBlockNumber";
    ApprovalEvent_OrderBy["Owner__updatedAtTimestamp"] = "owner__updatedAtTimestamp";
    ApprovalEvent_OrderBy["Timestamp"] = "timestamp";
    ApprovalEvent_OrderBy["To"] = "to";
    ApprovalEvent_OrderBy["To__createdAtBlockNumber"] = "to__createdAtBlockNumber";
    ApprovalEvent_OrderBy["To__createdAtTimestamp"] = "to__createdAtTimestamp";
    ApprovalEvent_OrderBy["To__id"] = "to__id";
    ApprovalEvent_OrderBy["To__isSuperApp"] = "to__isSuperApp";
    ApprovalEvent_OrderBy["To__updatedAtBlockNumber"] = "to__updatedAtBlockNumber";
    ApprovalEvent_OrderBy["To__updatedAtTimestamp"] = "to__updatedAtTimestamp";
    ApprovalEvent_OrderBy["TokenId"] = "tokenId";
    ApprovalEvent_OrderBy["TransactionHash"] = "transactionHash";
})(ApprovalEvent_OrderBy || (exports.ApprovalEvent_OrderBy = ApprovalEvent_OrderBy = {}));
var ApprovalForAllEvent_OrderBy;
(function (ApprovalForAllEvent_OrderBy) {
    ApprovalForAllEvent_OrderBy["Addresses"] = "addresses";
    ApprovalForAllEvent_OrderBy["Approved"] = "approved";
    ApprovalForAllEvent_OrderBy["BlockNumber"] = "blockNumber";
    ApprovalForAllEvent_OrderBy["GasPrice"] = "gasPrice";
    ApprovalForAllEvent_OrderBy["GasUsed"] = "gasUsed";
    ApprovalForAllEvent_OrderBy["Id"] = "id";
    ApprovalForAllEvent_OrderBy["LogIndex"] = "logIndex";
    ApprovalForAllEvent_OrderBy["Name"] = "name";
    ApprovalForAllEvent_OrderBy["Operator"] = "operator";
    ApprovalForAllEvent_OrderBy["Operator__createdAtBlockNumber"] = "operator__createdAtBlockNumber";
    ApprovalForAllEvent_OrderBy["Operator__createdAtTimestamp"] = "operator__createdAtTimestamp";
    ApprovalForAllEvent_OrderBy["Operator__id"] = "operator__id";
    ApprovalForAllEvent_OrderBy["Operator__isSuperApp"] = "operator__isSuperApp";
    ApprovalForAllEvent_OrderBy["Operator__updatedAtBlockNumber"] = "operator__updatedAtBlockNumber";
    ApprovalForAllEvent_OrderBy["Operator__updatedAtTimestamp"] = "operator__updatedAtTimestamp";
    ApprovalForAllEvent_OrderBy["Order"] = "order";
    ApprovalForAllEvent_OrderBy["Owner"] = "owner";
    ApprovalForAllEvent_OrderBy["Owner__createdAtBlockNumber"] = "owner__createdAtBlockNumber";
    ApprovalForAllEvent_OrderBy["Owner__createdAtTimestamp"] = "owner__createdAtTimestamp";
    ApprovalForAllEvent_OrderBy["Owner__id"] = "owner__id";
    ApprovalForAllEvent_OrderBy["Owner__isSuperApp"] = "owner__isSuperApp";
    ApprovalForAllEvent_OrderBy["Owner__updatedAtBlockNumber"] = "owner__updatedAtBlockNumber";
    ApprovalForAllEvent_OrderBy["Owner__updatedAtTimestamp"] = "owner__updatedAtTimestamp";
    ApprovalForAllEvent_OrderBy["Timestamp"] = "timestamp";
    ApprovalForAllEvent_OrderBy["TransactionHash"] = "transactionHash";
})(ApprovalForAllEvent_OrderBy || (exports.ApprovalForAllEvent_OrderBy = ApprovalForAllEvent_OrderBy = {}));
var BondIncreasedEvent_OrderBy;
(function (BondIncreasedEvent_OrderBy) {
    BondIncreasedEvent_OrderBy["AdditionalBond"] = "additionalBond";
    BondIncreasedEvent_OrderBy["Addresses"] = "addresses";
    BondIncreasedEvent_OrderBy["BlockNumber"] = "blockNumber";
    BondIncreasedEvent_OrderBy["GasPrice"] = "gasPrice";
    BondIncreasedEvent_OrderBy["GasUsed"] = "gasUsed";
    BondIncreasedEvent_OrderBy["Id"] = "id";
    BondIncreasedEvent_OrderBy["LogIndex"] = "logIndex";
    BondIncreasedEvent_OrderBy["Name"] = "name";
    BondIncreasedEvent_OrderBy["Order"] = "order";
    BondIncreasedEvent_OrderBy["Timestamp"] = "timestamp";
    BondIncreasedEvent_OrderBy["Token"] = "token";
    BondIncreasedEvent_OrderBy["TransactionHash"] = "transactionHash";
})(BondIncreasedEvent_OrderBy || (exports.BondIncreasedEvent_OrderBy = BondIncreasedEvent_OrderBy = {}));
var BufferAdjustedEvent_OrderBy;
(function (BufferAdjustedEvent_OrderBy) {
    BufferAdjustedEvent_OrderBy["Addresses"] = "addresses";
    BufferAdjustedEvent_OrderBy["BlockNumber"] = "blockNumber";
    BufferAdjustedEvent_OrderBy["BufferDelta"] = "bufferDelta";
    BufferAdjustedEvent_OrderBy["GasPrice"] = "gasPrice";
    BufferAdjustedEvent_OrderBy["GasUsed"] = "gasUsed";
    BufferAdjustedEvent_OrderBy["Id"] = "id";
    BufferAdjustedEvent_OrderBy["LogIndex"] = "logIndex";
    BufferAdjustedEvent_OrderBy["Name"] = "name";
    BufferAdjustedEvent_OrderBy["NewBufferAmount"] = "newBufferAmount";
    BufferAdjustedEvent_OrderBy["Order"] = "order";
    BufferAdjustedEvent_OrderBy["Pool"] = "pool";
    BufferAdjustedEvent_OrderBy["PoolDistributor"] = "poolDistributor";
    BufferAdjustedEvent_OrderBy["PoolDistributor__createdAtBlockNumber"] = "poolDistributor__createdAtBlockNumber";
    BufferAdjustedEvent_OrderBy["PoolDistributor__createdAtTimestamp"] = "poolDistributor__createdAtTimestamp";
    BufferAdjustedEvent_OrderBy["PoolDistributor__flowRate"] = "poolDistributor__flowRate";
    BufferAdjustedEvent_OrderBy["PoolDistributor__id"] = "poolDistributor__id";
    BufferAdjustedEvent_OrderBy["PoolDistributor__totalAmountDistributedUntilUpdatedAt"] = "poolDistributor__totalAmountDistributedUntilUpdatedAt";
    BufferAdjustedEvent_OrderBy["PoolDistributor__totalAmountFlowedDistributedUntilUpdatedAt"] = "poolDistributor__totalAmountFlowedDistributedUntilUpdatedAt";
    BufferAdjustedEvent_OrderBy["PoolDistributor__totalAmountInstantlyDistributedUntilUpdatedAt"] = "poolDistributor__totalAmountInstantlyDistributedUntilUpdatedAt";
    BufferAdjustedEvent_OrderBy["PoolDistributor__totalBuffer"] = "poolDistributor__totalBuffer";
    BufferAdjustedEvent_OrderBy["PoolDistributor__updatedAtBlockNumber"] = "poolDistributor__updatedAtBlockNumber";
    BufferAdjustedEvent_OrderBy["PoolDistributor__updatedAtTimestamp"] = "poolDistributor__updatedAtTimestamp";
    BufferAdjustedEvent_OrderBy["Pool__adjustmentFlowRate"] = "pool__adjustmentFlowRate";
    BufferAdjustedEvent_OrderBy["Pool__createdAtBlockNumber"] = "pool__createdAtBlockNumber";
    BufferAdjustedEvent_OrderBy["Pool__createdAtTimestamp"] = "pool__createdAtTimestamp";
    BufferAdjustedEvent_OrderBy["Pool__flowRate"] = "pool__flowRate";
    BufferAdjustedEvent_OrderBy["Pool__id"] = "pool__id";
    BufferAdjustedEvent_OrderBy["Pool__totalAmountDistributedUntilUpdatedAt"] = "pool__totalAmountDistributedUntilUpdatedAt";
    BufferAdjustedEvent_OrderBy["Pool__totalAmountFlowedDistributedUntilUpdatedAt"] = "pool__totalAmountFlowedDistributedUntilUpdatedAt";
    BufferAdjustedEvent_OrderBy["Pool__totalAmountInstantlyDistributedUntilUpdatedAt"] = "pool__totalAmountInstantlyDistributedUntilUpdatedAt";
    BufferAdjustedEvent_OrderBy["Pool__totalBuffer"] = "pool__totalBuffer";
    BufferAdjustedEvent_OrderBy["Pool__totalConnectedMembers"] = "pool__totalConnectedMembers";
    BufferAdjustedEvent_OrderBy["Pool__totalConnectedUnits"] = "pool__totalConnectedUnits";
    BufferAdjustedEvent_OrderBy["Pool__totalDisconnectedMembers"] = "pool__totalDisconnectedMembers";
    BufferAdjustedEvent_OrderBy["Pool__totalDisconnectedUnits"] = "pool__totalDisconnectedUnits";
    BufferAdjustedEvent_OrderBy["Pool__totalMembers"] = "pool__totalMembers";
    BufferAdjustedEvent_OrderBy["Pool__totalUnits"] = "pool__totalUnits";
    BufferAdjustedEvent_OrderBy["Pool__updatedAtBlockNumber"] = "pool__updatedAtBlockNumber";
    BufferAdjustedEvent_OrderBy["Pool__updatedAtTimestamp"] = "pool__updatedAtTimestamp";
    BufferAdjustedEvent_OrderBy["Timestamp"] = "timestamp";
    BufferAdjustedEvent_OrderBy["Token"] = "token";
    BufferAdjustedEvent_OrderBy["TotalBufferAmount"] = "totalBufferAmount";
    BufferAdjustedEvent_OrderBy["TransactionHash"] = "transactionHash";
})(BufferAdjustedEvent_OrderBy || (exports.BufferAdjustedEvent_OrderBy = BufferAdjustedEvent_OrderBy = {}));
var BurnedEvent_OrderBy;
(function (BurnedEvent_OrderBy) {
    BurnedEvent_OrderBy["Addresses"] = "addresses";
    BurnedEvent_OrderBy["Amount"] = "amount";
    BurnedEvent_OrderBy["BlockNumber"] = "blockNumber";
    BurnedEvent_OrderBy["Data"] = "data";
    BurnedEvent_OrderBy["From"] = "from";
    BurnedEvent_OrderBy["GasPrice"] = "gasPrice";
    BurnedEvent_OrderBy["GasUsed"] = "gasUsed";
    BurnedEvent_OrderBy["Id"] = "id";
    BurnedEvent_OrderBy["LogIndex"] = "logIndex";
    BurnedEvent_OrderBy["Name"] = "name";
    BurnedEvent_OrderBy["Operator"] = "operator";
    BurnedEvent_OrderBy["OperatorData"] = "operatorData";
    BurnedEvent_OrderBy["Order"] = "order";
    BurnedEvent_OrderBy["Timestamp"] = "timestamp";
    BurnedEvent_OrderBy["Token"] = "token";
    BurnedEvent_OrderBy["TransactionHash"] = "transactionHash";
})(BurnedEvent_OrderBy || (exports.BurnedEvent_OrderBy = BurnedEvent_OrderBy = {}));
var CfAv1LiquidationPeriodChangedEvent_OrderBy;
(function (CfAv1LiquidationPeriodChangedEvent_OrderBy) {
    CfAv1LiquidationPeriodChangedEvent_OrderBy["Addresses"] = "addresses";
    CfAv1LiquidationPeriodChangedEvent_OrderBy["BlockNumber"] = "blockNumber";
    CfAv1LiquidationPeriodChangedEvent_OrderBy["GasPrice"] = "gasPrice";
    CfAv1LiquidationPeriodChangedEvent_OrderBy["GasUsed"] = "gasUsed";
    CfAv1LiquidationPeriodChangedEvent_OrderBy["GovernanceAddress"] = "governanceAddress";
    CfAv1LiquidationPeriodChangedEvent_OrderBy["Host"] = "host";
    CfAv1LiquidationPeriodChangedEvent_OrderBy["Id"] = "id";
    CfAv1LiquidationPeriodChangedEvent_OrderBy["IsKeySet"] = "isKeySet";
    CfAv1LiquidationPeriodChangedEvent_OrderBy["LiquidationPeriod"] = "liquidationPeriod";
    CfAv1LiquidationPeriodChangedEvent_OrderBy["LogIndex"] = "logIndex";
    CfAv1LiquidationPeriodChangedEvent_OrderBy["Name"] = "name";
    CfAv1LiquidationPeriodChangedEvent_OrderBy["Order"] = "order";
    CfAv1LiquidationPeriodChangedEvent_OrderBy["SuperToken"] = "superToken";
    CfAv1LiquidationPeriodChangedEvent_OrderBy["Timestamp"] = "timestamp";
    CfAv1LiquidationPeriodChangedEvent_OrderBy["TransactionHash"] = "transactionHash";
})(CfAv1LiquidationPeriodChangedEvent_OrderBy || (exports.CfAv1LiquidationPeriodChangedEvent_OrderBy = CfAv1LiquidationPeriodChangedEvent_OrderBy = {}));
var ConfigChangedEvent_OrderBy;
(function (ConfigChangedEvent_OrderBy) {
    ConfigChangedEvent_OrderBy["Addresses"] = "addresses";
    ConfigChangedEvent_OrderBy["BlockNumber"] = "blockNumber";
    ConfigChangedEvent_OrderBy["GasPrice"] = "gasPrice";
    ConfigChangedEvent_OrderBy["GasUsed"] = "gasUsed";
    ConfigChangedEvent_OrderBy["GovernanceAddress"] = "governanceAddress";
    ConfigChangedEvent_OrderBy["Host"] = "host";
    ConfigChangedEvent_OrderBy["Id"] = "id";
    ConfigChangedEvent_OrderBy["IsKeySet"] = "isKeySet";
    ConfigChangedEvent_OrderBy["Key"] = "key";
    ConfigChangedEvent_OrderBy["LogIndex"] = "logIndex";
    ConfigChangedEvent_OrderBy["Name"] = "name";
    ConfigChangedEvent_OrderBy["Order"] = "order";
    ConfigChangedEvent_OrderBy["SuperToken"] = "superToken";
    ConfigChangedEvent_OrderBy["Timestamp"] = "timestamp";
    ConfigChangedEvent_OrderBy["TransactionHash"] = "transactionHash";
    ConfigChangedEvent_OrderBy["Value"] = "value";
})(ConfigChangedEvent_OrderBy || (exports.ConfigChangedEvent_OrderBy = ConfigChangedEvent_OrderBy = {}));
var CustomSuperTokenCreatedEvent_OrderBy;
(function (CustomSuperTokenCreatedEvent_OrderBy) {
    CustomSuperTokenCreatedEvent_OrderBy["Addresses"] = "addresses";
    CustomSuperTokenCreatedEvent_OrderBy["BlockNumber"] = "blockNumber";
    CustomSuperTokenCreatedEvent_OrderBy["GasPrice"] = "gasPrice";
    CustomSuperTokenCreatedEvent_OrderBy["GasUsed"] = "gasUsed";
    CustomSuperTokenCreatedEvent_OrderBy["Id"] = "id";
    CustomSuperTokenCreatedEvent_OrderBy["LogIndex"] = "logIndex";
    CustomSuperTokenCreatedEvent_OrderBy["Name"] = "name";
    CustomSuperTokenCreatedEvent_OrderBy["Order"] = "order";
    CustomSuperTokenCreatedEvent_OrderBy["Timestamp"] = "timestamp";
    CustomSuperTokenCreatedEvent_OrderBy["Token"] = "token";
    CustomSuperTokenCreatedEvent_OrderBy["TransactionHash"] = "transactionHash";
})(CustomSuperTokenCreatedEvent_OrderBy || (exports.CustomSuperTokenCreatedEvent_OrderBy = CustomSuperTokenCreatedEvent_OrderBy = {}));
var DistributionClaimedEvent_OrderBy;
(function (DistributionClaimedEvent_OrderBy) {
    DistributionClaimedEvent_OrderBy["Addresses"] = "addresses";
    DistributionClaimedEvent_OrderBy["BlockNumber"] = "blockNumber";
    DistributionClaimedEvent_OrderBy["ClaimedAmount"] = "claimedAmount";
    DistributionClaimedEvent_OrderBy["GasPrice"] = "gasPrice";
    DistributionClaimedEvent_OrderBy["GasUsed"] = "gasUsed";
    DistributionClaimedEvent_OrderBy["Id"] = "id";
    DistributionClaimedEvent_OrderBy["LogIndex"] = "logIndex";
    DistributionClaimedEvent_OrderBy["Name"] = "name";
    DistributionClaimedEvent_OrderBy["Order"] = "order";
    DistributionClaimedEvent_OrderBy["Pool"] = "pool";
    DistributionClaimedEvent_OrderBy["PoolMember"] = "poolMember";
    DistributionClaimedEvent_OrderBy["PoolMember__createdAtBlockNumber"] = "poolMember__createdAtBlockNumber";
    DistributionClaimedEvent_OrderBy["PoolMember__createdAtTimestamp"] = "poolMember__createdAtTimestamp";
    DistributionClaimedEvent_OrderBy["PoolMember__id"] = "poolMember__id";
    DistributionClaimedEvent_OrderBy["PoolMember__isConnected"] = "poolMember__isConnected";
    DistributionClaimedEvent_OrderBy["PoolMember__totalAmountClaimed"] = "poolMember__totalAmountClaimed";
    DistributionClaimedEvent_OrderBy["PoolMember__units"] = "poolMember__units";
    DistributionClaimedEvent_OrderBy["PoolMember__updatedAtBlockNumber"] = "poolMember__updatedAtBlockNumber";
    DistributionClaimedEvent_OrderBy["PoolMember__updatedAtTimestamp"] = "poolMember__updatedAtTimestamp";
    DistributionClaimedEvent_OrderBy["Pool__adjustmentFlowRate"] = "pool__adjustmentFlowRate";
    DistributionClaimedEvent_OrderBy["Pool__createdAtBlockNumber"] = "pool__createdAtBlockNumber";
    DistributionClaimedEvent_OrderBy["Pool__createdAtTimestamp"] = "pool__createdAtTimestamp";
    DistributionClaimedEvent_OrderBy["Pool__flowRate"] = "pool__flowRate";
    DistributionClaimedEvent_OrderBy["Pool__id"] = "pool__id";
    DistributionClaimedEvent_OrderBy["Pool__totalAmountDistributedUntilUpdatedAt"] = "pool__totalAmountDistributedUntilUpdatedAt";
    DistributionClaimedEvent_OrderBy["Pool__totalAmountFlowedDistributedUntilUpdatedAt"] = "pool__totalAmountFlowedDistributedUntilUpdatedAt";
    DistributionClaimedEvent_OrderBy["Pool__totalAmountInstantlyDistributedUntilUpdatedAt"] = "pool__totalAmountInstantlyDistributedUntilUpdatedAt";
    DistributionClaimedEvent_OrderBy["Pool__totalBuffer"] = "pool__totalBuffer";
    DistributionClaimedEvent_OrderBy["Pool__totalConnectedMembers"] = "pool__totalConnectedMembers";
    DistributionClaimedEvent_OrderBy["Pool__totalConnectedUnits"] = "pool__totalConnectedUnits";
    DistributionClaimedEvent_OrderBy["Pool__totalDisconnectedMembers"] = "pool__totalDisconnectedMembers";
    DistributionClaimedEvent_OrderBy["Pool__totalDisconnectedUnits"] = "pool__totalDisconnectedUnits";
    DistributionClaimedEvent_OrderBy["Pool__totalMembers"] = "pool__totalMembers";
    DistributionClaimedEvent_OrderBy["Pool__totalUnits"] = "pool__totalUnits";
    DistributionClaimedEvent_OrderBy["Pool__updatedAtBlockNumber"] = "pool__updatedAtBlockNumber";
    DistributionClaimedEvent_OrderBy["Pool__updatedAtTimestamp"] = "pool__updatedAtTimestamp";
    DistributionClaimedEvent_OrderBy["Timestamp"] = "timestamp";
    DistributionClaimedEvent_OrderBy["Token"] = "token";
    DistributionClaimedEvent_OrderBy["TotalClaimed"] = "totalClaimed";
    DistributionClaimedEvent_OrderBy["TransactionHash"] = "transactionHash";
})(DistributionClaimedEvent_OrderBy || (exports.DistributionClaimedEvent_OrderBy = DistributionClaimedEvent_OrderBy = {}));
var Event_OrderBy;
(function (Event_OrderBy) {
    Event_OrderBy["Addresses"] = "addresses";
    Event_OrderBy["BlockNumber"] = "blockNumber";
    Event_OrderBy["GasPrice"] = "gasPrice";
    Event_OrderBy["GasUsed"] = "gasUsed";
    Event_OrderBy["Id"] = "id";
    Event_OrderBy["LogIndex"] = "logIndex";
    Event_OrderBy["Name"] = "name";
    Event_OrderBy["Order"] = "order";
    Event_OrderBy["Timestamp"] = "timestamp";
    Event_OrderBy["TransactionHash"] = "transactionHash";
})(Event_OrderBy || (exports.Event_OrderBy = Event_OrderBy = {}));
var ExitRateChangedEvent_OrderBy;
(function (ExitRateChangedEvent_OrderBy) {
    ExitRateChangedEvent_OrderBy["Addresses"] = "addresses";
    ExitRateChangedEvent_OrderBy["BlockNumber"] = "blockNumber";
    ExitRateChangedEvent_OrderBy["ExitRate"] = "exitRate";
    ExitRateChangedEvent_OrderBy["GasPrice"] = "gasPrice";
    ExitRateChangedEvent_OrderBy["GasUsed"] = "gasUsed";
    ExitRateChangedEvent_OrderBy["Id"] = "id";
    ExitRateChangedEvent_OrderBy["LogIndex"] = "logIndex";
    ExitRateChangedEvent_OrderBy["Name"] = "name";
    ExitRateChangedEvent_OrderBy["Order"] = "order";
    ExitRateChangedEvent_OrderBy["Timestamp"] = "timestamp";
    ExitRateChangedEvent_OrderBy["Token"] = "token";
    ExitRateChangedEvent_OrderBy["TransactionHash"] = "transactionHash";
})(ExitRateChangedEvent_OrderBy || (exports.ExitRateChangedEvent_OrderBy = ExitRateChangedEvent_OrderBy = {}));
var FlowDistributionUpdatedEvent_OrderBy;
(function (FlowDistributionUpdatedEvent_OrderBy) {
    FlowDistributionUpdatedEvent_OrderBy["Addresses"] = "addresses";
    FlowDistributionUpdatedEvent_OrderBy["AdjustmentFlowRate"] = "adjustmentFlowRate";
    FlowDistributionUpdatedEvent_OrderBy["AdjustmentFlowRecipient"] = "adjustmentFlowRecipient";
    FlowDistributionUpdatedEvent_OrderBy["BlockNumber"] = "blockNumber";
    FlowDistributionUpdatedEvent_OrderBy["GasPrice"] = "gasPrice";
    FlowDistributionUpdatedEvent_OrderBy["GasUsed"] = "gasUsed";
    FlowDistributionUpdatedEvent_OrderBy["Id"] = "id";
    FlowDistributionUpdatedEvent_OrderBy["LogIndex"] = "logIndex";
    FlowDistributionUpdatedEvent_OrderBy["Name"] = "name";
    FlowDistributionUpdatedEvent_OrderBy["NewDistributorToPoolFlowRate"] = "newDistributorToPoolFlowRate";
    FlowDistributionUpdatedEvent_OrderBy["NewTotalDistributionFlowRate"] = "newTotalDistributionFlowRate";
    FlowDistributionUpdatedEvent_OrderBy["OldFlowRate"] = "oldFlowRate";
    FlowDistributionUpdatedEvent_OrderBy["Operator"] = "operator";
    FlowDistributionUpdatedEvent_OrderBy["Order"] = "order";
    FlowDistributionUpdatedEvent_OrderBy["Pool"] = "pool";
    FlowDistributionUpdatedEvent_OrderBy["PoolDistributor"] = "poolDistributor";
    FlowDistributionUpdatedEvent_OrderBy["PoolDistributor__createdAtBlockNumber"] = "poolDistributor__createdAtBlockNumber";
    FlowDistributionUpdatedEvent_OrderBy["PoolDistributor__createdAtTimestamp"] = "poolDistributor__createdAtTimestamp";
    FlowDistributionUpdatedEvent_OrderBy["PoolDistributor__flowRate"] = "poolDistributor__flowRate";
    FlowDistributionUpdatedEvent_OrderBy["PoolDistributor__id"] = "poolDistributor__id";
    FlowDistributionUpdatedEvent_OrderBy["PoolDistributor__totalAmountDistributedUntilUpdatedAt"] = "poolDistributor__totalAmountDistributedUntilUpdatedAt";
    FlowDistributionUpdatedEvent_OrderBy["PoolDistributor__totalAmountFlowedDistributedUntilUpdatedAt"] = "poolDistributor__totalAmountFlowedDistributedUntilUpdatedAt";
    FlowDistributionUpdatedEvent_OrderBy["PoolDistributor__totalAmountInstantlyDistributedUntilUpdatedAt"] = "poolDistributor__totalAmountInstantlyDistributedUntilUpdatedAt";
    FlowDistributionUpdatedEvent_OrderBy["PoolDistributor__totalBuffer"] = "poolDistributor__totalBuffer";
    FlowDistributionUpdatedEvent_OrderBy["PoolDistributor__updatedAtBlockNumber"] = "poolDistributor__updatedAtBlockNumber";
    FlowDistributionUpdatedEvent_OrderBy["PoolDistributor__updatedAtTimestamp"] = "poolDistributor__updatedAtTimestamp";
    FlowDistributionUpdatedEvent_OrderBy["Pool__adjustmentFlowRate"] = "pool__adjustmentFlowRate";
    FlowDistributionUpdatedEvent_OrderBy["Pool__createdAtBlockNumber"] = "pool__createdAtBlockNumber";
    FlowDistributionUpdatedEvent_OrderBy["Pool__createdAtTimestamp"] = "pool__createdAtTimestamp";
    FlowDistributionUpdatedEvent_OrderBy["Pool__flowRate"] = "pool__flowRate";
    FlowDistributionUpdatedEvent_OrderBy["Pool__id"] = "pool__id";
    FlowDistributionUpdatedEvent_OrderBy["Pool__totalAmountDistributedUntilUpdatedAt"] = "pool__totalAmountDistributedUntilUpdatedAt";
    FlowDistributionUpdatedEvent_OrderBy["Pool__totalAmountFlowedDistributedUntilUpdatedAt"] = "pool__totalAmountFlowedDistributedUntilUpdatedAt";
    FlowDistributionUpdatedEvent_OrderBy["Pool__totalAmountInstantlyDistributedUntilUpdatedAt"] = "pool__totalAmountInstantlyDistributedUntilUpdatedAt";
    FlowDistributionUpdatedEvent_OrderBy["Pool__totalBuffer"] = "pool__totalBuffer";
    FlowDistributionUpdatedEvent_OrderBy["Pool__totalConnectedMembers"] = "pool__totalConnectedMembers";
    FlowDistributionUpdatedEvent_OrderBy["Pool__totalConnectedUnits"] = "pool__totalConnectedUnits";
    FlowDistributionUpdatedEvent_OrderBy["Pool__totalDisconnectedMembers"] = "pool__totalDisconnectedMembers";
    FlowDistributionUpdatedEvent_OrderBy["Pool__totalDisconnectedUnits"] = "pool__totalDisconnectedUnits";
    FlowDistributionUpdatedEvent_OrderBy["Pool__totalMembers"] = "pool__totalMembers";
    FlowDistributionUpdatedEvent_OrderBy["Pool__totalUnits"] = "pool__totalUnits";
    FlowDistributionUpdatedEvent_OrderBy["Pool__updatedAtBlockNumber"] = "pool__updatedAtBlockNumber";
    FlowDistributionUpdatedEvent_OrderBy["Pool__updatedAtTimestamp"] = "pool__updatedAtTimestamp";
    FlowDistributionUpdatedEvent_OrderBy["Timestamp"] = "timestamp";
    FlowDistributionUpdatedEvent_OrderBy["Token"] = "token";
    FlowDistributionUpdatedEvent_OrderBy["TransactionHash"] = "transactionHash";
    FlowDistributionUpdatedEvent_OrderBy["UserData"] = "userData";
})(FlowDistributionUpdatedEvent_OrderBy || (exports.FlowDistributionUpdatedEvent_OrderBy = FlowDistributionUpdatedEvent_OrderBy = {}));
var FlowOperatorUpdatedEvent_OrderBy;
(function (FlowOperatorUpdatedEvent_OrderBy) {
    FlowOperatorUpdatedEvent_OrderBy["Addresses"] = "addresses";
    FlowOperatorUpdatedEvent_OrderBy["BlockNumber"] = "blockNumber";
    FlowOperatorUpdatedEvent_OrderBy["FlowOperator"] = "flowOperator";
    FlowOperatorUpdatedEvent_OrderBy["FlowOperator__allowance"] = "flowOperator__allowance";
    FlowOperatorUpdatedEvent_OrderBy["FlowOperator__createdAtBlockNumber"] = "flowOperator__createdAtBlockNumber";
    FlowOperatorUpdatedEvent_OrderBy["FlowOperator__createdAtTimestamp"] = "flowOperator__createdAtTimestamp";
    FlowOperatorUpdatedEvent_OrderBy["FlowOperator__flowOperator"] = "flowOperator__flowOperator";
    FlowOperatorUpdatedEvent_OrderBy["FlowOperator__flowRateAllowanceGranted"] = "flowOperator__flowRateAllowanceGranted";
    FlowOperatorUpdatedEvent_OrderBy["FlowOperator__flowRateAllowanceRemaining"] = "flowOperator__flowRateAllowanceRemaining";
    FlowOperatorUpdatedEvent_OrderBy["FlowOperator__id"] = "flowOperator__id";
    FlowOperatorUpdatedEvent_OrderBy["FlowOperator__permissions"] = "flowOperator__permissions";
    FlowOperatorUpdatedEvent_OrderBy["FlowOperator__updatedAtBlockNumber"] = "flowOperator__updatedAtBlockNumber";
    FlowOperatorUpdatedEvent_OrderBy["FlowOperator__updatedAtTimestamp"] = "flowOperator__updatedAtTimestamp";
    FlowOperatorUpdatedEvent_OrderBy["FlowRateAllowance"] = "flowRateAllowance";
    FlowOperatorUpdatedEvent_OrderBy["GasPrice"] = "gasPrice";
    FlowOperatorUpdatedEvent_OrderBy["GasUsed"] = "gasUsed";
    FlowOperatorUpdatedEvent_OrderBy["Id"] = "id";
    FlowOperatorUpdatedEvent_OrderBy["LogIndex"] = "logIndex";
    FlowOperatorUpdatedEvent_OrderBy["Name"] = "name";
    FlowOperatorUpdatedEvent_OrderBy["Order"] = "order";
    FlowOperatorUpdatedEvent_OrderBy["Permissions"] = "permissions";
    FlowOperatorUpdatedEvent_OrderBy["Sender"] = "sender";
    FlowOperatorUpdatedEvent_OrderBy["Timestamp"] = "timestamp";
    FlowOperatorUpdatedEvent_OrderBy["Token"] = "token";
    FlowOperatorUpdatedEvent_OrderBy["TransactionHash"] = "transactionHash";
})(FlowOperatorUpdatedEvent_OrderBy || (exports.FlowOperatorUpdatedEvent_OrderBy = FlowOperatorUpdatedEvent_OrderBy = {}));
var FlowOperator_OrderBy;
(function (FlowOperator_OrderBy) {
    FlowOperator_OrderBy["AccountTokenSnapshot"] = "accountTokenSnapshot";
    FlowOperator_OrderBy["AccountTokenSnapshot__activeCFAIncomingStreamCount"] = "accountTokenSnapshot__activeCFAIncomingStreamCount";
    FlowOperator_OrderBy["AccountTokenSnapshot__activeCFAOutgoingStreamCount"] = "accountTokenSnapshot__activeCFAOutgoingStreamCount";
    FlowOperator_OrderBy["AccountTokenSnapshot__activeGDAIncomingStreamCount"] = "accountTokenSnapshot__activeGDAIncomingStreamCount";
    FlowOperator_OrderBy["AccountTokenSnapshot__activeGDAOutgoingStreamCount"] = "accountTokenSnapshot__activeGDAOutgoingStreamCount";
    FlowOperator_OrderBy["AccountTokenSnapshot__activeIncomingStreamCount"] = "accountTokenSnapshot__activeIncomingStreamCount";
    FlowOperator_OrderBy["AccountTokenSnapshot__activeOutgoingStreamCount"] = "accountTokenSnapshot__activeOutgoingStreamCount";
    FlowOperator_OrderBy["AccountTokenSnapshot__balanceUntilUpdatedAt"] = "accountTokenSnapshot__balanceUntilUpdatedAt";
    FlowOperator_OrderBy["AccountTokenSnapshot__id"] = "accountTokenSnapshot__id";
    FlowOperator_OrderBy["AccountTokenSnapshot__inactiveCFAIncomingStreamCount"] = "accountTokenSnapshot__inactiveCFAIncomingStreamCount";
    FlowOperator_OrderBy["AccountTokenSnapshot__inactiveCFAOutgoingStreamCount"] = "accountTokenSnapshot__inactiveCFAOutgoingStreamCount";
    FlowOperator_OrderBy["AccountTokenSnapshot__inactiveGDAIncomingStreamCount"] = "accountTokenSnapshot__inactiveGDAIncomingStreamCount";
    FlowOperator_OrderBy["AccountTokenSnapshot__inactiveGDAOutgoingStreamCount"] = "accountTokenSnapshot__inactiveGDAOutgoingStreamCount";
    FlowOperator_OrderBy["AccountTokenSnapshot__inactiveIncomingStreamCount"] = "accountTokenSnapshot__inactiveIncomingStreamCount";
    FlowOperator_OrderBy["AccountTokenSnapshot__inactiveOutgoingStreamCount"] = "accountTokenSnapshot__inactiveOutgoingStreamCount";
    FlowOperator_OrderBy["AccountTokenSnapshot__isLiquidationEstimateOptimistic"] = "accountTokenSnapshot__isLiquidationEstimateOptimistic";
    FlowOperator_OrderBy["AccountTokenSnapshot__maybeCriticalAtTimestamp"] = "accountTokenSnapshot__maybeCriticalAtTimestamp";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalAmountStreamedInUntilUpdatedAt"] = "accountTokenSnapshot__totalAmountStreamedInUntilUpdatedAt";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalAmountStreamedOutUntilUpdatedAt"] = "accountTokenSnapshot__totalAmountStreamedOutUntilUpdatedAt";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalAmountStreamedUntilUpdatedAt"] = "accountTokenSnapshot__totalAmountStreamedUntilUpdatedAt";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalAmountTransferredUntilUpdatedAt"] = "accountTokenSnapshot__totalAmountTransferredUntilUpdatedAt";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalApprovedSubscriptions"] = "accountTokenSnapshot__totalApprovedSubscriptions";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalCFAAmountStreamedInUntilUpdatedAt"] = "accountTokenSnapshot__totalCFAAmountStreamedInUntilUpdatedAt";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalCFAAmountStreamedOutUntilUpdatedAt"] = "accountTokenSnapshot__totalCFAAmountStreamedOutUntilUpdatedAt";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalCFAAmountStreamedUntilUpdatedAt"] = "accountTokenSnapshot__totalCFAAmountStreamedUntilUpdatedAt";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalCFADeposit"] = "accountTokenSnapshot__totalCFADeposit";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalCFAInflowRate"] = "accountTokenSnapshot__totalCFAInflowRate";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalCFANetFlowRate"] = "accountTokenSnapshot__totalCFANetFlowRate";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalCFANumberOfActiveStreams"] = "accountTokenSnapshot__totalCFANumberOfActiveStreams";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalCFANumberOfClosedStreams"] = "accountTokenSnapshot__totalCFANumberOfClosedStreams";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalCFAOutflowRate"] = "accountTokenSnapshot__totalCFAOutflowRate";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalConnectedMemberships"] = "accountTokenSnapshot__totalConnectedMemberships";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalDeposit"] = "accountTokenSnapshot__totalDeposit";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalGDAAmountStreamedInUntilUpdatedAt"] = "accountTokenSnapshot__totalGDAAmountStreamedInUntilUpdatedAt";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalGDAAmountStreamedOutUntilUpdatedAt"] = "accountTokenSnapshot__totalGDAAmountStreamedOutUntilUpdatedAt";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalGDAAmountStreamedUntilUpdatedAt"] = "accountTokenSnapshot__totalGDAAmountStreamedUntilUpdatedAt";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalGDADeposit"] = "accountTokenSnapshot__totalGDADeposit";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalGDAInflowRate"] = "accountTokenSnapshot__totalGDAInflowRate";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalGDANetFlowRate"] = "accountTokenSnapshot__totalGDANetFlowRate";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalGDANumberOfActiveStreams"] = "accountTokenSnapshot__totalGDANumberOfActiveStreams";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalGDANumberOfClosedStreams"] = "accountTokenSnapshot__totalGDANumberOfClosedStreams";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalGDAOutflowRate"] = "accountTokenSnapshot__totalGDAOutflowRate";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalInflowRate"] = "accountTokenSnapshot__totalInflowRate";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalMembershipsWithUnits"] = "accountTokenSnapshot__totalMembershipsWithUnits";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalNetFlowRate"] = "accountTokenSnapshot__totalNetFlowRate";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalNumberOfActiveStreams"] = "accountTokenSnapshot__totalNumberOfActiveStreams";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalNumberOfClosedStreams"] = "accountTokenSnapshot__totalNumberOfClosedStreams";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalOutflowRate"] = "accountTokenSnapshot__totalOutflowRate";
    FlowOperator_OrderBy["AccountTokenSnapshot__totalSubscriptionsWithUnits"] = "accountTokenSnapshot__totalSubscriptionsWithUnits";
    FlowOperator_OrderBy["AccountTokenSnapshot__updatedAtBlockNumber"] = "accountTokenSnapshot__updatedAtBlockNumber";
    FlowOperator_OrderBy["AccountTokenSnapshot__updatedAtTimestamp"] = "accountTokenSnapshot__updatedAtTimestamp";
    FlowOperator_OrderBy["Allowance"] = "allowance";
    FlowOperator_OrderBy["CreatedAtBlockNumber"] = "createdAtBlockNumber";
    FlowOperator_OrderBy["CreatedAtTimestamp"] = "createdAtTimestamp";
    FlowOperator_OrderBy["FlowOperator"] = "flowOperator";
    FlowOperator_OrderBy["FlowOperatorUpdatedEvents"] = "flowOperatorUpdatedEvents";
    FlowOperator_OrderBy["FlowRateAllowanceGranted"] = "flowRateAllowanceGranted";
    FlowOperator_OrderBy["FlowRateAllowanceRemaining"] = "flowRateAllowanceRemaining";
    FlowOperator_OrderBy["Id"] = "id";
    FlowOperator_OrderBy["Permissions"] = "permissions";
    FlowOperator_OrderBy["Sender"] = "sender";
    FlowOperator_OrderBy["Sender__createdAtBlockNumber"] = "sender__createdAtBlockNumber";
    FlowOperator_OrderBy["Sender__createdAtTimestamp"] = "sender__createdAtTimestamp";
    FlowOperator_OrderBy["Sender__id"] = "sender__id";
    FlowOperator_OrderBy["Sender__isSuperApp"] = "sender__isSuperApp";
    FlowOperator_OrderBy["Sender__updatedAtBlockNumber"] = "sender__updatedAtBlockNumber";
    FlowOperator_OrderBy["Sender__updatedAtTimestamp"] = "sender__updatedAtTimestamp";
    FlowOperator_OrderBy["Token"] = "token";
    FlowOperator_OrderBy["Token__createdAtBlockNumber"] = "token__createdAtBlockNumber";
    FlowOperator_OrderBy["Token__createdAtTimestamp"] = "token__createdAtTimestamp";
    FlowOperator_OrderBy["Token__decimals"] = "token__decimals";
    FlowOperator_OrderBy["Token__id"] = "token__id";
    FlowOperator_OrderBy["Token__isListed"] = "token__isListed";
    FlowOperator_OrderBy["Token__isNativeAssetSuperToken"] = "token__isNativeAssetSuperToken";
    FlowOperator_OrderBy["Token__isSuperToken"] = "token__isSuperToken";
    FlowOperator_OrderBy["Token__name"] = "token__name";
    FlowOperator_OrderBy["Token__symbol"] = "token__symbol";
    FlowOperator_OrderBy["Token__underlyingAddress"] = "token__underlyingAddress";
    FlowOperator_OrderBy["UpdatedAtBlockNumber"] = "updatedAtBlockNumber";
    FlowOperator_OrderBy["UpdatedAtTimestamp"] = "updatedAtTimestamp";
})(FlowOperator_OrderBy || (exports.FlowOperator_OrderBy = FlowOperator_OrderBy = {}));
var FlowUpdatedEvent_OrderBy;
(function (FlowUpdatedEvent_OrderBy) {
    FlowUpdatedEvent_OrderBy["Addresses"] = "addresses";
    FlowUpdatedEvent_OrderBy["BlockNumber"] = "blockNumber";
    FlowUpdatedEvent_OrderBy["Deposit"] = "deposit";
    FlowUpdatedEvent_OrderBy["FlowOperator"] = "flowOperator";
    FlowUpdatedEvent_OrderBy["FlowRate"] = "flowRate";
    FlowUpdatedEvent_OrderBy["GasPrice"] = "gasPrice";
    FlowUpdatedEvent_OrderBy["GasUsed"] = "gasUsed";
    FlowUpdatedEvent_OrderBy["Id"] = "id";
    FlowUpdatedEvent_OrderBy["LogIndex"] = "logIndex";
    FlowUpdatedEvent_OrderBy["Name"] = "name";
    FlowUpdatedEvent_OrderBy["OldFlowRate"] = "oldFlowRate";
    FlowUpdatedEvent_OrderBy["Order"] = "order";
    FlowUpdatedEvent_OrderBy["Receiver"] = "receiver";
    FlowUpdatedEvent_OrderBy["Sender"] = "sender";
    FlowUpdatedEvent_OrderBy["Stream"] = "stream";
    FlowUpdatedEvent_OrderBy["Stream__createdAtBlockNumber"] = "stream__createdAtBlockNumber";
    FlowUpdatedEvent_OrderBy["Stream__createdAtTimestamp"] = "stream__createdAtTimestamp";
    FlowUpdatedEvent_OrderBy["Stream__currentFlowRate"] = "stream__currentFlowRate";
    FlowUpdatedEvent_OrderBy["Stream__deposit"] = "stream__deposit";
    FlowUpdatedEvent_OrderBy["Stream__id"] = "stream__id";
    FlowUpdatedEvent_OrderBy["Stream__streamedUntilUpdatedAt"] = "stream__streamedUntilUpdatedAt";
    FlowUpdatedEvent_OrderBy["Stream__updatedAtBlockNumber"] = "stream__updatedAtBlockNumber";
    FlowUpdatedEvent_OrderBy["Stream__updatedAtTimestamp"] = "stream__updatedAtTimestamp";
    FlowUpdatedEvent_OrderBy["Stream__userData"] = "stream__userData";
    FlowUpdatedEvent_OrderBy["Timestamp"] = "timestamp";
    FlowUpdatedEvent_OrderBy["Token"] = "token";
    FlowUpdatedEvent_OrderBy["TotalAmountStreamedUntilTimestamp"] = "totalAmountStreamedUntilTimestamp";
    FlowUpdatedEvent_OrderBy["TotalReceiverFlowRate"] = "totalReceiverFlowRate";
    FlowUpdatedEvent_OrderBy["TotalSenderFlowRate"] = "totalSenderFlowRate";
    FlowUpdatedEvent_OrderBy["TransactionHash"] = "transactionHash";
    FlowUpdatedEvent_OrderBy["Type"] = "type";
    FlowUpdatedEvent_OrderBy["UserData"] = "userData";
})(FlowUpdatedEvent_OrderBy || (exports.FlowUpdatedEvent_OrderBy = FlowUpdatedEvent_OrderBy = {}));
var GovernanceReplacedEvent_OrderBy;
(function (GovernanceReplacedEvent_OrderBy) {
    GovernanceReplacedEvent_OrderBy["Addresses"] = "addresses";
    GovernanceReplacedEvent_OrderBy["BlockNumber"] = "blockNumber";
    GovernanceReplacedEvent_OrderBy["GasPrice"] = "gasPrice";
    GovernanceReplacedEvent_OrderBy["GasUsed"] = "gasUsed";
    GovernanceReplacedEvent_OrderBy["Id"] = "id";
    GovernanceReplacedEvent_OrderBy["LogIndex"] = "logIndex";
    GovernanceReplacedEvent_OrderBy["Name"] = "name";
    GovernanceReplacedEvent_OrderBy["NewGovernance"] = "newGovernance";
    GovernanceReplacedEvent_OrderBy["OldGovernance"] = "oldGovernance";
    GovernanceReplacedEvent_OrderBy["Order"] = "order";
    GovernanceReplacedEvent_OrderBy["Timestamp"] = "timestamp";
    GovernanceReplacedEvent_OrderBy["TransactionHash"] = "transactionHash";
})(GovernanceReplacedEvent_OrderBy || (exports.GovernanceReplacedEvent_OrderBy = GovernanceReplacedEvent_OrderBy = {}));
var IndexCreatedEvent_OrderBy;
(function (IndexCreatedEvent_OrderBy) {
    IndexCreatedEvent_OrderBy["Addresses"] = "addresses";
    IndexCreatedEvent_OrderBy["BlockNumber"] = "blockNumber";
    IndexCreatedEvent_OrderBy["GasPrice"] = "gasPrice";
    IndexCreatedEvent_OrderBy["GasUsed"] = "gasUsed";
    IndexCreatedEvent_OrderBy["Id"] = "id";
    IndexCreatedEvent_OrderBy["Index"] = "index";
    IndexCreatedEvent_OrderBy["IndexId"] = "indexId";
    IndexCreatedEvent_OrderBy["Index__createdAtBlockNumber"] = "index__createdAtBlockNumber";
    IndexCreatedEvent_OrderBy["Index__createdAtTimestamp"] = "index__createdAtTimestamp";
    IndexCreatedEvent_OrderBy["Index__id"] = "index__id";
    IndexCreatedEvent_OrderBy["Index__indexId"] = "index__indexId";
    IndexCreatedEvent_OrderBy["Index__indexValue"] = "index__indexValue";
    IndexCreatedEvent_OrderBy["Index__totalAmountDistributedUntilUpdatedAt"] = "index__totalAmountDistributedUntilUpdatedAt";
    IndexCreatedEvent_OrderBy["Index__totalSubscriptionsWithUnits"] = "index__totalSubscriptionsWithUnits";
    IndexCreatedEvent_OrderBy["Index__totalUnits"] = "index__totalUnits";
    IndexCreatedEvent_OrderBy["Index__totalUnitsApproved"] = "index__totalUnitsApproved";
    IndexCreatedEvent_OrderBy["Index__totalUnitsPending"] = "index__totalUnitsPending";
    IndexCreatedEvent_OrderBy["Index__updatedAtBlockNumber"] = "index__updatedAtBlockNumber";
    IndexCreatedEvent_OrderBy["Index__updatedAtTimestamp"] = "index__updatedAtTimestamp";
    IndexCreatedEvent_OrderBy["LogIndex"] = "logIndex";
    IndexCreatedEvent_OrderBy["Name"] = "name";
    IndexCreatedEvent_OrderBy["Order"] = "order";
    IndexCreatedEvent_OrderBy["Publisher"] = "publisher";
    IndexCreatedEvent_OrderBy["Timestamp"] = "timestamp";
    IndexCreatedEvent_OrderBy["Token"] = "token";
    IndexCreatedEvent_OrderBy["TransactionHash"] = "transactionHash";
    IndexCreatedEvent_OrderBy["UserData"] = "userData";
})(IndexCreatedEvent_OrderBy || (exports.IndexCreatedEvent_OrderBy = IndexCreatedEvent_OrderBy = {}));
var IndexDistributionClaimedEvent_OrderBy;
(function (IndexDistributionClaimedEvent_OrderBy) {
    IndexDistributionClaimedEvent_OrderBy["Addresses"] = "addresses";
    IndexDistributionClaimedEvent_OrderBy["Amount"] = "amount";
    IndexDistributionClaimedEvent_OrderBy["BlockNumber"] = "blockNumber";
    IndexDistributionClaimedEvent_OrderBy["GasPrice"] = "gasPrice";
    IndexDistributionClaimedEvent_OrderBy["GasUsed"] = "gasUsed";
    IndexDistributionClaimedEvent_OrderBy["Id"] = "id";
    IndexDistributionClaimedEvent_OrderBy["Index"] = "index";
    IndexDistributionClaimedEvent_OrderBy["IndexId"] = "indexId";
    IndexDistributionClaimedEvent_OrderBy["Index__createdAtBlockNumber"] = "index__createdAtBlockNumber";
    IndexDistributionClaimedEvent_OrderBy["Index__createdAtTimestamp"] = "index__createdAtTimestamp";
    IndexDistributionClaimedEvent_OrderBy["Index__id"] = "index__id";
    IndexDistributionClaimedEvent_OrderBy["Index__indexId"] = "index__indexId";
    IndexDistributionClaimedEvent_OrderBy["Index__indexValue"] = "index__indexValue";
    IndexDistributionClaimedEvent_OrderBy["Index__totalAmountDistributedUntilUpdatedAt"] = "index__totalAmountDistributedUntilUpdatedAt";
    IndexDistributionClaimedEvent_OrderBy["Index__totalSubscriptionsWithUnits"] = "index__totalSubscriptionsWithUnits";
    IndexDistributionClaimedEvent_OrderBy["Index__totalUnits"] = "index__totalUnits";
    IndexDistributionClaimedEvent_OrderBy["Index__totalUnitsApproved"] = "index__totalUnitsApproved";
    IndexDistributionClaimedEvent_OrderBy["Index__totalUnitsPending"] = "index__totalUnitsPending";
    IndexDistributionClaimedEvent_OrderBy["Index__updatedAtBlockNumber"] = "index__updatedAtBlockNumber";
    IndexDistributionClaimedEvent_OrderBy["Index__updatedAtTimestamp"] = "index__updatedAtTimestamp";
    IndexDistributionClaimedEvent_OrderBy["LogIndex"] = "logIndex";
    IndexDistributionClaimedEvent_OrderBy["Name"] = "name";
    IndexDistributionClaimedEvent_OrderBy["Order"] = "order";
    IndexDistributionClaimedEvent_OrderBy["Publisher"] = "publisher";
    IndexDistributionClaimedEvent_OrderBy["Subscriber"] = "subscriber";
    IndexDistributionClaimedEvent_OrderBy["Timestamp"] = "timestamp";
    IndexDistributionClaimedEvent_OrderBy["Token"] = "token";
    IndexDistributionClaimedEvent_OrderBy["TransactionHash"] = "transactionHash";
})(IndexDistributionClaimedEvent_OrderBy || (exports.IndexDistributionClaimedEvent_OrderBy = IndexDistributionClaimedEvent_OrderBy = {}));
var IndexSubscribedEvent_OrderBy;
(function (IndexSubscribedEvent_OrderBy) {
    IndexSubscribedEvent_OrderBy["Addresses"] = "addresses";
    IndexSubscribedEvent_OrderBy["BlockNumber"] = "blockNumber";
    IndexSubscribedEvent_OrderBy["GasPrice"] = "gasPrice";
    IndexSubscribedEvent_OrderBy["GasUsed"] = "gasUsed";
    IndexSubscribedEvent_OrderBy["Id"] = "id";
    IndexSubscribedEvent_OrderBy["Index"] = "index";
    IndexSubscribedEvent_OrderBy["IndexId"] = "indexId";
    IndexSubscribedEvent_OrderBy["Index__createdAtBlockNumber"] = "index__createdAtBlockNumber";
    IndexSubscribedEvent_OrderBy["Index__createdAtTimestamp"] = "index__createdAtTimestamp";
    IndexSubscribedEvent_OrderBy["Index__id"] = "index__id";
    IndexSubscribedEvent_OrderBy["Index__indexId"] = "index__indexId";
    IndexSubscribedEvent_OrderBy["Index__indexValue"] = "index__indexValue";
    IndexSubscribedEvent_OrderBy["Index__totalAmountDistributedUntilUpdatedAt"] = "index__totalAmountDistributedUntilUpdatedAt";
    IndexSubscribedEvent_OrderBy["Index__totalSubscriptionsWithUnits"] = "index__totalSubscriptionsWithUnits";
    IndexSubscribedEvent_OrderBy["Index__totalUnits"] = "index__totalUnits";
    IndexSubscribedEvent_OrderBy["Index__totalUnitsApproved"] = "index__totalUnitsApproved";
    IndexSubscribedEvent_OrderBy["Index__totalUnitsPending"] = "index__totalUnitsPending";
    IndexSubscribedEvent_OrderBy["Index__updatedAtBlockNumber"] = "index__updatedAtBlockNumber";
    IndexSubscribedEvent_OrderBy["Index__updatedAtTimestamp"] = "index__updatedAtTimestamp";
    IndexSubscribedEvent_OrderBy["LogIndex"] = "logIndex";
    IndexSubscribedEvent_OrderBy["Name"] = "name";
    IndexSubscribedEvent_OrderBy["Order"] = "order";
    IndexSubscribedEvent_OrderBy["Publisher"] = "publisher";
    IndexSubscribedEvent_OrderBy["Subscriber"] = "subscriber";
    IndexSubscribedEvent_OrderBy["Timestamp"] = "timestamp";
    IndexSubscribedEvent_OrderBy["Token"] = "token";
    IndexSubscribedEvent_OrderBy["TransactionHash"] = "transactionHash";
    IndexSubscribedEvent_OrderBy["UserData"] = "userData";
})(IndexSubscribedEvent_OrderBy || (exports.IndexSubscribedEvent_OrderBy = IndexSubscribedEvent_OrderBy = {}));
var IndexSubscription_OrderBy;
(function (IndexSubscription_OrderBy) {
    IndexSubscription_OrderBy["Approved"] = "approved";
    IndexSubscription_OrderBy["CreatedAtBlockNumber"] = "createdAtBlockNumber";
    IndexSubscription_OrderBy["CreatedAtTimestamp"] = "createdAtTimestamp";
    IndexSubscription_OrderBy["Id"] = "id";
    IndexSubscription_OrderBy["Index"] = "index";
    IndexSubscription_OrderBy["IndexValueUntilUpdatedAt"] = "indexValueUntilUpdatedAt";
    IndexSubscription_OrderBy["Index__createdAtBlockNumber"] = "index__createdAtBlockNumber";
    IndexSubscription_OrderBy["Index__createdAtTimestamp"] = "index__createdAtTimestamp";
    IndexSubscription_OrderBy["Index__id"] = "index__id";
    IndexSubscription_OrderBy["Index__indexId"] = "index__indexId";
    IndexSubscription_OrderBy["Index__indexValue"] = "index__indexValue";
    IndexSubscription_OrderBy["Index__totalAmountDistributedUntilUpdatedAt"] = "index__totalAmountDistributedUntilUpdatedAt";
    IndexSubscription_OrderBy["Index__totalSubscriptionsWithUnits"] = "index__totalSubscriptionsWithUnits";
    IndexSubscription_OrderBy["Index__totalUnits"] = "index__totalUnits";
    IndexSubscription_OrderBy["Index__totalUnitsApproved"] = "index__totalUnitsApproved";
    IndexSubscription_OrderBy["Index__totalUnitsPending"] = "index__totalUnitsPending";
    IndexSubscription_OrderBy["Index__updatedAtBlockNumber"] = "index__updatedAtBlockNumber";
    IndexSubscription_OrderBy["Index__updatedAtTimestamp"] = "index__updatedAtTimestamp";
    IndexSubscription_OrderBy["Subscriber"] = "subscriber";
    IndexSubscription_OrderBy["Subscriber__createdAtBlockNumber"] = "subscriber__createdAtBlockNumber";
    IndexSubscription_OrderBy["Subscriber__createdAtTimestamp"] = "subscriber__createdAtTimestamp";
    IndexSubscription_OrderBy["Subscriber__id"] = "subscriber__id";
    IndexSubscription_OrderBy["Subscriber__isSuperApp"] = "subscriber__isSuperApp";
    IndexSubscription_OrderBy["Subscriber__updatedAtBlockNumber"] = "subscriber__updatedAtBlockNumber";
    IndexSubscription_OrderBy["Subscriber__updatedAtTimestamp"] = "subscriber__updatedAtTimestamp";
    IndexSubscription_OrderBy["SubscriptionApprovedEvents"] = "subscriptionApprovedEvents";
    IndexSubscription_OrderBy["SubscriptionDistributionClaimedEvents"] = "subscriptionDistributionClaimedEvents";
    IndexSubscription_OrderBy["SubscriptionRevokedEvents"] = "subscriptionRevokedEvents";
    IndexSubscription_OrderBy["SubscriptionUnitsUpdatedEvents"] = "subscriptionUnitsUpdatedEvents";
    IndexSubscription_OrderBy["TotalAmountReceivedUntilUpdatedAt"] = "totalAmountReceivedUntilUpdatedAt";
    IndexSubscription_OrderBy["Units"] = "units";
    IndexSubscription_OrderBy["UpdatedAtBlockNumber"] = "updatedAtBlockNumber";
    IndexSubscription_OrderBy["UpdatedAtTimestamp"] = "updatedAtTimestamp";
})(IndexSubscription_OrderBy || (exports.IndexSubscription_OrderBy = IndexSubscription_OrderBy = {}));
var IndexUnitsUpdatedEvent_OrderBy;
(function (IndexUnitsUpdatedEvent_OrderBy) {
    IndexUnitsUpdatedEvent_OrderBy["Addresses"] = "addresses";
    IndexUnitsUpdatedEvent_OrderBy["BlockNumber"] = "blockNumber";
    IndexUnitsUpdatedEvent_OrderBy["GasPrice"] = "gasPrice";
    IndexUnitsUpdatedEvent_OrderBy["GasUsed"] = "gasUsed";
    IndexUnitsUpdatedEvent_OrderBy["Id"] = "id";
    IndexUnitsUpdatedEvent_OrderBy["Index"] = "index";
    IndexUnitsUpdatedEvent_OrderBy["IndexId"] = "indexId";
    IndexUnitsUpdatedEvent_OrderBy["Index__createdAtBlockNumber"] = "index__createdAtBlockNumber";
    IndexUnitsUpdatedEvent_OrderBy["Index__createdAtTimestamp"] = "index__createdAtTimestamp";
    IndexUnitsUpdatedEvent_OrderBy["Index__id"] = "index__id";
    IndexUnitsUpdatedEvent_OrderBy["Index__indexId"] = "index__indexId";
    IndexUnitsUpdatedEvent_OrderBy["Index__indexValue"] = "index__indexValue";
    IndexUnitsUpdatedEvent_OrderBy["Index__totalAmountDistributedUntilUpdatedAt"] = "index__totalAmountDistributedUntilUpdatedAt";
    IndexUnitsUpdatedEvent_OrderBy["Index__totalSubscriptionsWithUnits"] = "index__totalSubscriptionsWithUnits";
    IndexUnitsUpdatedEvent_OrderBy["Index__totalUnits"] = "index__totalUnits";
    IndexUnitsUpdatedEvent_OrderBy["Index__totalUnitsApproved"] = "index__totalUnitsApproved";
    IndexUnitsUpdatedEvent_OrderBy["Index__totalUnitsPending"] = "index__totalUnitsPending";
    IndexUnitsUpdatedEvent_OrderBy["Index__updatedAtBlockNumber"] = "index__updatedAtBlockNumber";
    IndexUnitsUpdatedEvent_OrderBy["Index__updatedAtTimestamp"] = "index__updatedAtTimestamp";
    IndexUnitsUpdatedEvent_OrderBy["LogIndex"] = "logIndex";
    IndexUnitsUpdatedEvent_OrderBy["Name"] = "name";
    IndexUnitsUpdatedEvent_OrderBy["OldUnits"] = "oldUnits";
    IndexUnitsUpdatedEvent_OrderBy["Order"] = "order";
    IndexUnitsUpdatedEvent_OrderBy["Publisher"] = "publisher";
    IndexUnitsUpdatedEvent_OrderBy["Subscriber"] = "subscriber";
    IndexUnitsUpdatedEvent_OrderBy["Timestamp"] = "timestamp";
    IndexUnitsUpdatedEvent_OrderBy["Token"] = "token";
    IndexUnitsUpdatedEvent_OrderBy["TransactionHash"] = "transactionHash";
    IndexUnitsUpdatedEvent_OrderBy["Units"] = "units";
    IndexUnitsUpdatedEvent_OrderBy["UserData"] = "userData";
})(IndexUnitsUpdatedEvent_OrderBy || (exports.IndexUnitsUpdatedEvent_OrderBy = IndexUnitsUpdatedEvent_OrderBy = {}));
var IndexUnsubscribedEvent_OrderBy;
(function (IndexUnsubscribedEvent_OrderBy) {
    IndexUnsubscribedEvent_OrderBy["Addresses"] = "addresses";
    IndexUnsubscribedEvent_OrderBy["BlockNumber"] = "blockNumber";
    IndexUnsubscribedEvent_OrderBy["GasPrice"] = "gasPrice";
    IndexUnsubscribedEvent_OrderBy["GasUsed"] = "gasUsed";
    IndexUnsubscribedEvent_OrderBy["Id"] = "id";
    IndexUnsubscribedEvent_OrderBy["Index"] = "index";
    IndexUnsubscribedEvent_OrderBy["IndexId"] = "indexId";
    IndexUnsubscribedEvent_OrderBy["Index__createdAtBlockNumber"] = "index__createdAtBlockNumber";
    IndexUnsubscribedEvent_OrderBy["Index__createdAtTimestamp"] = "index__createdAtTimestamp";
    IndexUnsubscribedEvent_OrderBy["Index__id"] = "index__id";
    IndexUnsubscribedEvent_OrderBy["Index__indexId"] = "index__indexId";
    IndexUnsubscribedEvent_OrderBy["Index__indexValue"] = "index__indexValue";
    IndexUnsubscribedEvent_OrderBy["Index__totalAmountDistributedUntilUpdatedAt"] = "index__totalAmountDistributedUntilUpdatedAt";
    IndexUnsubscribedEvent_OrderBy["Index__totalSubscriptionsWithUnits"] = "index__totalSubscriptionsWithUnits";
    IndexUnsubscribedEvent_OrderBy["Index__totalUnits"] = "index__totalUnits";
    IndexUnsubscribedEvent_OrderBy["Index__totalUnitsApproved"] = "index__totalUnitsApproved";
    IndexUnsubscribedEvent_OrderBy["Index__totalUnitsPending"] = "index__totalUnitsPending";
    IndexUnsubscribedEvent_OrderBy["Index__updatedAtBlockNumber"] = "index__updatedAtBlockNumber";
    IndexUnsubscribedEvent_OrderBy["Index__updatedAtTimestamp"] = "index__updatedAtTimestamp";
    IndexUnsubscribedEvent_OrderBy["LogIndex"] = "logIndex";
    IndexUnsubscribedEvent_OrderBy["Name"] = "name";
    IndexUnsubscribedEvent_OrderBy["Order"] = "order";
    IndexUnsubscribedEvent_OrderBy["Publisher"] = "publisher";
    IndexUnsubscribedEvent_OrderBy["Subscriber"] = "subscriber";
    IndexUnsubscribedEvent_OrderBy["Timestamp"] = "timestamp";
    IndexUnsubscribedEvent_OrderBy["Token"] = "token";
    IndexUnsubscribedEvent_OrderBy["TransactionHash"] = "transactionHash";
    IndexUnsubscribedEvent_OrderBy["UserData"] = "userData";
})(IndexUnsubscribedEvent_OrderBy || (exports.IndexUnsubscribedEvent_OrderBy = IndexUnsubscribedEvent_OrderBy = {}));
var IndexUpdatedEvent_OrderBy;
(function (IndexUpdatedEvent_OrderBy) {
    IndexUpdatedEvent_OrderBy["Addresses"] = "addresses";
    IndexUpdatedEvent_OrderBy["BlockNumber"] = "blockNumber";
    IndexUpdatedEvent_OrderBy["GasPrice"] = "gasPrice";
    IndexUpdatedEvent_OrderBy["GasUsed"] = "gasUsed";
    IndexUpdatedEvent_OrderBy["Id"] = "id";
    IndexUpdatedEvent_OrderBy["Index"] = "index";
    IndexUpdatedEvent_OrderBy["IndexId"] = "indexId";
    IndexUpdatedEvent_OrderBy["Index__createdAtBlockNumber"] = "index__createdAtBlockNumber";
    IndexUpdatedEvent_OrderBy["Index__createdAtTimestamp"] = "index__createdAtTimestamp";
    IndexUpdatedEvent_OrderBy["Index__id"] = "index__id";
    IndexUpdatedEvent_OrderBy["Index__indexId"] = "index__indexId";
    IndexUpdatedEvent_OrderBy["Index__indexValue"] = "index__indexValue";
    IndexUpdatedEvent_OrderBy["Index__totalAmountDistributedUntilUpdatedAt"] = "index__totalAmountDistributedUntilUpdatedAt";
    IndexUpdatedEvent_OrderBy["Index__totalSubscriptionsWithUnits"] = "index__totalSubscriptionsWithUnits";
    IndexUpdatedEvent_OrderBy["Index__totalUnits"] = "index__totalUnits";
    IndexUpdatedEvent_OrderBy["Index__totalUnitsApproved"] = "index__totalUnitsApproved";
    IndexUpdatedEvent_OrderBy["Index__totalUnitsPending"] = "index__totalUnitsPending";
    IndexUpdatedEvent_OrderBy["Index__updatedAtBlockNumber"] = "index__updatedAtBlockNumber";
    IndexUpdatedEvent_OrderBy["Index__updatedAtTimestamp"] = "index__updatedAtTimestamp";
    IndexUpdatedEvent_OrderBy["LogIndex"] = "logIndex";
    IndexUpdatedEvent_OrderBy["Name"] = "name";
    IndexUpdatedEvent_OrderBy["NewIndexValue"] = "newIndexValue";
    IndexUpdatedEvent_OrderBy["OldIndexValue"] = "oldIndexValue";
    IndexUpdatedEvent_OrderBy["Order"] = "order";
    IndexUpdatedEvent_OrderBy["Publisher"] = "publisher";
    IndexUpdatedEvent_OrderBy["Timestamp"] = "timestamp";
    IndexUpdatedEvent_OrderBy["Token"] = "token";
    IndexUpdatedEvent_OrderBy["TotalUnitsApproved"] = "totalUnitsApproved";
    IndexUpdatedEvent_OrderBy["TotalUnitsPending"] = "totalUnitsPending";
    IndexUpdatedEvent_OrderBy["TransactionHash"] = "transactionHash";
    IndexUpdatedEvent_OrderBy["UserData"] = "userData";
})(IndexUpdatedEvent_OrderBy || (exports.IndexUpdatedEvent_OrderBy = IndexUpdatedEvent_OrderBy = {}));
var Index_OrderBy;
(function (Index_OrderBy) {
    Index_OrderBy["CreatedAtBlockNumber"] = "createdAtBlockNumber";
    Index_OrderBy["CreatedAtTimestamp"] = "createdAtTimestamp";
    Index_OrderBy["Id"] = "id";
    Index_OrderBy["IndexCreatedEvent"] = "indexCreatedEvent";
    Index_OrderBy["IndexCreatedEvent__blockNumber"] = "indexCreatedEvent__blockNumber";
    Index_OrderBy["IndexCreatedEvent__gasPrice"] = "indexCreatedEvent__gasPrice";
    Index_OrderBy["IndexCreatedEvent__gasUsed"] = "indexCreatedEvent__gasUsed";
    Index_OrderBy["IndexCreatedEvent__id"] = "indexCreatedEvent__id";
    Index_OrderBy["IndexCreatedEvent__indexId"] = "indexCreatedEvent__indexId";
    Index_OrderBy["IndexCreatedEvent__logIndex"] = "indexCreatedEvent__logIndex";
    Index_OrderBy["IndexCreatedEvent__name"] = "indexCreatedEvent__name";
    Index_OrderBy["IndexCreatedEvent__order"] = "indexCreatedEvent__order";
    Index_OrderBy["IndexCreatedEvent__publisher"] = "indexCreatedEvent__publisher";
    Index_OrderBy["IndexCreatedEvent__timestamp"] = "indexCreatedEvent__timestamp";
    Index_OrderBy["IndexCreatedEvent__token"] = "indexCreatedEvent__token";
    Index_OrderBy["IndexCreatedEvent__transactionHash"] = "indexCreatedEvent__transactionHash";
    Index_OrderBy["IndexCreatedEvent__userData"] = "indexCreatedEvent__userData";
    Index_OrderBy["IndexDistributionClaimedEvents"] = "indexDistributionClaimedEvents";
    Index_OrderBy["IndexId"] = "indexId";
    Index_OrderBy["IndexSubscribedEvents"] = "indexSubscribedEvents";
    Index_OrderBy["IndexUnitsUpdatedEvents"] = "indexUnitsUpdatedEvents";
    Index_OrderBy["IndexUnsubscribedEvents"] = "indexUnsubscribedEvents";
    Index_OrderBy["IndexUpdatedEvents"] = "indexUpdatedEvents";
    Index_OrderBy["IndexValue"] = "indexValue";
    Index_OrderBy["Publisher"] = "publisher";
    Index_OrderBy["Publisher__createdAtBlockNumber"] = "publisher__createdAtBlockNumber";
    Index_OrderBy["Publisher__createdAtTimestamp"] = "publisher__createdAtTimestamp";
    Index_OrderBy["Publisher__id"] = "publisher__id";
    Index_OrderBy["Publisher__isSuperApp"] = "publisher__isSuperApp";
    Index_OrderBy["Publisher__updatedAtBlockNumber"] = "publisher__updatedAtBlockNumber";
    Index_OrderBy["Publisher__updatedAtTimestamp"] = "publisher__updatedAtTimestamp";
    Index_OrderBy["Subscriptions"] = "subscriptions";
    Index_OrderBy["Token"] = "token";
    Index_OrderBy["Token__createdAtBlockNumber"] = "token__createdAtBlockNumber";
    Index_OrderBy["Token__createdAtTimestamp"] = "token__createdAtTimestamp";
    Index_OrderBy["Token__decimals"] = "token__decimals";
    Index_OrderBy["Token__id"] = "token__id";
    Index_OrderBy["Token__isListed"] = "token__isListed";
    Index_OrderBy["Token__isNativeAssetSuperToken"] = "token__isNativeAssetSuperToken";
    Index_OrderBy["Token__isSuperToken"] = "token__isSuperToken";
    Index_OrderBy["Token__name"] = "token__name";
    Index_OrderBy["Token__symbol"] = "token__symbol";
    Index_OrderBy["Token__underlyingAddress"] = "token__underlyingAddress";
    Index_OrderBy["TotalAmountDistributedUntilUpdatedAt"] = "totalAmountDistributedUntilUpdatedAt";
    Index_OrderBy["TotalSubscriptionsWithUnits"] = "totalSubscriptionsWithUnits";
    Index_OrderBy["TotalUnits"] = "totalUnits";
    Index_OrderBy["TotalUnitsApproved"] = "totalUnitsApproved";
    Index_OrderBy["TotalUnitsPending"] = "totalUnitsPending";
    Index_OrderBy["UpdatedAtBlockNumber"] = "updatedAtBlockNumber";
    Index_OrderBy["UpdatedAtTimestamp"] = "updatedAtTimestamp";
})(Index_OrderBy || (exports.Index_OrderBy = Index_OrderBy = {}));
var InstantDistributionUpdatedEvent_OrderBy;
(function (InstantDistributionUpdatedEvent_OrderBy) {
    InstantDistributionUpdatedEvent_OrderBy["ActualAmount"] = "actualAmount";
    InstantDistributionUpdatedEvent_OrderBy["Addresses"] = "addresses";
    InstantDistributionUpdatedEvent_OrderBy["BlockNumber"] = "blockNumber";
    InstantDistributionUpdatedEvent_OrderBy["GasPrice"] = "gasPrice";
    InstantDistributionUpdatedEvent_OrderBy["GasUsed"] = "gasUsed";
    InstantDistributionUpdatedEvent_OrderBy["Id"] = "id";
    InstantDistributionUpdatedEvent_OrderBy["LogIndex"] = "logIndex";
    InstantDistributionUpdatedEvent_OrderBy["Name"] = "name";
    InstantDistributionUpdatedEvent_OrderBy["Operator"] = "operator";
    InstantDistributionUpdatedEvent_OrderBy["Order"] = "order";
    InstantDistributionUpdatedEvent_OrderBy["Pool"] = "pool";
    InstantDistributionUpdatedEvent_OrderBy["PoolDistributor"] = "poolDistributor";
    InstantDistributionUpdatedEvent_OrderBy["PoolDistributor__createdAtBlockNumber"] = "poolDistributor__createdAtBlockNumber";
    InstantDistributionUpdatedEvent_OrderBy["PoolDistributor__createdAtTimestamp"] = "poolDistributor__createdAtTimestamp";
    InstantDistributionUpdatedEvent_OrderBy["PoolDistributor__flowRate"] = "poolDistributor__flowRate";
    InstantDistributionUpdatedEvent_OrderBy["PoolDistributor__id"] = "poolDistributor__id";
    InstantDistributionUpdatedEvent_OrderBy["PoolDistributor__totalAmountDistributedUntilUpdatedAt"] = "poolDistributor__totalAmountDistributedUntilUpdatedAt";
    InstantDistributionUpdatedEvent_OrderBy["PoolDistributor__totalAmountFlowedDistributedUntilUpdatedAt"] = "poolDistributor__totalAmountFlowedDistributedUntilUpdatedAt";
    InstantDistributionUpdatedEvent_OrderBy["PoolDistributor__totalAmountInstantlyDistributedUntilUpdatedAt"] = "poolDistributor__totalAmountInstantlyDistributedUntilUpdatedAt";
    InstantDistributionUpdatedEvent_OrderBy["PoolDistributor__totalBuffer"] = "poolDistributor__totalBuffer";
    InstantDistributionUpdatedEvent_OrderBy["PoolDistributor__updatedAtBlockNumber"] = "poolDistributor__updatedAtBlockNumber";
    InstantDistributionUpdatedEvent_OrderBy["PoolDistributor__updatedAtTimestamp"] = "poolDistributor__updatedAtTimestamp";
    InstantDistributionUpdatedEvent_OrderBy["Pool__adjustmentFlowRate"] = "pool__adjustmentFlowRate";
    InstantDistributionUpdatedEvent_OrderBy["Pool__createdAtBlockNumber"] = "pool__createdAtBlockNumber";
    InstantDistributionUpdatedEvent_OrderBy["Pool__createdAtTimestamp"] = "pool__createdAtTimestamp";
    InstantDistributionUpdatedEvent_OrderBy["Pool__flowRate"] = "pool__flowRate";
    InstantDistributionUpdatedEvent_OrderBy["Pool__id"] = "pool__id";
    InstantDistributionUpdatedEvent_OrderBy["Pool__totalAmountDistributedUntilUpdatedAt"] = "pool__totalAmountDistributedUntilUpdatedAt";
    InstantDistributionUpdatedEvent_OrderBy["Pool__totalAmountFlowedDistributedUntilUpdatedAt"] = "pool__totalAmountFlowedDistributedUntilUpdatedAt";
    InstantDistributionUpdatedEvent_OrderBy["Pool__totalAmountInstantlyDistributedUntilUpdatedAt"] = "pool__totalAmountInstantlyDistributedUntilUpdatedAt";
    InstantDistributionUpdatedEvent_OrderBy["Pool__totalBuffer"] = "pool__totalBuffer";
    InstantDistributionUpdatedEvent_OrderBy["Pool__totalConnectedMembers"] = "pool__totalConnectedMembers";
    InstantDistributionUpdatedEvent_OrderBy["Pool__totalConnectedUnits"] = "pool__totalConnectedUnits";
    InstantDistributionUpdatedEvent_OrderBy["Pool__totalDisconnectedMembers"] = "pool__totalDisconnectedMembers";
    InstantDistributionUpdatedEvent_OrderBy["Pool__totalDisconnectedUnits"] = "pool__totalDisconnectedUnits";
    InstantDistributionUpdatedEvent_OrderBy["Pool__totalMembers"] = "pool__totalMembers";
    InstantDistributionUpdatedEvent_OrderBy["Pool__totalUnits"] = "pool__totalUnits";
    InstantDistributionUpdatedEvent_OrderBy["Pool__updatedAtBlockNumber"] = "pool__updatedAtBlockNumber";
    InstantDistributionUpdatedEvent_OrderBy["Pool__updatedAtTimestamp"] = "pool__updatedAtTimestamp";
    InstantDistributionUpdatedEvent_OrderBy["RequestedAmount"] = "requestedAmount";
    InstantDistributionUpdatedEvent_OrderBy["Timestamp"] = "timestamp";
    InstantDistributionUpdatedEvent_OrderBy["Token"] = "token";
    InstantDistributionUpdatedEvent_OrderBy["TransactionHash"] = "transactionHash";
    InstantDistributionUpdatedEvent_OrderBy["UserData"] = "userData";
})(InstantDistributionUpdatedEvent_OrderBy || (exports.InstantDistributionUpdatedEvent_OrderBy = InstantDistributionUpdatedEvent_OrderBy = {}));
var JailEvent_OrderBy;
(function (JailEvent_OrderBy) {
    JailEvent_OrderBy["Addresses"] = "addresses";
    JailEvent_OrderBy["App"] = "app";
    JailEvent_OrderBy["BlockNumber"] = "blockNumber";
    JailEvent_OrderBy["GasPrice"] = "gasPrice";
    JailEvent_OrderBy["GasUsed"] = "gasUsed";
    JailEvent_OrderBy["Id"] = "id";
    JailEvent_OrderBy["LogIndex"] = "logIndex";
    JailEvent_OrderBy["Name"] = "name";
    JailEvent_OrderBy["Order"] = "order";
    JailEvent_OrderBy["Reason"] = "reason";
    JailEvent_OrderBy["Timestamp"] = "timestamp";
    JailEvent_OrderBy["TransactionHash"] = "transactionHash";
})(JailEvent_OrderBy || (exports.JailEvent_OrderBy = JailEvent_OrderBy = {}));
var MemberUnitsUpdatedEvent_OrderBy;
(function (MemberUnitsUpdatedEvent_OrderBy) {
    MemberUnitsUpdatedEvent_OrderBy["Addresses"] = "addresses";
    MemberUnitsUpdatedEvent_OrderBy["BlockNumber"] = "blockNumber";
    MemberUnitsUpdatedEvent_OrderBy["GasPrice"] = "gasPrice";
    MemberUnitsUpdatedEvent_OrderBy["GasUsed"] = "gasUsed";
    MemberUnitsUpdatedEvent_OrderBy["Id"] = "id";
    MemberUnitsUpdatedEvent_OrderBy["LogIndex"] = "logIndex";
    MemberUnitsUpdatedEvent_OrderBy["Name"] = "name";
    MemberUnitsUpdatedEvent_OrderBy["OldUnits"] = "oldUnits";
    MemberUnitsUpdatedEvent_OrderBy["Order"] = "order";
    MemberUnitsUpdatedEvent_OrderBy["Pool"] = "pool";
    MemberUnitsUpdatedEvent_OrderBy["PoolMember"] = "poolMember";
    MemberUnitsUpdatedEvent_OrderBy["PoolMember__createdAtBlockNumber"] = "poolMember__createdAtBlockNumber";
    MemberUnitsUpdatedEvent_OrderBy["PoolMember__createdAtTimestamp"] = "poolMember__createdAtTimestamp";
    MemberUnitsUpdatedEvent_OrderBy["PoolMember__id"] = "poolMember__id";
    MemberUnitsUpdatedEvent_OrderBy["PoolMember__isConnected"] = "poolMember__isConnected";
    MemberUnitsUpdatedEvent_OrderBy["PoolMember__totalAmountClaimed"] = "poolMember__totalAmountClaimed";
    MemberUnitsUpdatedEvent_OrderBy["PoolMember__units"] = "poolMember__units";
    MemberUnitsUpdatedEvent_OrderBy["PoolMember__updatedAtBlockNumber"] = "poolMember__updatedAtBlockNumber";
    MemberUnitsUpdatedEvent_OrderBy["PoolMember__updatedAtTimestamp"] = "poolMember__updatedAtTimestamp";
    MemberUnitsUpdatedEvent_OrderBy["Pool__adjustmentFlowRate"] = "pool__adjustmentFlowRate";
    MemberUnitsUpdatedEvent_OrderBy["Pool__createdAtBlockNumber"] = "pool__createdAtBlockNumber";
    MemberUnitsUpdatedEvent_OrderBy["Pool__createdAtTimestamp"] = "pool__createdAtTimestamp";
    MemberUnitsUpdatedEvent_OrderBy["Pool__flowRate"] = "pool__flowRate";
    MemberUnitsUpdatedEvent_OrderBy["Pool__id"] = "pool__id";
    MemberUnitsUpdatedEvent_OrderBy["Pool__totalAmountDistributedUntilUpdatedAt"] = "pool__totalAmountDistributedUntilUpdatedAt";
    MemberUnitsUpdatedEvent_OrderBy["Pool__totalAmountFlowedDistributedUntilUpdatedAt"] = "pool__totalAmountFlowedDistributedUntilUpdatedAt";
    MemberUnitsUpdatedEvent_OrderBy["Pool__totalAmountInstantlyDistributedUntilUpdatedAt"] = "pool__totalAmountInstantlyDistributedUntilUpdatedAt";
    MemberUnitsUpdatedEvent_OrderBy["Pool__totalBuffer"] = "pool__totalBuffer";
    MemberUnitsUpdatedEvent_OrderBy["Pool__totalConnectedMembers"] = "pool__totalConnectedMembers";
    MemberUnitsUpdatedEvent_OrderBy["Pool__totalConnectedUnits"] = "pool__totalConnectedUnits";
    MemberUnitsUpdatedEvent_OrderBy["Pool__totalDisconnectedMembers"] = "pool__totalDisconnectedMembers";
    MemberUnitsUpdatedEvent_OrderBy["Pool__totalDisconnectedUnits"] = "pool__totalDisconnectedUnits";
    MemberUnitsUpdatedEvent_OrderBy["Pool__totalMembers"] = "pool__totalMembers";
    MemberUnitsUpdatedEvent_OrderBy["Pool__totalUnits"] = "pool__totalUnits";
    MemberUnitsUpdatedEvent_OrderBy["Pool__updatedAtBlockNumber"] = "pool__updatedAtBlockNumber";
    MemberUnitsUpdatedEvent_OrderBy["Pool__updatedAtTimestamp"] = "pool__updatedAtTimestamp";
    MemberUnitsUpdatedEvent_OrderBy["Timestamp"] = "timestamp";
    MemberUnitsUpdatedEvent_OrderBy["Token"] = "token";
    MemberUnitsUpdatedEvent_OrderBy["TransactionHash"] = "transactionHash";
    MemberUnitsUpdatedEvent_OrderBy["Units"] = "units";
})(MemberUnitsUpdatedEvent_OrderBy || (exports.MemberUnitsUpdatedEvent_OrderBy = MemberUnitsUpdatedEvent_OrderBy = {}));
var MetadataUpdateEvent_OrderBy;
(function (MetadataUpdateEvent_OrderBy) {
    MetadataUpdateEvent_OrderBy["Addresses"] = "addresses";
    MetadataUpdateEvent_OrderBy["BlockNumber"] = "blockNumber";
    MetadataUpdateEvent_OrderBy["GasPrice"] = "gasPrice";
    MetadataUpdateEvent_OrderBy["GasUsed"] = "gasUsed";
    MetadataUpdateEvent_OrderBy["Id"] = "id";
    MetadataUpdateEvent_OrderBy["LogIndex"] = "logIndex";
    MetadataUpdateEvent_OrderBy["Name"] = "name";
    MetadataUpdateEvent_OrderBy["Order"] = "order";
    MetadataUpdateEvent_OrderBy["Timestamp"] = "timestamp";
    MetadataUpdateEvent_OrderBy["TokenId"] = "tokenId";
    MetadataUpdateEvent_OrderBy["TransactionHash"] = "transactionHash";
})(MetadataUpdateEvent_OrderBy || (exports.MetadataUpdateEvent_OrderBy = MetadataUpdateEvent_OrderBy = {}));
var MintedEvent_OrderBy;
(function (MintedEvent_OrderBy) {
    MintedEvent_OrderBy["Addresses"] = "addresses";
    MintedEvent_OrderBy["Amount"] = "amount";
    MintedEvent_OrderBy["BlockNumber"] = "blockNumber";
    MintedEvent_OrderBy["Data"] = "data";
    MintedEvent_OrderBy["GasPrice"] = "gasPrice";
    MintedEvent_OrderBy["GasUsed"] = "gasUsed";
    MintedEvent_OrderBy["Id"] = "id";
    MintedEvent_OrderBy["LogIndex"] = "logIndex";
    MintedEvent_OrderBy["Name"] = "name";
    MintedEvent_OrderBy["Operator"] = "operator";
    MintedEvent_OrderBy["OperatorData"] = "operatorData";
    MintedEvent_OrderBy["Order"] = "order";
    MintedEvent_OrderBy["Timestamp"] = "timestamp";
    MintedEvent_OrderBy["To"] = "to";
    MintedEvent_OrderBy["Token"] = "token";
    MintedEvent_OrderBy["TransactionHash"] = "transactionHash";
})(MintedEvent_OrderBy || (exports.MintedEvent_OrderBy = MintedEvent_OrderBy = {}));
var NewPicEvent_OrderBy;
(function (NewPicEvent_OrderBy) {
    NewPicEvent_OrderBy["Addresses"] = "addresses";
    NewPicEvent_OrderBy["BlockNumber"] = "blockNumber";
    NewPicEvent_OrderBy["Bond"] = "bond";
    NewPicEvent_OrderBy["ExitRate"] = "exitRate";
    NewPicEvent_OrderBy["GasPrice"] = "gasPrice";
    NewPicEvent_OrderBy["GasUsed"] = "gasUsed";
    NewPicEvent_OrderBy["Id"] = "id";
    NewPicEvent_OrderBy["LogIndex"] = "logIndex";
    NewPicEvent_OrderBy["Name"] = "name";
    NewPicEvent_OrderBy["Order"] = "order";
    NewPicEvent_OrderBy["Pic"] = "pic";
    NewPicEvent_OrderBy["Timestamp"] = "timestamp";
    NewPicEvent_OrderBy["Token"] = "token";
    NewPicEvent_OrderBy["TransactionHash"] = "transactionHash";
})(NewPicEvent_OrderBy || (exports.NewPicEvent_OrderBy = NewPicEvent_OrderBy = {}));
/** Defines the order direction, either ascending or descending */
var OrderDirection;
(function (OrderDirection) {
    OrderDirection["Asc"] = "asc";
    OrderDirection["Desc"] = "desc";
})(OrderDirection || (exports.OrderDirection = OrderDirection = {}));
var PppConfigurationChangedEvent_OrderBy;
(function (PppConfigurationChangedEvent_OrderBy) {
    PppConfigurationChangedEvent_OrderBy["Addresses"] = "addresses";
    PppConfigurationChangedEvent_OrderBy["BlockNumber"] = "blockNumber";
    PppConfigurationChangedEvent_OrderBy["GasPrice"] = "gasPrice";
    PppConfigurationChangedEvent_OrderBy["GasUsed"] = "gasUsed";
    PppConfigurationChangedEvent_OrderBy["GovernanceAddress"] = "governanceAddress";
    PppConfigurationChangedEvent_OrderBy["Host"] = "host";
    PppConfigurationChangedEvent_OrderBy["Id"] = "id";
    PppConfigurationChangedEvent_OrderBy["IsKeySet"] = "isKeySet";
    PppConfigurationChangedEvent_OrderBy["LiquidationPeriod"] = "liquidationPeriod";
    PppConfigurationChangedEvent_OrderBy["LogIndex"] = "logIndex";
    PppConfigurationChangedEvent_OrderBy["Name"] = "name";
    PppConfigurationChangedEvent_OrderBy["Order"] = "order";
    PppConfigurationChangedEvent_OrderBy["PatricianPeriod"] = "patricianPeriod";
    PppConfigurationChangedEvent_OrderBy["SuperToken"] = "superToken";
    PppConfigurationChangedEvent_OrderBy["Timestamp"] = "timestamp";
    PppConfigurationChangedEvent_OrderBy["TransactionHash"] = "transactionHash";
})(PppConfigurationChangedEvent_OrderBy || (exports.PppConfigurationChangedEvent_OrderBy = PppConfigurationChangedEvent_OrderBy = {}));
var PoolConnectionUpdatedEvent_OrderBy;
(function (PoolConnectionUpdatedEvent_OrderBy) {
    PoolConnectionUpdatedEvent_OrderBy["Addresses"] = "addresses";
    PoolConnectionUpdatedEvent_OrderBy["BlockNumber"] = "blockNumber";
    PoolConnectionUpdatedEvent_OrderBy["Connected"] = "connected";
    PoolConnectionUpdatedEvent_OrderBy["GasPrice"] = "gasPrice";
    PoolConnectionUpdatedEvent_OrderBy["GasUsed"] = "gasUsed";
    PoolConnectionUpdatedEvent_OrderBy["Id"] = "id";
    PoolConnectionUpdatedEvent_OrderBy["LogIndex"] = "logIndex";
    PoolConnectionUpdatedEvent_OrderBy["Name"] = "name";
    PoolConnectionUpdatedEvent_OrderBy["Order"] = "order";
    PoolConnectionUpdatedEvent_OrderBy["Pool"] = "pool";
    PoolConnectionUpdatedEvent_OrderBy["PoolMember"] = "poolMember";
    PoolConnectionUpdatedEvent_OrderBy["PoolMember__createdAtBlockNumber"] = "poolMember__createdAtBlockNumber";
    PoolConnectionUpdatedEvent_OrderBy["PoolMember__createdAtTimestamp"] = "poolMember__createdAtTimestamp";
    PoolConnectionUpdatedEvent_OrderBy["PoolMember__id"] = "poolMember__id";
    PoolConnectionUpdatedEvent_OrderBy["PoolMember__isConnected"] = "poolMember__isConnected";
    PoolConnectionUpdatedEvent_OrderBy["PoolMember__totalAmountClaimed"] = "poolMember__totalAmountClaimed";
    PoolConnectionUpdatedEvent_OrderBy["PoolMember__units"] = "poolMember__units";
    PoolConnectionUpdatedEvent_OrderBy["PoolMember__updatedAtBlockNumber"] = "poolMember__updatedAtBlockNumber";
    PoolConnectionUpdatedEvent_OrderBy["PoolMember__updatedAtTimestamp"] = "poolMember__updatedAtTimestamp";
    PoolConnectionUpdatedEvent_OrderBy["Pool__adjustmentFlowRate"] = "pool__adjustmentFlowRate";
    PoolConnectionUpdatedEvent_OrderBy["Pool__createdAtBlockNumber"] = "pool__createdAtBlockNumber";
    PoolConnectionUpdatedEvent_OrderBy["Pool__createdAtTimestamp"] = "pool__createdAtTimestamp";
    PoolConnectionUpdatedEvent_OrderBy["Pool__flowRate"] = "pool__flowRate";
    PoolConnectionUpdatedEvent_OrderBy["Pool__id"] = "pool__id";
    PoolConnectionUpdatedEvent_OrderBy["Pool__totalAmountDistributedUntilUpdatedAt"] = "pool__totalAmountDistributedUntilUpdatedAt";
    PoolConnectionUpdatedEvent_OrderBy["Pool__totalAmountFlowedDistributedUntilUpdatedAt"] = "pool__totalAmountFlowedDistributedUntilUpdatedAt";
    PoolConnectionUpdatedEvent_OrderBy["Pool__totalAmountInstantlyDistributedUntilUpdatedAt"] = "pool__totalAmountInstantlyDistributedUntilUpdatedAt";
    PoolConnectionUpdatedEvent_OrderBy["Pool__totalBuffer"] = "pool__totalBuffer";
    PoolConnectionUpdatedEvent_OrderBy["Pool__totalConnectedMembers"] = "pool__totalConnectedMembers";
    PoolConnectionUpdatedEvent_OrderBy["Pool__totalConnectedUnits"] = "pool__totalConnectedUnits";
    PoolConnectionUpdatedEvent_OrderBy["Pool__totalDisconnectedMembers"] = "pool__totalDisconnectedMembers";
    PoolConnectionUpdatedEvent_OrderBy["Pool__totalDisconnectedUnits"] = "pool__totalDisconnectedUnits";
    PoolConnectionUpdatedEvent_OrderBy["Pool__totalMembers"] = "pool__totalMembers";
    PoolConnectionUpdatedEvent_OrderBy["Pool__totalUnits"] = "pool__totalUnits";
    PoolConnectionUpdatedEvent_OrderBy["Pool__updatedAtBlockNumber"] = "pool__updatedAtBlockNumber";
    PoolConnectionUpdatedEvent_OrderBy["Pool__updatedAtTimestamp"] = "pool__updatedAtTimestamp";
    PoolConnectionUpdatedEvent_OrderBy["Timestamp"] = "timestamp";
    PoolConnectionUpdatedEvent_OrderBy["Token"] = "token";
    PoolConnectionUpdatedEvent_OrderBy["TransactionHash"] = "transactionHash";
    PoolConnectionUpdatedEvent_OrderBy["UserData"] = "userData";
})(PoolConnectionUpdatedEvent_OrderBy || (exports.PoolConnectionUpdatedEvent_OrderBy = PoolConnectionUpdatedEvent_OrderBy = {}));
var PoolCreatedEvent_OrderBy;
(function (PoolCreatedEvent_OrderBy) {
    PoolCreatedEvent_OrderBy["Addresses"] = "addresses";
    PoolCreatedEvent_OrderBy["Admin"] = "admin";
    PoolCreatedEvent_OrderBy["BlockNumber"] = "blockNumber";
    PoolCreatedEvent_OrderBy["Caller"] = "caller";
    PoolCreatedEvent_OrderBy["GasPrice"] = "gasPrice";
    PoolCreatedEvent_OrderBy["GasUsed"] = "gasUsed";
    PoolCreatedEvent_OrderBy["Id"] = "id";
    PoolCreatedEvent_OrderBy["LogIndex"] = "logIndex";
    PoolCreatedEvent_OrderBy["Name"] = "name";
    PoolCreatedEvent_OrderBy["Order"] = "order";
    PoolCreatedEvent_OrderBy["Pool"] = "pool";
    PoolCreatedEvent_OrderBy["Pool__adjustmentFlowRate"] = "pool__adjustmentFlowRate";
    PoolCreatedEvent_OrderBy["Pool__createdAtBlockNumber"] = "pool__createdAtBlockNumber";
    PoolCreatedEvent_OrderBy["Pool__createdAtTimestamp"] = "pool__createdAtTimestamp";
    PoolCreatedEvent_OrderBy["Pool__flowRate"] = "pool__flowRate";
    PoolCreatedEvent_OrderBy["Pool__id"] = "pool__id";
    PoolCreatedEvent_OrderBy["Pool__totalAmountDistributedUntilUpdatedAt"] = "pool__totalAmountDistributedUntilUpdatedAt";
    PoolCreatedEvent_OrderBy["Pool__totalAmountFlowedDistributedUntilUpdatedAt"] = "pool__totalAmountFlowedDistributedUntilUpdatedAt";
    PoolCreatedEvent_OrderBy["Pool__totalAmountInstantlyDistributedUntilUpdatedAt"] = "pool__totalAmountInstantlyDistributedUntilUpdatedAt";
    PoolCreatedEvent_OrderBy["Pool__totalBuffer"] = "pool__totalBuffer";
    PoolCreatedEvent_OrderBy["Pool__totalConnectedMembers"] = "pool__totalConnectedMembers";
    PoolCreatedEvent_OrderBy["Pool__totalConnectedUnits"] = "pool__totalConnectedUnits";
    PoolCreatedEvent_OrderBy["Pool__totalDisconnectedMembers"] = "pool__totalDisconnectedMembers";
    PoolCreatedEvent_OrderBy["Pool__totalDisconnectedUnits"] = "pool__totalDisconnectedUnits";
    PoolCreatedEvent_OrderBy["Pool__totalMembers"] = "pool__totalMembers";
    PoolCreatedEvent_OrderBy["Pool__totalUnits"] = "pool__totalUnits";
    PoolCreatedEvent_OrderBy["Pool__updatedAtBlockNumber"] = "pool__updatedAtBlockNumber";
    PoolCreatedEvent_OrderBy["Pool__updatedAtTimestamp"] = "pool__updatedAtTimestamp";
    PoolCreatedEvent_OrderBy["Timestamp"] = "timestamp";
    PoolCreatedEvent_OrderBy["Token"] = "token";
    PoolCreatedEvent_OrderBy["TransactionHash"] = "transactionHash";
})(PoolCreatedEvent_OrderBy || (exports.PoolCreatedEvent_OrderBy = PoolCreatedEvent_OrderBy = {}));
var PoolDistributor_OrderBy;
(function (PoolDistributor_OrderBy) {
    PoolDistributor_OrderBy["Account"] = "account";
    PoolDistributor_OrderBy["Account__createdAtBlockNumber"] = "account__createdAtBlockNumber";
    PoolDistributor_OrderBy["Account__createdAtTimestamp"] = "account__createdAtTimestamp";
    PoolDistributor_OrderBy["Account__id"] = "account__id";
    PoolDistributor_OrderBy["Account__isSuperApp"] = "account__isSuperApp";
    PoolDistributor_OrderBy["Account__updatedAtBlockNumber"] = "account__updatedAtBlockNumber";
    PoolDistributor_OrderBy["Account__updatedAtTimestamp"] = "account__updatedAtTimestamp";
    PoolDistributor_OrderBy["BufferAdjustedEvents"] = "bufferAdjustedEvents";
    PoolDistributor_OrderBy["CreatedAtBlockNumber"] = "createdAtBlockNumber";
    PoolDistributor_OrderBy["CreatedAtTimestamp"] = "createdAtTimestamp";
    PoolDistributor_OrderBy["FlowDistributionUpdatedEvents"] = "flowDistributionUpdatedEvents";
    PoolDistributor_OrderBy["FlowRate"] = "flowRate";
    PoolDistributor_OrderBy["Id"] = "id";
    PoolDistributor_OrderBy["InstantDistributionUpdatedEvents"] = "instantDistributionUpdatedEvents";
    PoolDistributor_OrderBy["Pool"] = "pool";
    PoolDistributor_OrderBy["Pool__adjustmentFlowRate"] = "pool__adjustmentFlowRate";
    PoolDistributor_OrderBy["Pool__createdAtBlockNumber"] = "pool__createdAtBlockNumber";
    PoolDistributor_OrderBy["Pool__createdAtTimestamp"] = "pool__createdAtTimestamp";
    PoolDistributor_OrderBy["Pool__flowRate"] = "pool__flowRate";
    PoolDistributor_OrderBy["Pool__id"] = "pool__id";
    PoolDistributor_OrderBy["Pool__totalAmountDistributedUntilUpdatedAt"] = "pool__totalAmountDistributedUntilUpdatedAt";
    PoolDistributor_OrderBy["Pool__totalAmountFlowedDistributedUntilUpdatedAt"] = "pool__totalAmountFlowedDistributedUntilUpdatedAt";
    PoolDistributor_OrderBy["Pool__totalAmountInstantlyDistributedUntilUpdatedAt"] = "pool__totalAmountInstantlyDistributedUntilUpdatedAt";
    PoolDistributor_OrderBy["Pool__totalBuffer"] = "pool__totalBuffer";
    PoolDistributor_OrderBy["Pool__totalConnectedMembers"] = "pool__totalConnectedMembers";
    PoolDistributor_OrderBy["Pool__totalConnectedUnits"] = "pool__totalConnectedUnits";
    PoolDistributor_OrderBy["Pool__totalDisconnectedMembers"] = "pool__totalDisconnectedMembers";
    PoolDistributor_OrderBy["Pool__totalDisconnectedUnits"] = "pool__totalDisconnectedUnits";
    PoolDistributor_OrderBy["Pool__totalMembers"] = "pool__totalMembers";
    PoolDistributor_OrderBy["Pool__totalUnits"] = "pool__totalUnits";
    PoolDistributor_OrderBy["Pool__updatedAtBlockNumber"] = "pool__updatedAtBlockNumber";
    PoolDistributor_OrderBy["Pool__updatedAtTimestamp"] = "pool__updatedAtTimestamp";
    PoolDistributor_OrderBy["TotalAmountDistributedUntilUpdatedAt"] = "totalAmountDistributedUntilUpdatedAt";
    PoolDistributor_OrderBy["TotalAmountFlowedDistributedUntilUpdatedAt"] = "totalAmountFlowedDistributedUntilUpdatedAt";
    PoolDistributor_OrderBy["TotalAmountInstantlyDistributedUntilUpdatedAt"] = "totalAmountInstantlyDistributedUntilUpdatedAt";
    PoolDistributor_OrderBy["TotalBuffer"] = "totalBuffer";
    PoolDistributor_OrderBy["UpdatedAtBlockNumber"] = "updatedAtBlockNumber";
    PoolDistributor_OrderBy["UpdatedAtTimestamp"] = "updatedAtTimestamp";
})(PoolDistributor_OrderBy || (exports.PoolDistributor_OrderBy = PoolDistributor_OrderBy = {}));
var PoolMember_OrderBy;
(function (PoolMember_OrderBy) {
    PoolMember_OrderBy["Account"] = "account";
    PoolMember_OrderBy["Account__createdAtBlockNumber"] = "account__createdAtBlockNumber";
    PoolMember_OrderBy["Account__createdAtTimestamp"] = "account__createdAtTimestamp";
    PoolMember_OrderBy["Account__id"] = "account__id";
    PoolMember_OrderBy["Account__isSuperApp"] = "account__isSuperApp";
    PoolMember_OrderBy["Account__updatedAtBlockNumber"] = "account__updatedAtBlockNumber";
    PoolMember_OrderBy["Account__updatedAtTimestamp"] = "account__updatedAtTimestamp";
    PoolMember_OrderBy["CreatedAtBlockNumber"] = "createdAtBlockNumber";
    PoolMember_OrderBy["CreatedAtTimestamp"] = "createdAtTimestamp";
    PoolMember_OrderBy["DistributionClaimedEvents"] = "distributionClaimedEvents";
    PoolMember_OrderBy["Id"] = "id";
    PoolMember_OrderBy["IsConnected"] = "isConnected";
    PoolMember_OrderBy["MemberUnitsUpdatedEvents"] = "memberUnitsUpdatedEvents";
    PoolMember_OrderBy["Pool"] = "pool";
    PoolMember_OrderBy["PoolConnectionUpdatedEvents"] = "poolConnectionUpdatedEvents";
    PoolMember_OrderBy["Pool__adjustmentFlowRate"] = "pool__adjustmentFlowRate";
    PoolMember_OrderBy["Pool__createdAtBlockNumber"] = "pool__createdAtBlockNumber";
    PoolMember_OrderBy["Pool__createdAtTimestamp"] = "pool__createdAtTimestamp";
    PoolMember_OrderBy["Pool__flowRate"] = "pool__flowRate";
    PoolMember_OrderBy["Pool__id"] = "pool__id";
    PoolMember_OrderBy["Pool__totalAmountDistributedUntilUpdatedAt"] = "pool__totalAmountDistributedUntilUpdatedAt";
    PoolMember_OrderBy["Pool__totalAmountFlowedDistributedUntilUpdatedAt"] = "pool__totalAmountFlowedDistributedUntilUpdatedAt";
    PoolMember_OrderBy["Pool__totalAmountInstantlyDistributedUntilUpdatedAt"] = "pool__totalAmountInstantlyDistributedUntilUpdatedAt";
    PoolMember_OrderBy["Pool__totalBuffer"] = "pool__totalBuffer";
    PoolMember_OrderBy["Pool__totalConnectedMembers"] = "pool__totalConnectedMembers";
    PoolMember_OrderBy["Pool__totalConnectedUnits"] = "pool__totalConnectedUnits";
    PoolMember_OrderBy["Pool__totalDisconnectedMembers"] = "pool__totalDisconnectedMembers";
    PoolMember_OrderBy["Pool__totalDisconnectedUnits"] = "pool__totalDisconnectedUnits";
    PoolMember_OrderBy["Pool__totalMembers"] = "pool__totalMembers";
    PoolMember_OrderBy["Pool__totalUnits"] = "pool__totalUnits";
    PoolMember_OrderBy["Pool__updatedAtBlockNumber"] = "pool__updatedAtBlockNumber";
    PoolMember_OrderBy["Pool__updatedAtTimestamp"] = "pool__updatedAtTimestamp";
    PoolMember_OrderBy["TotalAmountClaimed"] = "totalAmountClaimed";
    PoolMember_OrderBy["Units"] = "units";
    PoolMember_OrderBy["UpdatedAtBlockNumber"] = "updatedAtBlockNumber";
    PoolMember_OrderBy["UpdatedAtTimestamp"] = "updatedAtTimestamp";
})(PoolMember_OrderBy || (exports.PoolMember_OrderBy = PoolMember_OrderBy = {}));
var Pool_OrderBy;
(function (Pool_OrderBy) {
    Pool_OrderBy["AdjustmentFlowRate"] = "adjustmentFlowRate";
    Pool_OrderBy["Admin"] = "admin";
    Pool_OrderBy["Admin__createdAtBlockNumber"] = "admin__createdAtBlockNumber";
    Pool_OrderBy["Admin__createdAtTimestamp"] = "admin__createdAtTimestamp";
    Pool_OrderBy["Admin__id"] = "admin__id";
    Pool_OrderBy["Admin__isSuperApp"] = "admin__isSuperApp";
    Pool_OrderBy["Admin__updatedAtBlockNumber"] = "admin__updatedAtBlockNumber";
    Pool_OrderBy["Admin__updatedAtTimestamp"] = "admin__updatedAtTimestamp";
    Pool_OrderBy["BufferAdjustedEvents"] = "bufferAdjustedEvents";
    Pool_OrderBy["CreatedAtBlockNumber"] = "createdAtBlockNumber";
    Pool_OrderBy["CreatedAtTimestamp"] = "createdAtTimestamp";
    Pool_OrderBy["DistributionClaimedEvents"] = "distributionClaimedEvents";
    Pool_OrderBy["FlowDistributionUpdatedEvents"] = "flowDistributionUpdatedEvents";
    Pool_OrderBy["FlowRate"] = "flowRate";
    Pool_OrderBy["Id"] = "id";
    Pool_OrderBy["InstantDistributionUpdatedEvents"] = "instantDistributionUpdatedEvents";
    Pool_OrderBy["MemberUnitsUpdatedEvents"] = "memberUnitsUpdatedEvents";
    Pool_OrderBy["PoolConnectionUpdatedEvents"] = "poolConnectionUpdatedEvents";
    Pool_OrderBy["PoolCreatedEvent"] = "poolCreatedEvent";
    Pool_OrderBy["PoolCreatedEvent__admin"] = "poolCreatedEvent__admin";
    Pool_OrderBy["PoolCreatedEvent__blockNumber"] = "poolCreatedEvent__blockNumber";
    Pool_OrderBy["PoolCreatedEvent__caller"] = "poolCreatedEvent__caller";
    Pool_OrderBy["PoolCreatedEvent__gasPrice"] = "poolCreatedEvent__gasPrice";
    Pool_OrderBy["PoolCreatedEvent__gasUsed"] = "poolCreatedEvent__gasUsed";
    Pool_OrderBy["PoolCreatedEvent__id"] = "poolCreatedEvent__id";
    Pool_OrderBy["PoolCreatedEvent__logIndex"] = "poolCreatedEvent__logIndex";
    Pool_OrderBy["PoolCreatedEvent__name"] = "poolCreatedEvent__name";
    Pool_OrderBy["PoolCreatedEvent__order"] = "poolCreatedEvent__order";
    Pool_OrderBy["PoolCreatedEvent__timestamp"] = "poolCreatedEvent__timestamp";
    Pool_OrderBy["PoolCreatedEvent__token"] = "poolCreatedEvent__token";
    Pool_OrderBy["PoolCreatedEvent__transactionHash"] = "poolCreatedEvent__transactionHash";
    Pool_OrderBy["PoolDistributors"] = "poolDistributors";
    Pool_OrderBy["PoolMembers"] = "poolMembers";
    Pool_OrderBy["Token"] = "token";
    Pool_OrderBy["Token__createdAtBlockNumber"] = "token__createdAtBlockNumber";
    Pool_OrderBy["Token__createdAtTimestamp"] = "token__createdAtTimestamp";
    Pool_OrderBy["Token__decimals"] = "token__decimals";
    Pool_OrderBy["Token__id"] = "token__id";
    Pool_OrderBy["Token__isListed"] = "token__isListed";
    Pool_OrderBy["Token__isNativeAssetSuperToken"] = "token__isNativeAssetSuperToken";
    Pool_OrderBy["Token__isSuperToken"] = "token__isSuperToken";
    Pool_OrderBy["Token__name"] = "token__name";
    Pool_OrderBy["Token__symbol"] = "token__symbol";
    Pool_OrderBy["Token__underlyingAddress"] = "token__underlyingAddress";
    Pool_OrderBy["TotalAmountDistributedUntilUpdatedAt"] = "totalAmountDistributedUntilUpdatedAt";
    Pool_OrderBy["TotalAmountFlowedDistributedUntilUpdatedAt"] = "totalAmountFlowedDistributedUntilUpdatedAt";
    Pool_OrderBy["TotalAmountInstantlyDistributedUntilUpdatedAt"] = "totalAmountInstantlyDistributedUntilUpdatedAt";
    Pool_OrderBy["TotalBuffer"] = "totalBuffer";
    Pool_OrderBy["TotalConnectedMembers"] = "totalConnectedMembers";
    Pool_OrderBy["TotalConnectedUnits"] = "totalConnectedUnits";
    Pool_OrderBy["TotalDisconnectedMembers"] = "totalDisconnectedMembers";
    Pool_OrderBy["TotalDisconnectedUnits"] = "totalDisconnectedUnits";
    Pool_OrderBy["TotalMembers"] = "totalMembers";
    Pool_OrderBy["TotalUnits"] = "totalUnits";
    Pool_OrderBy["UpdatedAtBlockNumber"] = "updatedAtBlockNumber";
    Pool_OrderBy["UpdatedAtTimestamp"] = "updatedAtTimestamp";
})(Pool_OrderBy || (exports.Pool_OrderBy = Pool_OrderBy = {}));
var ResolverEntry_OrderBy;
(function (ResolverEntry_OrderBy) {
    ResolverEntry_OrderBy["CreatedAtBlockNumber"] = "createdAtBlockNumber";
    ResolverEntry_OrderBy["CreatedAtTimestamp"] = "createdAtTimestamp";
    ResolverEntry_OrderBy["Id"] = "id";
    ResolverEntry_OrderBy["IsListed"] = "isListed";
    ResolverEntry_OrderBy["IsToken"] = "isToken";
    ResolverEntry_OrderBy["SetEvents"] = "setEvents";
    ResolverEntry_OrderBy["TargetAddress"] = "targetAddress";
    ResolverEntry_OrderBy["UpdatedAtBlockNumber"] = "updatedAtBlockNumber";
    ResolverEntry_OrderBy["UpdatedAtTimestamp"] = "updatedAtTimestamp";
})(ResolverEntry_OrderBy || (exports.ResolverEntry_OrderBy = ResolverEntry_OrderBy = {}));
var RewardAddressChangedEvent_OrderBy;
(function (RewardAddressChangedEvent_OrderBy) {
    RewardAddressChangedEvent_OrderBy["Addresses"] = "addresses";
    RewardAddressChangedEvent_OrderBy["BlockNumber"] = "blockNumber";
    RewardAddressChangedEvent_OrderBy["GasPrice"] = "gasPrice";
    RewardAddressChangedEvent_OrderBy["GasUsed"] = "gasUsed";
    RewardAddressChangedEvent_OrderBy["GovernanceAddress"] = "governanceAddress";
    RewardAddressChangedEvent_OrderBy["Host"] = "host";
    RewardAddressChangedEvent_OrderBy["Id"] = "id";
    RewardAddressChangedEvent_OrderBy["IsKeySet"] = "isKeySet";
    RewardAddressChangedEvent_OrderBy["LogIndex"] = "logIndex";
    RewardAddressChangedEvent_OrderBy["Name"] = "name";
    RewardAddressChangedEvent_OrderBy["Order"] = "order";
    RewardAddressChangedEvent_OrderBy["RewardAddress"] = "rewardAddress";
    RewardAddressChangedEvent_OrderBy["SuperToken"] = "superToken";
    RewardAddressChangedEvent_OrderBy["Timestamp"] = "timestamp";
    RewardAddressChangedEvent_OrderBy["TransactionHash"] = "transactionHash";
})(RewardAddressChangedEvent_OrderBy || (exports.RewardAddressChangedEvent_OrderBy = RewardAddressChangedEvent_OrderBy = {}));
var RoleAdminChangedEvent_OrderBy;
(function (RoleAdminChangedEvent_OrderBy) {
    RoleAdminChangedEvent_OrderBy["Addresses"] = "addresses";
    RoleAdminChangedEvent_OrderBy["BlockNumber"] = "blockNumber";
    RoleAdminChangedEvent_OrderBy["GasPrice"] = "gasPrice";
    RoleAdminChangedEvent_OrderBy["GasUsed"] = "gasUsed";
    RoleAdminChangedEvent_OrderBy["Id"] = "id";
    RoleAdminChangedEvent_OrderBy["LogIndex"] = "logIndex";
    RoleAdminChangedEvent_OrderBy["Name"] = "name";
    RoleAdminChangedEvent_OrderBy["NewAdminRole"] = "newAdminRole";
    RoleAdminChangedEvent_OrderBy["Order"] = "order";
    RoleAdminChangedEvent_OrderBy["PreviousAdminRole"] = "previousAdminRole";
    RoleAdminChangedEvent_OrderBy["Role"] = "role";
    RoleAdminChangedEvent_OrderBy["Timestamp"] = "timestamp";
    RoleAdminChangedEvent_OrderBy["TransactionHash"] = "transactionHash";
})(RoleAdminChangedEvent_OrderBy || (exports.RoleAdminChangedEvent_OrderBy = RoleAdminChangedEvent_OrderBy = {}));
var RoleGrantedEvent_OrderBy;
(function (RoleGrantedEvent_OrderBy) {
    RoleGrantedEvent_OrderBy["Account"] = "account";
    RoleGrantedEvent_OrderBy["Addresses"] = "addresses";
    RoleGrantedEvent_OrderBy["BlockNumber"] = "blockNumber";
    RoleGrantedEvent_OrderBy["GasPrice"] = "gasPrice";
    RoleGrantedEvent_OrderBy["GasUsed"] = "gasUsed";
    RoleGrantedEvent_OrderBy["Id"] = "id";
    RoleGrantedEvent_OrderBy["LogIndex"] = "logIndex";
    RoleGrantedEvent_OrderBy["Name"] = "name";
    RoleGrantedEvent_OrderBy["Order"] = "order";
    RoleGrantedEvent_OrderBy["Role"] = "role";
    RoleGrantedEvent_OrderBy["Sender"] = "sender";
    RoleGrantedEvent_OrderBy["Timestamp"] = "timestamp";
    RoleGrantedEvent_OrderBy["TransactionHash"] = "transactionHash";
})(RoleGrantedEvent_OrderBy || (exports.RoleGrantedEvent_OrderBy = RoleGrantedEvent_OrderBy = {}));
var RoleRevokedEvent_OrderBy;
(function (RoleRevokedEvent_OrderBy) {
    RoleRevokedEvent_OrderBy["Account"] = "account";
    RoleRevokedEvent_OrderBy["Addresses"] = "addresses";
    RoleRevokedEvent_OrderBy["BlockNumber"] = "blockNumber";
    RoleRevokedEvent_OrderBy["GasPrice"] = "gasPrice";
    RoleRevokedEvent_OrderBy["GasUsed"] = "gasUsed";
    RoleRevokedEvent_OrderBy["Id"] = "id";
    RoleRevokedEvent_OrderBy["LogIndex"] = "logIndex";
    RoleRevokedEvent_OrderBy["Name"] = "name";
    RoleRevokedEvent_OrderBy["Order"] = "order";
    RoleRevokedEvent_OrderBy["Role"] = "role";
    RoleRevokedEvent_OrderBy["Sender"] = "sender";
    RoleRevokedEvent_OrderBy["Timestamp"] = "timestamp";
    RoleRevokedEvent_OrderBy["TransactionHash"] = "transactionHash";
})(RoleRevokedEvent_OrderBy || (exports.RoleRevokedEvent_OrderBy = RoleRevokedEvent_OrderBy = {}));
var SfMeta_OrderBy;
(function (SfMeta_OrderBy) {
    SfMeta_OrderBy["BlockNumber"] = "blockNumber";
    SfMeta_OrderBy["Branch"] = "branch";
    SfMeta_OrderBy["Configuration"] = "configuration";
    SfMeta_OrderBy["Id"] = "id";
    SfMeta_OrderBy["Timestamp"] = "timestamp";
})(SfMeta_OrderBy || (exports.SfMeta_OrderBy = SfMeta_OrderBy = {}));
var SentEvent_OrderBy;
(function (SentEvent_OrderBy) {
    SentEvent_OrderBy["Addresses"] = "addresses";
    SentEvent_OrderBy["Amount"] = "amount";
    SentEvent_OrderBy["BlockNumber"] = "blockNumber";
    SentEvent_OrderBy["Data"] = "data";
    SentEvent_OrderBy["From"] = "from";
    SentEvent_OrderBy["GasPrice"] = "gasPrice";
    SentEvent_OrderBy["GasUsed"] = "gasUsed";
    SentEvent_OrderBy["Id"] = "id";
    SentEvent_OrderBy["LogIndex"] = "logIndex";
    SentEvent_OrderBy["Name"] = "name";
    SentEvent_OrderBy["Operator"] = "operator";
    SentEvent_OrderBy["OperatorData"] = "operatorData";
    SentEvent_OrderBy["Order"] = "order";
    SentEvent_OrderBy["Timestamp"] = "timestamp";
    SentEvent_OrderBy["To"] = "to";
    SentEvent_OrderBy["Token"] = "token";
    SentEvent_OrderBy["TransactionHash"] = "transactionHash";
})(SentEvent_OrderBy || (exports.SentEvent_OrderBy = SentEvent_OrderBy = {}));
var SetEvent_OrderBy;
(function (SetEvent_OrderBy) {
    SetEvent_OrderBy["Addresses"] = "addresses";
    SetEvent_OrderBy["BlockNumber"] = "blockNumber";
    SetEvent_OrderBy["GasPrice"] = "gasPrice";
    SetEvent_OrderBy["GasUsed"] = "gasUsed";
    SetEvent_OrderBy["HashedName"] = "hashedName";
    SetEvent_OrderBy["Id"] = "id";
    SetEvent_OrderBy["LogIndex"] = "logIndex";
    SetEvent_OrderBy["Name"] = "name";
    SetEvent_OrderBy["Order"] = "order";
    SetEvent_OrderBy["ResolverEntry"] = "resolverEntry";
    SetEvent_OrderBy["ResolverEntry__createdAtBlockNumber"] = "resolverEntry__createdAtBlockNumber";
    SetEvent_OrderBy["ResolverEntry__createdAtTimestamp"] = "resolverEntry__createdAtTimestamp";
    SetEvent_OrderBy["ResolverEntry__id"] = "resolverEntry__id";
    SetEvent_OrderBy["ResolverEntry__isListed"] = "resolverEntry__isListed";
    SetEvent_OrderBy["ResolverEntry__isToken"] = "resolverEntry__isToken";
    SetEvent_OrderBy["ResolverEntry__targetAddress"] = "resolverEntry__targetAddress";
    SetEvent_OrderBy["ResolverEntry__updatedAtBlockNumber"] = "resolverEntry__updatedAtBlockNumber";
    SetEvent_OrderBy["ResolverEntry__updatedAtTimestamp"] = "resolverEntry__updatedAtTimestamp";
    SetEvent_OrderBy["Target"] = "target";
    SetEvent_OrderBy["Timestamp"] = "timestamp";
    SetEvent_OrderBy["TransactionHash"] = "transactionHash";
})(SetEvent_OrderBy || (exports.SetEvent_OrderBy = SetEvent_OrderBy = {}));
var StreamPeriod_OrderBy;
(function (StreamPeriod_OrderBy) {
    StreamPeriod_OrderBy["Deposit"] = "deposit";
    StreamPeriod_OrderBy["FlowRate"] = "flowRate";
    StreamPeriod_OrderBy["Id"] = "id";
    StreamPeriod_OrderBy["Receiver"] = "receiver";
    StreamPeriod_OrderBy["Receiver__createdAtBlockNumber"] = "receiver__createdAtBlockNumber";
    StreamPeriod_OrderBy["Receiver__createdAtTimestamp"] = "receiver__createdAtTimestamp";
    StreamPeriod_OrderBy["Receiver__id"] = "receiver__id";
    StreamPeriod_OrderBy["Receiver__isSuperApp"] = "receiver__isSuperApp";
    StreamPeriod_OrderBy["Receiver__updatedAtBlockNumber"] = "receiver__updatedAtBlockNumber";
    StreamPeriod_OrderBy["Receiver__updatedAtTimestamp"] = "receiver__updatedAtTimestamp";
    StreamPeriod_OrderBy["Sender"] = "sender";
    StreamPeriod_OrderBy["Sender__createdAtBlockNumber"] = "sender__createdAtBlockNumber";
    StreamPeriod_OrderBy["Sender__createdAtTimestamp"] = "sender__createdAtTimestamp";
    StreamPeriod_OrderBy["Sender__id"] = "sender__id";
    StreamPeriod_OrderBy["Sender__isSuperApp"] = "sender__isSuperApp";
    StreamPeriod_OrderBy["Sender__updatedAtBlockNumber"] = "sender__updatedAtBlockNumber";
    StreamPeriod_OrderBy["Sender__updatedAtTimestamp"] = "sender__updatedAtTimestamp";
    StreamPeriod_OrderBy["StartedAtBlockNumber"] = "startedAtBlockNumber";
    StreamPeriod_OrderBy["StartedAtEvent"] = "startedAtEvent";
    StreamPeriod_OrderBy["StartedAtEvent__blockNumber"] = "startedAtEvent__blockNumber";
    StreamPeriod_OrderBy["StartedAtEvent__deposit"] = "startedAtEvent__deposit";
    StreamPeriod_OrderBy["StartedAtEvent__flowOperator"] = "startedAtEvent__flowOperator";
    StreamPeriod_OrderBy["StartedAtEvent__flowRate"] = "startedAtEvent__flowRate";
    StreamPeriod_OrderBy["StartedAtEvent__gasPrice"] = "startedAtEvent__gasPrice";
    StreamPeriod_OrderBy["StartedAtEvent__gasUsed"] = "startedAtEvent__gasUsed";
    StreamPeriod_OrderBy["StartedAtEvent__id"] = "startedAtEvent__id";
    StreamPeriod_OrderBy["StartedAtEvent__logIndex"] = "startedAtEvent__logIndex";
    StreamPeriod_OrderBy["StartedAtEvent__name"] = "startedAtEvent__name";
    StreamPeriod_OrderBy["StartedAtEvent__oldFlowRate"] = "startedAtEvent__oldFlowRate";
    StreamPeriod_OrderBy["StartedAtEvent__order"] = "startedAtEvent__order";
    StreamPeriod_OrderBy["StartedAtEvent__receiver"] = "startedAtEvent__receiver";
    StreamPeriod_OrderBy["StartedAtEvent__sender"] = "startedAtEvent__sender";
    StreamPeriod_OrderBy["StartedAtEvent__timestamp"] = "startedAtEvent__timestamp";
    StreamPeriod_OrderBy["StartedAtEvent__token"] = "startedAtEvent__token";
    StreamPeriod_OrderBy["StartedAtEvent__totalAmountStreamedUntilTimestamp"] = "startedAtEvent__totalAmountStreamedUntilTimestamp";
    StreamPeriod_OrderBy["StartedAtEvent__totalReceiverFlowRate"] = "startedAtEvent__totalReceiverFlowRate";
    StreamPeriod_OrderBy["StartedAtEvent__totalSenderFlowRate"] = "startedAtEvent__totalSenderFlowRate";
    StreamPeriod_OrderBy["StartedAtEvent__transactionHash"] = "startedAtEvent__transactionHash";
    StreamPeriod_OrderBy["StartedAtEvent__type"] = "startedAtEvent__type";
    StreamPeriod_OrderBy["StartedAtEvent__userData"] = "startedAtEvent__userData";
    StreamPeriod_OrderBy["StartedAtTimestamp"] = "startedAtTimestamp";
    StreamPeriod_OrderBy["StoppedAtBlockNumber"] = "stoppedAtBlockNumber";
    StreamPeriod_OrderBy["StoppedAtEvent"] = "stoppedAtEvent";
    StreamPeriod_OrderBy["StoppedAtEvent__blockNumber"] = "stoppedAtEvent__blockNumber";
    StreamPeriod_OrderBy["StoppedAtEvent__deposit"] = "stoppedAtEvent__deposit";
    StreamPeriod_OrderBy["StoppedAtEvent__flowOperator"] = "stoppedAtEvent__flowOperator";
    StreamPeriod_OrderBy["StoppedAtEvent__flowRate"] = "stoppedAtEvent__flowRate";
    StreamPeriod_OrderBy["StoppedAtEvent__gasPrice"] = "stoppedAtEvent__gasPrice";
    StreamPeriod_OrderBy["StoppedAtEvent__gasUsed"] = "stoppedAtEvent__gasUsed";
    StreamPeriod_OrderBy["StoppedAtEvent__id"] = "stoppedAtEvent__id";
    StreamPeriod_OrderBy["StoppedAtEvent__logIndex"] = "stoppedAtEvent__logIndex";
    StreamPeriod_OrderBy["StoppedAtEvent__name"] = "stoppedAtEvent__name";
    StreamPeriod_OrderBy["StoppedAtEvent__oldFlowRate"] = "stoppedAtEvent__oldFlowRate";
    StreamPeriod_OrderBy["StoppedAtEvent__order"] = "stoppedAtEvent__order";
    StreamPeriod_OrderBy["StoppedAtEvent__receiver"] = "stoppedAtEvent__receiver";
    StreamPeriod_OrderBy["StoppedAtEvent__sender"] = "stoppedAtEvent__sender";
    StreamPeriod_OrderBy["StoppedAtEvent__timestamp"] = "stoppedAtEvent__timestamp";
    StreamPeriod_OrderBy["StoppedAtEvent__token"] = "stoppedAtEvent__token";
    StreamPeriod_OrderBy["StoppedAtEvent__totalAmountStreamedUntilTimestamp"] = "stoppedAtEvent__totalAmountStreamedUntilTimestamp";
    StreamPeriod_OrderBy["StoppedAtEvent__totalReceiverFlowRate"] = "stoppedAtEvent__totalReceiverFlowRate";
    StreamPeriod_OrderBy["StoppedAtEvent__totalSenderFlowRate"] = "stoppedAtEvent__totalSenderFlowRate";
    StreamPeriod_OrderBy["StoppedAtEvent__transactionHash"] = "stoppedAtEvent__transactionHash";
    StreamPeriod_OrderBy["StoppedAtEvent__type"] = "stoppedAtEvent__type";
    StreamPeriod_OrderBy["StoppedAtEvent__userData"] = "stoppedAtEvent__userData";
    StreamPeriod_OrderBy["StoppedAtTimestamp"] = "stoppedAtTimestamp";
    StreamPeriod_OrderBy["Stream"] = "stream";
    StreamPeriod_OrderBy["Stream__createdAtBlockNumber"] = "stream__createdAtBlockNumber";
    StreamPeriod_OrderBy["Stream__createdAtTimestamp"] = "stream__createdAtTimestamp";
    StreamPeriod_OrderBy["Stream__currentFlowRate"] = "stream__currentFlowRate";
    StreamPeriod_OrderBy["Stream__deposit"] = "stream__deposit";
    StreamPeriod_OrderBy["Stream__id"] = "stream__id";
    StreamPeriod_OrderBy["Stream__streamedUntilUpdatedAt"] = "stream__streamedUntilUpdatedAt";
    StreamPeriod_OrderBy["Stream__updatedAtBlockNumber"] = "stream__updatedAtBlockNumber";
    StreamPeriod_OrderBy["Stream__updatedAtTimestamp"] = "stream__updatedAtTimestamp";
    StreamPeriod_OrderBy["Stream__userData"] = "stream__userData";
    StreamPeriod_OrderBy["Token"] = "token";
    StreamPeriod_OrderBy["Token__createdAtBlockNumber"] = "token__createdAtBlockNumber";
    StreamPeriod_OrderBy["Token__createdAtTimestamp"] = "token__createdAtTimestamp";
    StreamPeriod_OrderBy["Token__decimals"] = "token__decimals";
    StreamPeriod_OrderBy["Token__id"] = "token__id";
    StreamPeriod_OrderBy["Token__isListed"] = "token__isListed";
    StreamPeriod_OrderBy["Token__isNativeAssetSuperToken"] = "token__isNativeAssetSuperToken";
    StreamPeriod_OrderBy["Token__isSuperToken"] = "token__isSuperToken";
    StreamPeriod_OrderBy["Token__name"] = "token__name";
    StreamPeriod_OrderBy["Token__symbol"] = "token__symbol";
    StreamPeriod_OrderBy["Token__underlyingAddress"] = "token__underlyingAddress";
    StreamPeriod_OrderBy["TotalAmountStreamed"] = "totalAmountStreamed";
})(StreamPeriod_OrderBy || (exports.StreamPeriod_OrderBy = StreamPeriod_OrderBy = {}));
var StreamRevision_OrderBy;
(function (StreamRevision_OrderBy) {
    StreamRevision_OrderBy["Id"] = "id";
    StreamRevision_OrderBy["MostRecentStream"] = "mostRecentStream";
    StreamRevision_OrderBy["MostRecentStream__createdAtBlockNumber"] = "mostRecentStream__createdAtBlockNumber";
    StreamRevision_OrderBy["MostRecentStream__createdAtTimestamp"] = "mostRecentStream__createdAtTimestamp";
    StreamRevision_OrderBy["MostRecentStream__currentFlowRate"] = "mostRecentStream__currentFlowRate";
    StreamRevision_OrderBy["MostRecentStream__deposit"] = "mostRecentStream__deposit";
    StreamRevision_OrderBy["MostRecentStream__id"] = "mostRecentStream__id";
    StreamRevision_OrderBy["MostRecentStream__streamedUntilUpdatedAt"] = "mostRecentStream__streamedUntilUpdatedAt";
    StreamRevision_OrderBy["MostRecentStream__updatedAtBlockNumber"] = "mostRecentStream__updatedAtBlockNumber";
    StreamRevision_OrderBy["MostRecentStream__updatedAtTimestamp"] = "mostRecentStream__updatedAtTimestamp";
    StreamRevision_OrderBy["MostRecentStream__userData"] = "mostRecentStream__userData";
    StreamRevision_OrderBy["PeriodRevisionIndex"] = "periodRevisionIndex";
    StreamRevision_OrderBy["RevisionIndex"] = "revisionIndex";
})(StreamRevision_OrderBy || (exports.StreamRevision_OrderBy = StreamRevision_OrderBy = {}));
var Stream_OrderBy;
(function (Stream_OrderBy) {
    Stream_OrderBy["CreatedAtBlockNumber"] = "createdAtBlockNumber";
    Stream_OrderBy["CreatedAtTimestamp"] = "createdAtTimestamp";
    Stream_OrderBy["CurrentFlowRate"] = "currentFlowRate";
    Stream_OrderBy["Deposit"] = "deposit";
    Stream_OrderBy["FlowUpdatedEvents"] = "flowUpdatedEvents";
    Stream_OrderBy["Id"] = "id";
    Stream_OrderBy["Receiver"] = "receiver";
    Stream_OrderBy["Receiver__createdAtBlockNumber"] = "receiver__createdAtBlockNumber";
    Stream_OrderBy["Receiver__createdAtTimestamp"] = "receiver__createdAtTimestamp";
    Stream_OrderBy["Receiver__id"] = "receiver__id";
    Stream_OrderBy["Receiver__isSuperApp"] = "receiver__isSuperApp";
    Stream_OrderBy["Receiver__updatedAtBlockNumber"] = "receiver__updatedAtBlockNumber";
    Stream_OrderBy["Receiver__updatedAtTimestamp"] = "receiver__updatedAtTimestamp";
    Stream_OrderBy["Sender"] = "sender";
    Stream_OrderBy["Sender__createdAtBlockNumber"] = "sender__createdAtBlockNumber";
    Stream_OrderBy["Sender__createdAtTimestamp"] = "sender__createdAtTimestamp";
    Stream_OrderBy["Sender__id"] = "sender__id";
    Stream_OrderBy["Sender__isSuperApp"] = "sender__isSuperApp";
    Stream_OrderBy["Sender__updatedAtBlockNumber"] = "sender__updatedAtBlockNumber";
    Stream_OrderBy["Sender__updatedAtTimestamp"] = "sender__updatedAtTimestamp";
    Stream_OrderBy["StreamPeriods"] = "streamPeriods";
    Stream_OrderBy["StreamedUntilUpdatedAt"] = "streamedUntilUpdatedAt";
    Stream_OrderBy["Token"] = "token";
    Stream_OrderBy["Token__createdAtBlockNumber"] = "token__createdAtBlockNumber";
    Stream_OrderBy["Token__createdAtTimestamp"] = "token__createdAtTimestamp";
    Stream_OrderBy["Token__decimals"] = "token__decimals";
    Stream_OrderBy["Token__id"] = "token__id";
    Stream_OrderBy["Token__isListed"] = "token__isListed";
    Stream_OrderBy["Token__isNativeAssetSuperToken"] = "token__isNativeAssetSuperToken";
    Stream_OrderBy["Token__isSuperToken"] = "token__isSuperToken";
    Stream_OrderBy["Token__name"] = "token__name";
    Stream_OrderBy["Token__symbol"] = "token__symbol";
    Stream_OrderBy["Token__underlyingAddress"] = "token__underlyingAddress";
    Stream_OrderBy["UpdatedAtBlockNumber"] = "updatedAtBlockNumber";
    Stream_OrderBy["UpdatedAtTimestamp"] = "updatedAtTimestamp";
    Stream_OrderBy["UserData"] = "userData";
})(Stream_OrderBy || (exports.Stream_OrderBy = Stream_OrderBy = {}));
var SubscriptionApprovedEvent_OrderBy;
(function (SubscriptionApprovedEvent_OrderBy) {
    SubscriptionApprovedEvent_OrderBy["Addresses"] = "addresses";
    SubscriptionApprovedEvent_OrderBy["BlockNumber"] = "blockNumber";
    SubscriptionApprovedEvent_OrderBy["GasPrice"] = "gasPrice";
    SubscriptionApprovedEvent_OrderBy["GasUsed"] = "gasUsed";
    SubscriptionApprovedEvent_OrderBy["Id"] = "id";
    SubscriptionApprovedEvent_OrderBy["IndexId"] = "indexId";
    SubscriptionApprovedEvent_OrderBy["LogIndex"] = "logIndex";
    SubscriptionApprovedEvent_OrderBy["Name"] = "name";
    SubscriptionApprovedEvent_OrderBy["Order"] = "order";
    SubscriptionApprovedEvent_OrderBy["Publisher"] = "publisher";
    SubscriptionApprovedEvent_OrderBy["Subscriber"] = "subscriber";
    SubscriptionApprovedEvent_OrderBy["Subscription"] = "subscription";
    SubscriptionApprovedEvent_OrderBy["Subscription__approved"] = "subscription__approved";
    SubscriptionApprovedEvent_OrderBy["Subscription__createdAtBlockNumber"] = "subscription__createdAtBlockNumber";
    SubscriptionApprovedEvent_OrderBy["Subscription__createdAtTimestamp"] = "subscription__createdAtTimestamp";
    SubscriptionApprovedEvent_OrderBy["Subscription__id"] = "subscription__id";
    SubscriptionApprovedEvent_OrderBy["Subscription__indexValueUntilUpdatedAt"] = "subscription__indexValueUntilUpdatedAt";
    SubscriptionApprovedEvent_OrderBy["Subscription__totalAmountReceivedUntilUpdatedAt"] = "subscription__totalAmountReceivedUntilUpdatedAt";
    SubscriptionApprovedEvent_OrderBy["Subscription__units"] = "subscription__units";
    SubscriptionApprovedEvent_OrderBy["Subscription__updatedAtBlockNumber"] = "subscription__updatedAtBlockNumber";
    SubscriptionApprovedEvent_OrderBy["Subscription__updatedAtTimestamp"] = "subscription__updatedAtTimestamp";
    SubscriptionApprovedEvent_OrderBy["Timestamp"] = "timestamp";
    SubscriptionApprovedEvent_OrderBy["Token"] = "token";
    SubscriptionApprovedEvent_OrderBy["TransactionHash"] = "transactionHash";
    SubscriptionApprovedEvent_OrderBy["UserData"] = "userData";
})(SubscriptionApprovedEvent_OrderBy || (exports.SubscriptionApprovedEvent_OrderBy = SubscriptionApprovedEvent_OrderBy = {}));
var SubscriptionDistributionClaimedEvent_OrderBy;
(function (SubscriptionDistributionClaimedEvent_OrderBy) {
    SubscriptionDistributionClaimedEvent_OrderBy["Addresses"] = "addresses";
    SubscriptionDistributionClaimedEvent_OrderBy["Amount"] = "amount";
    SubscriptionDistributionClaimedEvent_OrderBy["BlockNumber"] = "blockNumber";
    SubscriptionDistributionClaimedEvent_OrderBy["GasPrice"] = "gasPrice";
    SubscriptionDistributionClaimedEvent_OrderBy["GasUsed"] = "gasUsed";
    SubscriptionDistributionClaimedEvent_OrderBy["Id"] = "id";
    SubscriptionDistributionClaimedEvent_OrderBy["IndexId"] = "indexId";
    SubscriptionDistributionClaimedEvent_OrderBy["LogIndex"] = "logIndex";
    SubscriptionDistributionClaimedEvent_OrderBy["Name"] = "name";
    SubscriptionDistributionClaimedEvent_OrderBy["Order"] = "order";
    SubscriptionDistributionClaimedEvent_OrderBy["Publisher"] = "publisher";
    SubscriptionDistributionClaimedEvent_OrderBy["Subscriber"] = "subscriber";
    SubscriptionDistributionClaimedEvent_OrderBy["Subscription"] = "subscription";
    SubscriptionDistributionClaimedEvent_OrderBy["Subscription__approved"] = "subscription__approved";
    SubscriptionDistributionClaimedEvent_OrderBy["Subscription__createdAtBlockNumber"] = "subscription__createdAtBlockNumber";
    SubscriptionDistributionClaimedEvent_OrderBy["Subscription__createdAtTimestamp"] = "subscription__createdAtTimestamp";
    SubscriptionDistributionClaimedEvent_OrderBy["Subscription__id"] = "subscription__id";
    SubscriptionDistributionClaimedEvent_OrderBy["Subscription__indexValueUntilUpdatedAt"] = "subscription__indexValueUntilUpdatedAt";
    SubscriptionDistributionClaimedEvent_OrderBy["Subscription__totalAmountReceivedUntilUpdatedAt"] = "subscription__totalAmountReceivedUntilUpdatedAt";
    SubscriptionDistributionClaimedEvent_OrderBy["Subscription__units"] = "subscription__units";
    SubscriptionDistributionClaimedEvent_OrderBy["Subscription__updatedAtBlockNumber"] = "subscription__updatedAtBlockNumber";
    SubscriptionDistributionClaimedEvent_OrderBy["Subscription__updatedAtTimestamp"] = "subscription__updatedAtTimestamp";
    SubscriptionDistributionClaimedEvent_OrderBy["Timestamp"] = "timestamp";
    SubscriptionDistributionClaimedEvent_OrderBy["Token"] = "token";
    SubscriptionDistributionClaimedEvent_OrderBy["TransactionHash"] = "transactionHash";
})(SubscriptionDistributionClaimedEvent_OrderBy || (exports.SubscriptionDistributionClaimedEvent_OrderBy = SubscriptionDistributionClaimedEvent_OrderBy = {}));
var SubscriptionRevokedEvent_OrderBy;
(function (SubscriptionRevokedEvent_OrderBy) {
    SubscriptionRevokedEvent_OrderBy["Addresses"] = "addresses";
    SubscriptionRevokedEvent_OrderBy["BlockNumber"] = "blockNumber";
    SubscriptionRevokedEvent_OrderBy["GasPrice"] = "gasPrice";
    SubscriptionRevokedEvent_OrderBy["GasUsed"] = "gasUsed";
    SubscriptionRevokedEvent_OrderBy["Id"] = "id";
    SubscriptionRevokedEvent_OrderBy["IndexId"] = "indexId";
    SubscriptionRevokedEvent_OrderBy["LogIndex"] = "logIndex";
    SubscriptionRevokedEvent_OrderBy["Name"] = "name";
    SubscriptionRevokedEvent_OrderBy["Order"] = "order";
    SubscriptionRevokedEvent_OrderBy["Publisher"] = "publisher";
    SubscriptionRevokedEvent_OrderBy["Subscriber"] = "subscriber";
    SubscriptionRevokedEvent_OrderBy["Subscription"] = "subscription";
    SubscriptionRevokedEvent_OrderBy["Subscription__approved"] = "subscription__approved";
    SubscriptionRevokedEvent_OrderBy["Subscription__createdAtBlockNumber"] = "subscription__createdAtBlockNumber";
    SubscriptionRevokedEvent_OrderBy["Subscription__createdAtTimestamp"] = "subscription__createdAtTimestamp";
    SubscriptionRevokedEvent_OrderBy["Subscription__id"] = "subscription__id";
    SubscriptionRevokedEvent_OrderBy["Subscription__indexValueUntilUpdatedAt"] = "subscription__indexValueUntilUpdatedAt";
    SubscriptionRevokedEvent_OrderBy["Subscription__totalAmountReceivedUntilUpdatedAt"] = "subscription__totalAmountReceivedUntilUpdatedAt";
    SubscriptionRevokedEvent_OrderBy["Subscription__units"] = "subscription__units";
    SubscriptionRevokedEvent_OrderBy["Subscription__updatedAtBlockNumber"] = "subscription__updatedAtBlockNumber";
    SubscriptionRevokedEvent_OrderBy["Subscription__updatedAtTimestamp"] = "subscription__updatedAtTimestamp";
    SubscriptionRevokedEvent_OrderBy["Timestamp"] = "timestamp";
    SubscriptionRevokedEvent_OrderBy["Token"] = "token";
    SubscriptionRevokedEvent_OrderBy["TransactionHash"] = "transactionHash";
    SubscriptionRevokedEvent_OrderBy["UserData"] = "userData";
})(SubscriptionRevokedEvent_OrderBy || (exports.SubscriptionRevokedEvent_OrderBy = SubscriptionRevokedEvent_OrderBy = {}));
var SubscriptionUnitsUpdatedEvent_OrderBy;
(function (SubscriptionUnitsUpdatedEvent_OrderBy) {
    SubscriptionUnitsUpdatedEvent_OrderBy["Addresses"] = "addresses";
    SubscriptionUnitsUpdatedEvent_OrderBy["BlockNumber"] = "blockNumber";
    SubscriptionUnitsUpdatedEvent_OrderBy["GasPrice"] = "gasPrice";
    SubscriptionUnitsUpdatedEvent_OrderBy["GasUsed"] = "gasUsed";
    SubscriptionUnitsUpdatedEvent_OrderBy["Id"] = "id";
    SubscriptionUnitsUpdatedEvent_OrderBy["IndexId"] = "indexId";
    SubscriptionUnitsUpdatedEvent_OrderBy["LogIndex"] = "logIndex";
    SubscriptionUnitsUpdatedEvent_OrderBy["Name"] = "name";
    SubscriptionUnitsUpdatedEvent_OrderBy["OldUnits"] = "oldUnits";
    SubscriptionUnitsUpdatedEvent_OrderBy["Order"] = "order";
    SubscriptionUnitsUpdatedEvent_OrderBy["Publisher"] = "publisher";
    SubscriptionUnitsUpdatedEvent_OrderBy["Subscriber"] = "subscriber";
    SubscriptionUnitsUpdatedEvent_OrderBy["Subscription"] = "subscription";
    SubscriptionUnitsUpdatedEvent_OrderBy["Subscription__approved"] = "subscription__approved";
    SubscriptionUnitsUpdatedEvent_OrderBy["Subscription__createdAtBlockNumber"] = "subscription__createdAtBlockNumber";
    SubscriptionUnitsUpdatedEvent_OrderBy["Subscription__createdAtTimestamp"] = "subscription__createdAtTimestamp";
    SubscriptionUnitsUpdatedEvent_OrderBy["Subscription__id"] = "subscription__id";
    SubscriptionUnitsUpdatedEvent_OrderBy["Subscription__indexValueUntilUpdatedAt"] = "subscription__indexValueUntilUpdatedAt";
    SubscriptionUnitsUpdatedEvent_OrderBy["Subscription__totalAmountReceivedUntilUpdatedAt"] = "subscription__totalAmountReceivedUntilUpdatedAt";
    SubscriptionUnitsUpdatedEvent_OrderBy["Subscription__units"] = "subscription__units";
    SubscriptionUnitsUpdatedEvent_OrderBy["Subscription__updatedAtBlockNumber"] = "subscription__updatedAtBlockNumber";
    SubscriptionUnitsUpdatedEvent_OrderBy["Subscription__updatedAtTimestamp"] = "subscription__updatedAtTimestamp";
    SubscriptionUnitsUpdatedEvent_OrderBy["Timestamp"] = "timestamp";
    SubscriptionUnitsUpdatedEvent_OrderBy["Token"] = "token";
    SubscriptionUnitsUpdatedEvent_OrderBy["TransactionHash"] = "transactionHash";
    SubscriptionUnitsUpdatedEvent_OrderBy["Units"] = "units";
    SubscriptionUnitsUpdatedEvent_OrderBy["UserData"] = "userData";
})(SubscriptionUnitsUpdatedEvent_OrderBy || (exports.SubscriptionUnitsUpdatedEvent_OrderBy = SubscriptionUnitsUpdatedEvent_OrderBy = {}));
var SuperTokenCreatedEvent_OrderBy;
(function (SuperTokenCreatedEvent_OrderBy) {
    SuperTokenCreatedEvent_OrderBy["Addresses"] = "addresses";
    SuperTokenCreatedEvent_OrderBy["BlockNumber"] = "blockNumber";
    SuperTokenCreatedEvent_OrderBy["GasPrice"] = "gasPrice";
    SuperTokenCreatedEvent_OrderBy["GasUsed"] = "gasUsed";
    SuperTokenCreatedEvent_OrderBy["Id"] = "id";
    SuperTokenCreatedEvent_OrderBy["LogIndex"] = "logIndex";
    SuperTokenCreatedEvent_OrderBy["Name"] = "name";
    SuperTokenCreatedEvent_OrderBy["Order"] = "order";
    SuperTokenCreatedEvent_OrderBy["Timestamp"] = "timestamp";
    SuperTokenCreatedEvent_OrderBy["Token"] = "token";
    SuperTokenCreatedEvent_OrderBy["TransactionHash"] = "transactionHash";
})(SuperTokenCreatedEvent_OrderBy || (exports.SuperTokenCreatedEvent_OrderBy = SuperTokenCreatedEvent_OrderBy = {}));
var SuperTokenFactoryUpdatedEvent_OrderBy;
(function (SuperTokenFactoryUpdatedEvent_OrderBy) {
    SuperTokenFactoryUpdatedEvent_OrderBy["Addresses"] = "addresses";
    SuperTokenFactoryUpdatedEvent_OrderBy["BlockNumber"] = "blockNumber";
    SuperTokenFactoryUpdatedEvent_OrderBy["GasPrice"] = "gasPrice";
    SuperTokenFactoryUpdatedEvent_OrderBy["GasUsed"] = "gasUsed";
    SuperTokenFactoryUpdatedEvent_OrderBy["Id"] = "id";
    SuperTokenFactoryUpdatedEvent_OrderBy["LogIndex"] = "logIndex";
    SuperTokenFactoryUpdatedEvent_OrderBy["Name"] = "name";
    SuperTokenFactoryUpdatedEvent_OrderBy["NewFactory"] = "newFactory";
    SuperTokenFactoryUpdatedEvent_OrderBy["Order"] = "order";
    SuperTokenFactoryUpdatedEvent_OrderBy["Timestamp"] = "timestamp";
    SuperTokenFactoryUpdatedEvent_OrderBy["TransactionHash"] = "transactionHash";
})(SuperTokenFactoryUpdatedEvent_OrderBy || (exports.SuperTokenFactoryUpdatedEvent_OrderBy = SuperTokenFactoryUpdatedEvent_OrderBy = {}));
var SuperTokenLogicCreatedEvent_OrderBy;
(function (SuperTokenLogicCreatedEvent_OrderBy) {
    SuperTokenLogicCreatedEvent_OrderBy["Addresses"] = "addresses";
    SuperTokenLogicCreatedEvent_OrderBy["BlockNumber"] = "blockNumber";
    SuperTokenLogicCreatedEvent_OrderBy["GasPrice"] = "gasPrice";
    SuperTokenLogicCreatedEvent_OrderBy["GasUsed"] = "gasUsed";
    SuperTokenLogicCreatedEvent_OrderBy["Id"] = "id";
    SuperTokenLogicCreatedEvent_OrderBy["LogIndex"] = "logIndex";
    SuperTokenLogicCreatedEvent_OrderBy["Name"] = "name";
    SuperTokenLogicCreatedEvent_OrderBy["Order"] = "order";
    SuperTokenLogicCreatedEvent_OrderBy["Timestamp"] = "timestamp";
    SuperTokenLogicCreatedEvent_OrderBy["TokenLogic"] = "tokenLogic";
    SuperTokenLogicCreatedEvent_OrderBy["TransactionHash"] = "transactionHash";
})(SuperTokenLogicCreatedEvent_OrderBy || (exports.SuperTokenLogicCreatedEvent_OrderBy = SuperTokenLogicCreatedEvent_OrderBy = {}));
var SuperTokenLogicUpdatedEvent_OrderBy;
(function (SuperTokenLogicUpdatedEvent_OrderBy) {
    SuperTokenLogicUpdatedEvent_OrderBy["Addresses"] = "addresses";
    SuperTokenLogicUpdatedEvent_OrderBy["BlockNumber"] = "blockNumber";
    SuperTokenLogicUpdatedEvent_OrderBy["Code"] = "code";
    SuperTokenLogicUpdatedEvent_OrderBy["GasPrice"] = "gasPrice";
    SuperTokenLogicUpdatedEvent_OrderBy["GasUsed"] = "gasUsed";
    SuperTokenLogicUpdatedEvent_OrderBy["Id"] = "id";
    SuperTokenLogicUpdatedEvent_OrderBy["LogIndex"] = "logIndex";
    SuperTokenLogicUpdatedEvent_OrderBy["Name"] = "name";
    SuperTokenLogicUpdatedEvent_OrderBy["Order"] = "order";
    SuperTokenLogicUpdatedEvent_OrderBy["Timestamp"] = "timestamp";
    SuperTokenLogicUpdatedEvent_OrderBy["Token"] = "token";
    SuperTokenLogicUpdatedEvent_OrderBy["TransactionHash"] = "transactionHash";
})(SuperTokenLogicUpdatedEvent_OrderBy || (exports.SuperTokenLogicUpdatedEvent_OrderBy = SuperTokenLogicUpdatedEvent_OrderBy = {}));
var SuperTokenMinimumDepositChangedEvent_OrderBy;
(function (SuperTokenMinimumDepositChangedEvent_OrderBy) {
    SuperTokenMinimumDepositChangedEvent_OrderBy["Addresses"] = "addresses";
    SuperTokenMinimumDepositChangedEvent_OrderBy["BlockNumber"] = "blockNumber";
    SuperTokenMinimumDepositChangedEvent_OrderBy["GasPrice"] = "gasPrice";
    SuperTokenMinimumDepositChangedEvent_OrderBy["GasUsed"] = "gasUsed";
    SuperTokenMinimumDepositChangedEvent_OrderBy["GovernanceAddress"] = "governanceAddress";
    SuperTokenMinimumDepositChangedEvent_OrderBy["Host"] = "host";
    SuperTokenMinimumDepositChangedEvent_OrderBy["Id"] = "id";
    SuperTokenMinimumDepositChangedEvent_OrderBy["IsKeySet"] = "isKeySet";
    SuperTokenMinimumDepositChangedEvent_OrderBy["LogIndex"] = "logIndex";
    SuperTokenMinimumDepositChangedEvent_OrderBy["MinimumDeposit"] = "minimumDeposit";
    SuperTokenMinimumDepositChangedEvent_OrderBy["Name"] = "name";
    SuperTokenMinimumDepositChangedEvent_OrderBy["Order"] = "order";
    SuperTokenMinimumDepositChangedEvent_OrderBy["SuperToken"] = "superToken";
    SuperTokenMinimumDepositChangedEvent_OrderBy["Timestamp"] = "timestamp";
    SuperTokenMinimumDepositChangedEvent_OrderBy["TransactionHash"] = "transactionHash";
})(SuperTokenMinimumDepositChangedEvent_OrderBy || (exports.SuperTokenMinimumDepositChangedEvent_OrderBy = SuperTokenMinimumDepositChangedEvent_OrderBy = {}));
var TokenDowngradedEvent_OrderBy;
(function (TokenDowngradedEvent_OrderBy) {
    TokenDowngradedEvent_OrderBy["Account"] = "account";
    TokenDowngradedEvent_OrderBy["Account__createdAtBlockNumber"] = "account__createdAtBlockNumber";
    TokenDowngradedEvent_OrderBy["Account__createdAtTimestamp"] = "account__createdAtTimestamp";
    TokenDowngradedEvent_OrderBy["Account__id"] = "account__id";
    TokenDowngradedEvent_OrderBy["Account__isSuperApp"] = "account__isSuperApp";
    TokenDowngradedEvent_OrderBy["Account__updatedAtBlockNumber"] = "account__updatedAtBlockNumber";
    TokenDowngradedEvent_OrderBy["Account__updatedAtTimestamp"] = "account__updatedAtTimestamp";
    TokenDowngradedEvent_OrderBy["Addresses"] = "addresses";
    TokenDowngradedEvent_OrderBy["Amount"] = "amount";
    TokenDowngradedEvent_OrderBy["BlockNumber"] = "blockNumber";
    TokenDowngradedEvent_OrderBy["GasPrice"] = "gasPrice";
    TokenDowngradedEvent_OrderBy["GasUsed"] = "gasUsed";
    TokenDowngradedEvent_OrderBy["Id"] = "id";
    TokenDowngradedEvent_OrderBy["LogIndex"] = "logIndex";
    TokenDowngradedEvent_OrderBy["Name"] = "name";
    TokenDowngradedEvent_OrderBy["Order"] = "order";
    TokenDowngradedEvent_OrderBy["Timestamp"] = "timestamp";
    TokenDowngradedEvent_OrderBy["Token"] = "token";
    TokenDowngradedEvent_OrderBy["TransactionHash"] = "transactionHash";
})(TokenDowngradedEvent_OrderBy || (exports.TokenDowngradedEvent_OrderBy = TokenDowngradedEvent_OrderBy = {}));
var TokenGovernanceConfig_OrderBy;
(function (TokenGovernanceConfig_OrderBy) {
    TokenGovernanceConfig_OrderBy["CreatedAtBlockNumber"] = "createdAtBlockNumber";
    TokenGovernanceConfig_OrderBy["CreatedAtTimestamp"] = "createdAtTimestamp";
    TokenGovernanceConfig_OrderBy["Id"] = "id";
    TokenGovernanceConfig_OrderBy["IsDefault"] = "isDefault";
    TokenGovernanceConfig_OrderBy["LiquidationPeriod"] = "liquidationPeriod";
    TokenGovernanceConfig_OrderBy["MinimumDeposit"] = "minimumDeposit";
    TokenGovernanceConfig_OrderBy["PatricianPeriod"] = "patricianPeriod";
    TokenGovernanceConfig_OrderBy["RewardAddress"] = "rewardAddress";
    TokenGovernanceConfig_OrderBy["Token"] = "token";
    TokenGovernanceConfig_OrderBy["Token__createdAtBlockNumber"] = "token__createdAtBlockNumber";
    TokenGovernanceConfig_OrderBy["Token__createdAtTimestamp"] = "token__createdAtTimestamp";
    TokenGovernanceConfig_OrderBy["Token__decimals"] = "token__decimals";
    TokenGovernanceConfig_OrderBy["Token__id"] = "token__id";
    TokenGovernanceConfig_OrderBy["Token__isListed"] = "token__isListed";
    TokenGovernanceConfig_OrderBy["Token__isNativeAssetSuperToken"] = "token__isNativeAssetSuperToken";
    TokenGovernanceConfig_OrderBy["Token__isSuperToken"] = "token__isSuperToken";
    TokenGovernanceConfig_OrderBy["Token__name"] = "token__name";
    TokenGovernanceConfig_OrderBy["Token__symbol"] = "token__symbol";
    TokenGovernanceConfig_OrderBy["Token__underlyingAddress"] = "token__underlyingAddress";
    TokenGovernanceConfig_OrderBy["UpdatedAtBlockNumber"] = "updatedAtBlockNumber";
    TokenGovernanceConfig_OrderBy["UpdatedAtTimestamp"] = "updatedAtTimestamp";
})(TokenGovernanceConfig_OrderBy || (exports.TokenGovernanceConfig_OrderBy = TokenGovernanceConfig_OrderBy = {}));
var TokenStatisticLog_OrderBy;
(function (TokenStatisticLog_OrderBy) {
    TokenStatisticLog_OrderBy["BlockNumber"] = "blockNumber";
    TokenStatisticLog_OrderBy["Id"] = "id";
    TokenStatisticLog_OrderBy["LogIndex"] = "logIndex";
    TokenStatisticLog_OrderBy["Order"] = "order";
    TokenStatisticLog_OrderBy["Timestamp"] = "timestamp";
    TokenStatisticLog_OrderBy["Token"] = "token";
    TokenStatisticLog_OrderBy["TokenStatistic"] = "tokenStatistic";
    TokenStatisticLog_OrderBy["TokenStatistic__id"] = "tokenStatistic__id";
    TokenStatisticLog_OrderBy["TokenStatistic__totalAmountDistributedUntilUpdatedAt"] = "tokenStatistic__totalAmountDistributedUntilUpdatedAt";
    TokenStatisticLog_OrderBy["TokenStatistic__totalAmountStreamedUntilUpdatedAt"] = "tokenStatistic__totalAmountStreamedUntilUpdatedAt";
    TokenStatisticLog_OrderBy["TokenStatistic__totalAmountTransferredUntilUpdatedAt"] = "tokenStatistic__totalAmountTransferredUntilUpdatedAt";
    TokenStatisticLog_OrderBy["TokenStatistic__totalApprovedSubscriptions"] = "tokenStatistic__totalApprovedSubscriptions";
    TokenStatisticLog_OrderBy["TokenStatistic__totalCFAAmountStreamedUntilUpdatedAt"] = "tokenStatistic__totalCFAAmountStreamedUntilUpdatedAt";
    TokenStatisticLog_OrderBy["TokenStatistic__totalCFADeposit"] = "tokenStatistic__totalCFADeposit";
    TokenStatisticLog_OrderBy["TokenStatistic__totalCFANumberOfActiveStreams"] = "tokenStatistic__totalCFANumberOfActiveStreams";
    TokenStatisticLog_OrderBy["TokenStatistic__totalCFANumberOfClosedStreams"] = "tokenStatistic__totalCFANumberOfClosedStreams";
    TokenStatisticLog_OrderBy["TokenStatistic__totalCFAOutflowRate"] = "tokenStatistic__totalCFAOutflowRate";
    TokenStatisticLog_OrderBy["TokenStatistic__totalConnectedMemberships"] = "tokenStatistic__totalConnectedMemberships";
    TokenStatisticLog_OrderBy["TokenStatistic__totalDeposit"] = "tokenStatistic__totalDeposit";
    TokenStatisticLog_OrderBy["TokenStatistic__totalGDAAmountStreamedUntilUpdatedAt"] = "tokenStatistic__totalGDAAmountStreamedUntilUpdatedAt";
    TokenStatisticLog_OrderBy["TokenStatistic__totalGDADeposit"] = "tokenStatistic__totalGDADeposit";
    TokenStatisticLog_OrderBy["TokenStatistic__totalGDANumberOfActiveStreams"] = "tokenStatistic__totalGDANumberOfActiveStreams";
    TokenStatisticLog_OrderBy["TokenStatistic__totalGDANumberOfClosedStreams"] = "tokenStatistic__totalGDANumberOfClosedStreams";
    TokenStatisticLog_OrderBy["TokenStatistic__totalGDAOutflowRate"] = "tokenStatistic__totalGDAOutflowRate";
    TokenStatisticLog_OrderBy["TokenStatistic__totalMembershipsWithUnits"] = "tokenStatistic__totalMembershipsWithUnits";
    TokenStatisticLog_OrderBy["TokenStatistic__totalNumberOfAccounts"] = "tokenStatistic__totalNumberOfAccounts";
    TokenStatisticLog_OrderBy["TokenStatistic__totalNumberOfActiveIndexes"] = "tokenStatistic__totalNumberOfActiveIndexes";
    TokenStatisticLog_OrderBy["TokenStatistic__totalNumberOfActivePools"] = "tokenStatistic__totalNumberOfActivePools";
    TokenStatisticLog_OrderBy["TokenStatistic__totalNumberOfActiveStreams"] = "tokenStatistic__totalNumberOfActiveStreams";
    TokenStatisticLog_OrderBy["TokenStatistic__totalNumberOfClosedStreams"] = "tokenStatistic__totalNumberOfClosedStreams";
    TokenStatisticLog_OrderBy["TokenStatistic__totalNumberOfHolders"] = "tokenStatistic__totalNumberOfHolders";
    TokenStatisticLog_OrderBy["TokenStatistic__totalNumberOfIndexes"] = "tokenStatistic__totalNumberOfIndexes";
    TokenStatisticLog_OrderBy["TokenStatistic__totalNumberOfPools"] = "tokenStatistic__totalNumberOfPools";
    TokenStatisticLog_OrderBy["TokenStatistic__totalOutflowRate"] = "tokenStatistic__totalOutflowRate";
    TokenStatisticLog_OrderBy["TokenStatistic__totalSubscriptionsWithUnits"] = "tokenStatistic__totalSubscriptionsWithUnits";
    TokenStatisticLog_OrderBy["TokenStatistic__totalSupply"] = "tokenStatistic__totalSupply";
    TokenStatisticLog_OrderBy["TokenStatistic__updatedAtBlockNumber"] = "tokenStatistic__updatedAtBlockNumber";
    TokenStatisticLog_OrderBy["TokenStatistic__updatedAtTimestamp"] = "tokenStatistic__updatedAtTimestamp";
    TokenStatisticLog_OrderBy["Token__createdAtBlockNumber"] = "token__createdAtBlockNumber";
    TokenStatisticLog_OrderBy["Token__createdAtTimestamp"] = "token__createdAtTimestamp";
    TokenStatisticLog_OrderBy["Token__decimals"] = "token__decimals";
    TokenStatisticLog_OrderBy["Token__id"] = "token__id";
    TokenStatisticLog_OrderBy["Token__isListed"] = "token__isListed";
    TokenStatisticLog_OrderBy["Token__isNativeAssetSuperToken"] = "token__isNativeAssetSuperToken";
    TokenStatisticLog_OrderBy["Token__isSuperToken"] = "token__isSuperToken";
    TokenStatisticLog_OrderBy["Token__name"] = "token__name";
    TokenStatisticLog_OrderBy["Token__symbol"] = "token__symbol";
    TokenStatisticLog_OrderBy["Token__underlyingAddress"] = "token__underlyingAddress";
    TokenStatisticLog_OrderBy["TotalAmountDistributed"] = "totalAmountDistributed";
    TokenStatisticLog_OrderBy["TotalAmountStreamed"] = "totalAmountStreamed";
    TokenStatisticLog_OrderBy["TotalAmountTransferred"] = "totalAmountTransferred";
    TokenStatisticLog_OrderBy["TotalApprovedSubscriptions"] = "totalApprovedSubscriptions";
    TokenStatisticLog_OrderBy["TotalCFAAmountStreamed"] = "totalCFAAmountStreamed";
    TokenStatisticLog_OrderBy["TotalCFADeposit"] = "totalCFADeposit";
    TokenStatisticLog_OrderBy["TotalCFANumberOfActiveStreams"] = "totalCFANumberOfActiveStreams";
    TokenStatisticLog_OrderBy["TotalCFANumberOfClosedStreams"] = "totalCFANumberOfClosedStreams";
    TokenStatisticLog_OrderBy["TotalCFAOutflowRate"] = "totalCFAOutflowRate";
    TokenStatisticLog_OrderBy["TotalConnectedMemberships"] = "totalConnectedMemberships";
    TokenStatisticLog_OrderBy["TotalDeposit"] = "totalDeposit";
    TokenStatisticLog_OrderBy["TotalGDAAmountStreamed"] = "totalGDAAmountStreamed";
    TokenStatisticLog_OrderBy["TotalGDADeposit"] = "totalGDADeposit";
    TokenStatisticLog_OrderBy["TotalGDANumberOfActiveStreams"] = "totalGDANumberOfActiveStreams";
    TokenStatisticLog_OrderBy["TotalGDANumberOfClosedStreams"] = "totalGDANumberOfClosedStreams";
    TokenStatisticLog_OrderBy["TotalGDAOutflowRate"] = "totalGDAOutflowRate";
    TokenStatisticLog_OrderBy["TotalMembershipsWithUnits"] = "totalMembershipsWithUnits";
    TokenStatisticLog_OrderBy["TotalNumberOfAccounts"] = "totalNumberOfAccounts";
    TokenStatisticLog_OrderBy["TotalNumberOfActiveIndexes"] = "totalNumberOfActiveIndexes";
    TokenStatisticLog_OrderBy["TotalNumberOfActivePools"] = "totalNumberOfActivePools";
    TokenStatisticLog_OrderBy["TotalNumberOfActiveStreams"] = "totalNumberOfActiveStreams";
    TokenStatisticLog_OrderBy["TotalNumberOfClosedStreams"] = "totalNumberOfClosedStreams";
    TokenStatisticLog_OrderBy["TotalNumberOfHolders"] = "totalNumberOfHolders";
    TokenStatisticLog_OrderBy["TotalNumberOfIndexes"] = "totalNumberOfIndexes";
    TokenStatisticLog_OrderBy["TotalNumberOfPools"] = "totalNumberOfPools";
    TokenStatisticLog_OrderBy["TotalOutflowRate"] = "totalOutflowRate";
    TokenStatisticLog_OrderBy["TotalSubscriptionsWithUnits"] = "totalSubscriptionsWithUnits";
    TokenStatisticLog_OrderBy["TotalSupply"] = "totalSupply";
    TokenStatisticLog_OrderBy["TransactionHash"] = "transactionHash";
    TokenStatisticLog_OrderBy["TriggeredByEventName"] = "triggeredByEventName";
})(TokenStatisticLog_OrderBy || (exports.TokenStatisticLog_OrderBy = TokenStatisticLog_OrderBy = {}));
var TokenStatistic_OrderBy;
(function (TokenStatistic_OrderBy) {
    TokenStatistic_OrderBy["Id"] = "id";
    TokenStatistic_OrderBy["Token"] = "token";
    TokenStatistic_OrderBy["TokenStatisticLogs"] = "tokenStatisticLogs";
    TokenStatistic_OrderBy["Token__createdAtBlockNumber"] = "token__createdAtBlockNumber";
    TokenStatistic_OrderBy["Token__createdAtTimestamp"] = "token__createdAtTimestamp";
    TokenStatistic_OrderBy["Token__decimals"] = "token__decimals";
    TokenStatistic_OrderBy["Token__id"] = "token__id";
    TokenStatistic_OrderBy["Token__isListed"] = "token__isListed";
    TokenStatistic_OrderBy["Token__isNativeAssetSuperToken"] = "token__isNativeAssetSuperToken";
    TokenStatistic_OrderBy["Token__isSuperToken"] = "token__isSuperToken";
    TokenStatistic_OrderBy["Token__name"] = "token__name";
    TokenStatistic_OrderBy["Token__symbol"] = "token__symbol";
    TokenStatistic_OrderBy["Token__underlyingAddress"] = "token__underlyingAddress";
    TokenStatistic_OrderBy["TotalAmountDistributedUntilUpdatedAt"] = "totalAmountDistributedUntilUpdatedAt";
    TokenStatistic_OrderBy["TotalAmountStreamedUntilUpdatedAt"] = "totalAmountStreamedUntilUpdatedAt";
    TokenStatistic_OrderBy["TotalAmountTransferredUntilUpdatedAt"] = "totalAmountTransferredUntilUpdatedAt";
    TokenStatistic_OrderBy["TotalApprovedSubscriptions"] = "totalApprovedSubscriptions";
    TokenStatistic_OrderBy["TotalCFAAmountStreamedUntilUpdatedAt"] = "totalCFAAmountStreamedUntilUpdatedAt";
    TokenStatistic_OrderBy["TotalCFADeposit"] = "totalCFADeposit";
    TokenStatistic_OrderBy["TotalCFANumberOfActiveStreams"] = "totalCFANumberOfActiveStreams";
    TokenStatistic_OrderBy["TotalCFANumberOfClosedStreams"] = "totalCFANumberOfClosedStreams";
    TokenStatistic_OrderBy["TotalCFAOutflowRate"] = "totalCFAOutflowRate";
    TokenStatistic_OrderBy["TotalConnectedMemberships"] = "totalConnectedMemberships";
    TokenStatistic_OrderBy["TotalDeposit"] = "totalDeposit";
    TokenStatistic_OrderBy["TotalGDAAmountStreamedUntilUpdatedAt"] = "totalGDAAmountStreamedUntilUpdatedAt";
    TokenStatistic_OrderBy["TotalGDADeposit"] = "totalGDADeposit";
    TokenStatistic_OrderBy["TotalGDANumberOfActiveStreams"] = "totalGDANumberOfActiveStreams";
    TokenStatistic_OrderBy["TotalGDANumberOfClosedStreams"] = "totalGDANumberOfClosedStreams";
    TokenStatistic_OrderBy["TotalGDAOutflowRate"] = "totalGDAOutflowRate";
    TokenStatistic_OrderBy["TotalMembershipsWithUnits"] = "totalMembershipsWithUnits";
    TokenStatistic_OrderBy["TotalNumberOfAccounts"] = "totalNumberOfAccounts";
    TokenStatistic_OrderBy["TotalNumberOfActiveIndexes"] = "totalNumberOfActiveIndexes";
    TokenStatistic_OrderBy["TotalNumberOfActivePools"] = "totalNumberOfActivePools";
    TokenStatistic_OrderBy["TotalNumberOfActiveStreams"] = "totalNumberOfActiveStreams";
    TokenStatistic_OrderBy["TotalNumberOfClosedStreams"] = "totalNumberOfClosedStreams";
    TokenStatistic_OrderBy["TotalNumberOfHolders"] = "totalNumberOfHolders";
    TokenStatistic_OrderBy["TotalNumberOfIndexes"] = "totalNumberOfIndexes";
    TokenStatistic_OrderBy["TotalNumberOfPools"] = "totalNumberOfPools";
    TokenStatistic_OrderBy["TotalOutflowRate"] = "totalOutflowRate";
    TokenStatistic_OrderBy["TotalSubscriptionsWithUnits"] = "totalSubscriptionsWithUnits";
    TokenStatistic_OrderBy["TotalSupply"] = "totalSupply";
    TokenStatistic_OrderBy["UpdatedAtBlockNumber"] = "updatedAtBlockNumber";
    TokenStatistic_OrderBy["UpdatedAtTimestamp"] = "updatedAtTimestamp";
})(TokenStatistic_OrderBy || (exports.TokenStatistic_OrderBy = TokenStatistic_OrderBy = {}));
var TokenUpgradedEvent_OrderBy;
(function (TokenUpgradedEvent_OrderBy) {
    TokenUpgradedEvent_OrderBy["Account"] = "account";
    TokenUpgradedEvent_OrderBy["Account__createdAtBlockNumber"] = "account__createdAtBlockNumber";
    TokenUpgradedEvent_OrderBy["Account__createdAtTimestamp"] = "account__createdAtTimestamp";
    TokenUpgradedEvent_OrderBy["Account__id"] = "account__id";
    TokenUpgradedEvent_OrderBy["Account__isSuperApp"] = "account__isSuperApp";
    TokenUpgradedEvent_OrderBy["Account__updatedAtBlockNumber"] = "account__updatedAtBlockNumber";
    TokenUpgradedEvent_OrderBy["Account__updatedAtTimestamp"] = "account__updatedAtTimestamp";
    TokenUpgradedEvent_OrderBy["Addresses"] = "addresses";
    TokenUpgradedEvent_OrderBy["Amount"] = "amount";
    TokenUpgradedEvent_OrderBy["BlockNumber"] = "blockNumber";
    TokenUpgradedEvent_OrderBy["GasPrice"] = "gasPrice";
    TokenUpgradedEvent_OrderBy["GasUsed"] = "gasUsed";
    TokenUpgradedEvent_OrderBy["Id"] = "id";
    TokenUpgradedEvent_OrderBy["LogIndex"] = "logIndex";
    TokenUpgradedEvent_OrderBy["Name"] = "name";
    TokenUpgradedEvent_OrderBy["Order"] = "order";
    TokenUpgradedEvent_OrderBy["Timestamp"] = "timestamp";
    TokenUpgradedEvent_OrderBy["Token"] = "token";
    TokenUpgradedEvent_OrderBy["TransactionHash"] = "transactionHash";
})(TokenUpgradedEvent_OrderBy || (exports.TokenUpgradedEvent_OrderBy = TokenUpgradedEvent_OrderBy = {}));
var Token_OrderBy;
(function (Token_OrderBy) {
    Token_OrderBy["CreatedAtBlockNumber"] = "createdAtBlockNumber";
    Token_OrderBy["CreatedAtTimestamp"] = "createdAtTimestamp";
    Token_OrderBy["Decimals"] = "decimals";
    Token_OrderBy["GovernanceConfig"] = "governanceConfig";
    Token_OrderBy["GovernanceConfig__createdAtBlockNumber"] = "governanceConfig__createdAtBlockNumber";
    Token_OrderBy["GovernanceConfig__createdAtTimestamp"] = "governanceConfig__createdAtTimestamp";
    Token_OrderBy["GovernanceConfig__id"] = "governanceConfig__id";
    Token_OrderBy["GovernanceConfig__isDefault"] = "governanceConfig__isDefault";
    Token_OrderBy["GovernanceConfig__liquidationPeriod"] = "governanceConfig__liquidationPeriod";
    Token_OrderBy["GovernanceConfig__minimumDeposit"] = "governanceConfig__minimumDeposit";
    Token_OrderBy["GovernanceConfig__patricianPeriod"] = "governanceConfig__patricianPeriod";
    Token_OrderBy["GovernanceConfig__rewardAddress"] = "governanceConfig__rewardAddress";
    Token_OrderBy["GovernanceConfig__updatedAtBlockNumber"] = "governanceConfig__updatedAtBlockNumber";
    Token_OrderBy["GovernanceConfig__updatedAtTimestamp"] = "governanceConfig__updatedAtTimestamp";
    Token_OrderBy["Id"] = "id";
    Token_OrderBy["IsListed"] = "isListed";
    Token_OrderBy["IsNativeAssetSuperToken"] = "isNativeAssetSuperToken";
    Token_OrderBy["IsSuperToken"] = "isSuperToken";
    Token_OrderBy["Name"] = "name";
    Token_OrderBy["Symbol"] = "symbol";
    Token_OrderBy["UnderlyingAddress"] = "underlyingAddress";
    Token_OrderBy["UnderlyingToken"] = "underlyingToken";
    Token_OrderBy["UnderlyingToken__createdAtBlockNumber"] = "underlyingToken__createdAtBlockNumber";
    Token_OrderBy["UnderlyingToken__createdAtTimestamp"] = "underlyingToken__createdAtTimestamp";
    Token_OrderBy["UnderlyingToken__decimals"] = "underlyingToken__decimals";
    Token_OrderBy["UnderlyingToken__id"] = "underlyingToken__id";
    Token_OrderBy["UnderlyingToken__isListed"] = "underlyingToken__isListed";
    Token_OrderBy["UnderlyingToken__isNativeAssetSuperToken"] = "underlyingToken__isNativeAssetSuperToken";
    Token_OrderBy["UnderlyingToken__isSuperToken"] = "underlyingToken__isSuperToken";
    Token_OrderBy["UnderlyingToken__name"] = "underlyingToken__name";
    Token_OrderBy["UnderlyingToken__symbol"] = "underlyingToken__symbol";
    Token_OrderBy["UnderlyingToken__underlyingAddress"] = "underlyingToken__underlyingAddress";
})(Token_OrderBy || (exports.Token_OrderBy = Token_OrderBy = {}));
var TransferEvent_OrderBy;
(function (TransferEvent_OrderBy) {
    TransferEvent_OrderBy["Addresses"] = "addresses";
    TransferEvent_OrderBy["BlockNumber"] = "blockNumber";
    TransferEvent_OrderBy["From"] = "from";
    TransferEvent_OrderBy["From__createdAtBlockNumber"] = "from__createdAtBlockNumber";
    TransferEvent_OrderBy["From__createdAtTimestamp"] = "from__createdAtTimestamp";
    TransferEvent_OrderBy["From__id"] = "from__id";
    TransferEvent_OrderBy["From__isSuperApp"] = "from__isSuperApp";
    TransferEvent_OrderBy["From__updatedAtBlockNumber"] = "from__updatedAtBlockNumber";
    TransferEvent_OrderBy["From__updatedAtTimestamp"] = "from__updatedAtTimestamp";
    TransferEvent_OrderBy["GasPrice"] = "gasPrice";
    TransferEvent_OrderBy["GasUsed"] = "gasUsed";
    TransferEvent_OrderBy["Id"] = "id";
    TransferEvent_OrderBy["IsNFTTransfer"] = "isNFTTransfer";
    TransferEvent_OrderBy["LogIndex"] = "logIndex";
    TransferEvent_OrderBy["Name"] = "name";
    TransferEvent_OrderBy["Order"] = "order";
    TransferEvent_OrderBy["Timestamp"] = "timestamp";
    TransferEvent_OrderBy["To"] = "to";
    TransferEvent_OrderBy["To__createdAtBlockNumber"] = "to__createdAtBlockNumber";
    TransferEvent_OrderBy["To__createdAtTimestamp"] = "to__createdAtTimestamp";
    TransferEvent_OrderBy["To__id"] = "to__id";
    TransferEvent_OrderBy["To__isSuperApp"] = "to__isSuperApp";
    TransferEvent_OrderBy["To__updatedAtBlockNumber"] = "to__updatedAtBlockNumber";
    TransferEvent_OrderBy["To__updatedAtTimestamp"] = "to__updatedAtTimestamp";
    TransferEvent_OrderBy["Token"] = "token";
    TransferEvent_OrderBy["TransactionHash"] = "transactionHash";
    TransferEvent_OrderBy["Value"] = "value";
})(TransferEvent_OrderBy || (exports.TransferEvent_OrderBy = TransferEvent_OrderBy = {}));
var TrustedForwarderChangedEvent_OrderBy;
(function (TrustedForwarderChangedEvent_OrderBy) {
    TrustedForwarderChangedEvent_OrderBy["Addresses"] = "addresses";
    TrustedForwarderChangedEvent_OrderBy["BlockNumber"] = "blockNumber";
    TrustedForwarderChangedEvent_OrderBy["Enabled"] = "enabled";
    TrustedForwarderChangedEvent_OrderBy["Forwarder"] = "forwarder";
    TrustedForwarderChangedEvent_OrderBy["GasPrice"] = "gasPrice";
    TrustedForwarderChangedEvent_OrderBy["GasUsed"] = "gasUsed";
    TrustedForwarderChangedEvent_OrderBy["GovernanceAddress"] = "governanceAddress";
    TrustedForwarderChangedEvent_OrderBy["Host"] = "host";
    TrustedForwarderChangedEvent_OrderBy["Id"] = "id";
    TrustedForwarderChangedEvent_OrderBy["IsKeySet"] = "isKeySet";
    TrustedForwarderChangedEvent_OrderBy["LogIndex"] = "logIndex";
    TrustedForwarderChangedEvent_OrderBy["Name"] = "name";
    TrustedForwarderChangedEvent_OrderBy["Order"] = "order";
    TrustedForwarderChangedEvent_OrderBy["SuperToken"] = "superToken";
    TrustedForwarderChangedEvent_OrderBy["Timestamp"] = "timestamp";
    TrustedForwarderChangedEvent_OrderBy["TransactionHash"] = "transactionHash";
})(TrustedForwarderChangedEvent_OrderBy || (exports.TrustedForwarderChangedEvent_OrderBy = TrustedForwarderChangedEvent_OrderBy = {}));
var _SubgraphErrorPolicy_;
(function (_SubgraphErrorPolicy_) {
    /** Data will be returned even if the subgraph has indexing errors */
    _SubgraphErrorPolicy_["Allow"] = "allow";
    /** If the subgraph has indexing errors, data will be omitted. The default. */
    _SubgraphErrorPolicy_["Deny"] = "deny";
})(_SubgraphErrorPolicy_ || (exports._SubgraphErrorPolicy_ = _SubgraphErrorPolicy_ = {}));
exports.EventFragmentFragmentDoc = (0, graphql_tag_1.default) `
    fragment EventFragment on FlowUpdatedEvent {
  transactionHash
  blockNumber
  timestamp
  sender
  flowRate
  oldFlowRate
  type
}
    `;
exports.PaymentFragmentFragmentDoc = (0, graphql_tag_1.default) `
    fragment PaymentFragment on SentEvent {
  transactionHash
  blockNumber
  timestamp
  from
  amount
}
    `;
exports.GetSuperFluidEventsDocument = (0, graphql_tag_1.default) `
    query GetSuperFluidEvents($tokenAddress: Bytes!, $to: Bytes!, $reference: Bytes!) {
  untagged: flowUpdatedEvents(
    orderBy: timestamp
    where: {flowRate: "0", userData: "0x", type: 2, token: $tokenAddress, receiver: $to}
  ) {
    ...EventFragment
  }
  flow: flowUpdatedEvents(
    orderBy: timestamp
    where: {userData: $reference, token: $tokenAddress, receiver: $to}
  ) {
    ...EventFragment
  }
  payment: sentEvents(
    orderBy: timestamp
    where: {data: $reference, token: $tokenAddress, to: $to}
  ) {
    ...PaymentFragment
  }
}
    ${exports.EventFragmentFragmentDoc}
${exports.PaymentFragmentFragmentDoc}`;
const defaultWrapper = (action, _operationName, _operationType) => action();
function getSdk(client, withWrapper = defaultWrapper) {
    return {
        GetSuperFluidEvents(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetSuperFluidEventsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'GetSuperFluidEvents', 'query');
        }
    };
}
exports.getSdk = getSdk;
exports.EventFragment = (0, graphql_tag_1.default) `
    fragment EventFragment on FlowUpdatedEvent {
  transactionHash
  blockNumber
  timestamp
  sender
  flowRate
  oldFlowRate
  type
}
    `;
exports.PaymentFragment = (0, graphql_tag_1.default) `
    fragment PaymentFragment on SentEvent {
  transactionHash
  blockNumber
  timestamp
  from
  amount
}
    `;
exports.GetSuperFluidEvents = (0, graphql_tag_1.default) `
    query GetSuperFluidEvents($tokenAddress: Bytes!, $to: Bytes!, $reference: Bytes!) {
  untagged: flowUpdatedEvents(
    orderBy: timestamp
    where: {flowRate: "0", userData: "0x", type: 2, token: $tokenAddress, receiver: $to}
  ) {
    ...EventFragment
  }
  flow: flowUpdatedEvents(
    orderBy: timestamp
    where: {userData: $reference, token: $tokenAddress, receiver: $to}
  ) {
    ...EventFragment
  }
  payment: sentEvents(
    orderBy: timestamp
    where: {data: $reference, token: $tokenAddress, to: $to}
  ) {
    ...PaymentFragment
  }
}
    ${exports.EventFragment}
${exports.PaymentFragment}`;
